import { DatePipe } from '@angular/common';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FilterUtils } from 'primeng/components/utils/filterutils';
import 'rxjs/operator/map';
import { CommonSerivce } from '../shared/services/common.service';
import { UserService } from '../shared/services/user.service';
import { ConfirmationService } from 'primeng/api';
import { jsPDF } from "jspdf";
//import * as jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { Observable } from 'rxjs/Observable';
//import 'jspdf-autotable';
//import jsPDF from 'jspdf';
//import 'jspdf-autotable';
import 'rxjs/Rx';
import { Dropdown, DropdownModule } from 'primeng/dropdown';
import * as XLSX from "xlsx-js-style";
import { Router } from '@angular/router';
import { IDialogApprovalAction, IDialogApprovalRoute, IReturnDialogApprovalAction, IReturnDialogApprovalRoute } from '../shared/models/shared.services.interface';
import { BcpApprovalRouteService } from '../shared/services/approvalRoute/bcpApprovalRoute.service';
import { BcpApprovalActionService } from '../shared/services/approvalAction/bcpApprovalAction.service';



@Component({
  selector: 'etsTender',
  styleUrls: ['../shared/share.component.css'
  ],
  providers: [CommonSerivce, UserService, DatePipe, ConfirmationService],
  templateUrl: './etsTender.component.html'
})


export class TenderComponent implements OnInit {

  /*
      RecordList - Search result list
      SelectedRecordList - User selected record (Multiple) in the result table
      SelectedRecord - User selected record (Single) for edition
  */
  public RecordList: ITender[];
  public SelectedRecordList: ITender[];
  public SelectedRecord: ITender;

  public SelectedLockRecord: ITenderLock;

  public PriceRecordList: ITenderPrice[];
  public SelectedPriceRecordList: ITenderPrice[];
  public SelectedPriceRecord: ITenderPrice;

  public InvitationRecordList: ITenderInvitation[];
  public SelectedInvitationRecordList: ITenderInvitation[];
  public SelectedInvitationRecord: ITenderInvitation;

  public SpecificationRecordList: ITenderDocument[];
  public SelectedSpecificationRecordList: ITenderDocument[];
  public SelectedSpecificationRecord: ITenderDocument;

  public DocumentRecordList: ITenderDocument[];
  public SelectedDocumentRecordList: ITenderDocument[];
  public SelectedDocumentRecord: ITenderDocument;

  public MessageRecordList: ITenderMessage[];
  public SelectedMessageRecordList: ITenderMessage[];
  public SelectedMessageRecord: ITenderMessage;
  public EnteredMessageRecord: ITenderMessage;

  public ResponseDocRecordList: ITenderDocument[];
  public SelectedResponseDocRecordList: ITenderDocument[];
  public SelectedResponseDocRecord: ITenderDocument;

  public AwardPriceRecordList: ITenderPrice[];
  public SelectedAwardPriceRecordList: ITenderPrice[];
  public SelectedAwardPriceRecord: ITenderPrice;

  public LogRecordList: ITenderLog[];
  public SelectedLogRecordList: ITenderLog[];
  public SelectedLogRecord: ITenderLog;

  public CompanyDataSet: ICompanyData;
  public GenNextNumberFieldHolder: IGenNextNumber;
  public NextNumberOutput: INextNumber;
  public UserNameDataSet: IUserName;

  public InputErrorMsg: Message[] = [];

  //  Hold the value of the user inputted search field, to be used for searching
  public SearchFieldHolder: any;
  public SearchDnFieldHolder: any;
  public tenderCols: any;
  public priceCols: any;
  public invitationCols: any;
  public specificationCols: any;
  public documentCols: any;
  public projectCols: any;
  public messageCols: any;
  public exportColumns: any;
  public pdfColumns = [];
  public attachmentCols: any;
  public responseDocCols: any;
  public awardPriceCols: any;
  public logCols: any;


  //  Code value list for List Box, add required code value list
  public DomainList: IListValue[];
  public DataRoleList: IDataRole[];
  public ProcessRoleList: IProcessRole[];
  public ActiveFlagList: IListValue[];
  public YesNoList: IListValue[];
  public AttachmentList: IAttachmentValue[];
  public MessageNewAttachmentList: IAttachmentValue[];
  public MessageReviewAttachmentList: IAttachmentValue[];
  public CompanyListD: IListValue[];
  public CompanyListE: IListValue[];
  public CompanyListInvited: IListValue[];
  public CompanyListInvitedOnly: IListValue[];
  public CompanyListResponsed: IListValue[];
  public TenderCategoryList: IListValue[];
  public TenderPropertyList: IListValue[];
  public BusinessUnitList: IListValue[];
  public DocumentCategoryList: IListValue[];

  public loggedInType: string = "";
  public loggedInCompanyCode: string = "";
  public loggedInUser: string = "";

  public currentVertificationKey: string = "";
  public currentRegisterFlag: string = "";
  public currentInviteFlag: string = "";
  public currentTempCompany: string = "";
  public currentCompanyStatus: string = "";

  public globalFilterValue1: string = "";
  public globalFilterValue2: string = "";
  public globalFilterValue3: string = "";
  public globalFilterValue4: string = "";
  public globalFilterValue5: string = "";
  public globalFilterValue6: string = "";
  public globalFilterValue7: string = "";

  public resultMsgs: Message[] = [];

  /*
      action code security
  */
  public allowAdd: string = "N";
  public allowPriceReview: string = "N";
  public allowAward: string = "N";
  public allowPurge: string = "N";
  public emailInviteContractor: boolean = false;
  public emailSubmitResponse: boolean = false;
  public emailSendMessage: boolean = false;
  public emailAwardTender: boolean = false;

 
  /*
      sort0 - define the sorting sequence for the table field (1 asc, 0 desc)
      softF - define the sorting field name
  */
  sortO: number = 0;
  sortF: string = '';


  /*
      Major control variables
          FormTitle - Initial Form Title for the landing form
          PrimaryApiPath - Path for the API controller per component 
          ShowEditForm/ ShowAddForm - control whether to show Inquiry or Edit form
          AutoReload - control auto reload component
          
  */
  FormTitle: String = "Work With Tenders";
  FormAccessRight: String = "NA";
  PrimaryApiPath: string = "api/EtsTender/";
  LockApiPath: string = "api/BcpLock/";
  PriceApiPath: string = "api/EtsPrice/";
  InvitationApiPath: string = "api/EtsInvitation/";
  DocumentApiPath: string = "api/EtsDocument/";
  MessageApiPath: string = "api/EtsMessage/";
  LogApiPath: string = "api/EtsLog/";
  CompanyApiPath: string = "api/BcpCompany/";
  ContactApiPath: string = "api/BcpContact/";
  ListValueApiPath: string = "api/BcpListValue/";
  AuthApiPath: string = "api/BcpJwtAuth/getDistinguishedName/";
  TableSequenceApiPath: string = "api/BcpTableSequence/";
  ProjectApiPath: string = "api/EtsProject/";
  SendEmailPath: string = "api/BcpEmailService/";
  SecurityApiPath: string = "api/BcpUserSecurityAction/";
  ReportApiPath: string = "api/EtsReport/";
  AttachmentApiPathLocal: string = "api/BcpAttachment/";
  AttachmentApiPathAzure: string = "api/BcpAzureAttachment/";
  AttachmentApiPath: string = " ";


  ShowAddForm: Boolean = false;
  ShowEditForm: Boolean = false;
  ShowNotAuthorizedForm: Boolean = false;
  ShowSubmissionForm: Boolean = false;
  SuccessUpload: Boolean = false;
  AddMode: string = "N";
  checkedError: string = "";
  HideMessage: Boolean = true;
  RecordLocked: Boolean = false;
  OverDeadline: Boolean = false;
  fullUploadDoc: Boolean = false;
  NewMessageFlag: Boolean = false;

  AutoReload: Boolean = true;
  AttachmentAutoReload: Boolean = true;
  MessageNewAttachmentAutoReload: Boolean = false;
  MessageReviewAttachmentAutoReload: Boolean = true;
  newLinePendingCD: Boolean = false;
  newLinePendingCT: Boolean = true;
  newLinePendingTI: Boolean = true;
  numberOfPriceLine: number = 0;

  scrollHeight: string = "";
  scrollWidth: string = "";

  httpOriginalUrl: String;
  stringifyValue = "";
  stringifyUploadValue = "";
  Headers = new HttpHeaders();
  isLoggedIn: boolean = false;
  dateFormat: String = "yy-mm-dd";
  minimumDate = new Date();

  //Attachment related
  public record: any;
  uploadFile: File;

  specificationLineNumber: number = 0;
  documentLineNumber: number = 0;
  responseDocLineNumber: number = 0;
  newTenderRecordId: any;
  newDocumentRecordId: any;
  inputDocumentCompany: string = "";
  inputMessageCompany: string = "";
  inputPriceCompany: string = "";
  inputLogCompany: string = "";
  inputSendAllCompany: boolean = false;
  inputTenderDocumentName: string = "";
  inputRemark: string = "";
  inputNewTenderDocumentName: string = "";
  inputNewDocumentRemark: string = "";
  currentTimestamp: any = new Date();
  public CopyTenderFieldHolder: ICopyTender;
  public UpdateTenderPriceFieldHolder: IUpdateTender;
  public AwardTenderFieldHolder: IAwardTender;
  public WriteLogFieldHolder: IWriteLog;
  public WriteDocLogFieldHolder: IWriteDocLog;
  public WithdrawTenderFieldHolder: IWithdrawTender;
  public DeclineLetterData: IDeclineLetter;
  public CopyAttachmentFieldHolder: ICopyAttachment;
  public ConvertProjectFieldHolder: IConvertProject;
  public CompanyStatus: ICompanyStatus;
  public ReportFieldHolder: IPriceSummary;
  public emailReturnStatus: boolean = false;
  public tenderProcessEmail: ITenderProcessEmail;
  public GenPriceSummary: IGenPriceSummary;
  expressInterestText: string = "";
  submissionDoneText: string = "The Tender Response has been submitted successfully";
  awardDoneText: string = "The Tender has been awarded successfully";
  priceInputText: string = "";
  //responseCycle: number = 0;
  public RecordCount: number = 0;
  displayTotalAmount: string = "";
  savedTotalAmount: string = "";
  enteredTotalAmount: number = 0;
  Accept1: Boolean = false;
  Accept2: Boolean = false;
  seeAllCompanyMessage: Boolean = false;
  public index: number = 0;
  displayResponseUser: string = "";
  displayResponseDate: string = "";
  currentUserNameLong: string = "";
  currentUserName: string = "";
  currentUserEmail: string = "";
  currentUserPhone: string = "";
   
  //excel variable
  strLine: string;
  excelRow: string[] = [];
  SheetNames = [];
  Sheets = {};
  cellList: string[];
  lastRowNumber: number;
  currentProcessRow: number = -1;
  currentProcessColumn: number = -1;
  rangeFromColumn: number = -1;
  rangeFromRow: number = -1;
  rangeToColumn: number = -1;
  rangeToRow: number = -1;
  delimiter: string = "|";
  //excel variable - End

  processingFlag: string = "N";
  processingReport: string = "";
  listLength1: number = 0;
  listLength2: number = 0;
  listLength3: number = 0;
  listLength4: number = 0;


  //Import Excel File Parameters
  arrayBuffer: any;
  importFile: File;
  importData;

  //For display Edit and Delete Images
  //public imgEdit = require("../shared/Images/edit.gif");
  //public imgDelete = require("../shared/Images/delete.gif");

  //for animation status
  //animStatus: string = 'inactive';




  constructor(private http: HttpClient, @Inject('BASE_URL') originUrl: string
    , private bcp: CommonSerivce
    , private datePipe: DatePipe
    , private confirmationService: ConfirmationService
    , private bcpApprovalRoute: BcpApprovalRouteService
    , private bcpApprovalAction: BcpApprovalActionService
    , private _router: Router  ) {
    //  this.httpHeaders = this.bcp.getHttpHeader();
    this.PrimaryApiPath = originUrl + this.PrimaryApiPath;
    this.LockApiPath = originUrl + this.LockApiPath;
    this.PriceApiPath = originUrl + this.PriceApiPath;
    this.InvitationApiPath = originUrl + this.InvitationApiPath;
    this.DocumentApiPath = originUrl + this.DocumentApiPath;
    this.MessageApiPath = originUrl + this.MessageApiPath;
    this.LogApiPath = originUrl + this.LogApiPath;
    this.CompanyApiPath = originUrl + this.CompanyApiPath;
    this.ContactApiPath = originUrl + this.ContactApiPath;
    this.ListValueApiPath = originUrl + this.ListValueApiPath;
    this.TableSequenceApiPath = originUrl + this.TableSequenceApiPath;
    this.ProjectApiPath = originUrl + this.ProjectApiPath;
    this.SendEmailPath = originUrl + this.SendEmailPath;
    this.SecurityApiPath = originUrl + this.SecurityApiPath;
    this.ReportApiPath = originUrl + this.ReportApiPath;

    this.FormAccessRight = this.bcp.getAccessRightByProcess('ETSTENDER');
    this.isLoggedIn = this.bcp.getLoginStatus();

    this.loggedInType = this.bcp.getCurrentUserAccountType();
    this.loggedInCompanyCode = this.bcp.getCurrentCompanyCode();
    this.loggedInUser = this.bcp.getCurrentLoginUser();

    this.AttachmentApiPath = this.AttachmentApiPathLocal;
    if (this.bcp.getAttachmentTarget() == "AZURE") {
      this.AttachmentApiPath = this.AttachmentApiPathAzure;
    }  

    //get action security controls
    this.getSecurity();
    this.currentTimestamp = this.bcp.getCurrentDateTime();
    this.getUserNameLong(this.bcp.getCurrentDomainId(), this.bcp.getCurrentLoginUser());

    this.resetSearchField();
    this.FormTitle = "Work With Tenders";
    this.ShowAddForm = false;
    this.ShowEditForm = false;

    this.getFirstPage();

    //get all list value for drop down list
    this.getListValue();
    //this.getListValueByDomain();
    this.getDomainList();

    //this.getData();
    this.initMessageRecord();

    this.scrollHeight = this.bcp.getDataTableHeight(4);
    this.scrollWidth = this.bcp.getDataTableWidth();

    this.SelectedRecord = null;
    this.SelectedLockRecord = null;
    this.SelectedPriceRecord = null;
    this.InputErrorMsg = [];

    this.tenderCols = [
      { field: 'actions', header: 'Actions', width: '50', size: '10' },
      { field: 'expand', width: '20', size: '5' },
      //{ field: 'id', header: 'Id', width: '10', size: '10' },
      { field: 'domainId', header: 'Domain', width: '60', size: '10' },
      { field: 'tenderId', header: 'Tender ID', width: '60', size: '10' },
      { field: 'tenderCategory', header: 'Category', width: '60', size: '10' },
      { field: 'tenderProperty', header: 'Property', width: '50', size: '10' },
      { field: 'subject', header: 'Subject', width: '140', size: '10' },
      { field: 'tenderStatus', header: 'Status', width: '50', size: '10' },
      { field: 'tenderDate02', header: 'Open Date', width: '60', size: '10' },
      { field: 'tenderDate03', header: 'Due Date', width: '60', size: '10' },
      { field: 'fullName', header: 'Contact', width: '60', size: '10' },
      { field: 'companyCode', header: 'Company Code', width: '60', size: '10' },
    ];

    this.priceCols = [
      { field: 'actions', header: 'Actions', width: '40', size: '10' },
      { field: 'part', header: 'Part', width: '30', size: '10' },
      { field: 'section', header: 'Section', width: '35', size: '10' },
      { field: 'longDescription', header: 'Description', width: '270', size: '10' },
      { field: 'quantityTendered', header: 'Qty', width: '40', size: '10' },
      //{ field: 'quantityOffered', header: 'Qty (Offered)', width: '80', size: '10' },
      { field: 'unitOfMeasure', header: 'UOM', width: '40', size: '10' },
      { field: 'optionalFlag', header: 'Optional', width: '40', size: '10' },
      { field: 'unitPrice', header: 'Unit Price', width: '65', size: '10' },
      { field: 'lineAmount', header: 'Amount (HK$)', width: '65', size: '10' },
      //{ field: 'id', header: 'Id', width: '20', size: '10' },
    ];

    this.invitationCols = [
      { field: 'invitedCompanyCode', header: 'Company Code', width: '40', size: '5' },
      { field: 'fullName', header: 'Company Name', width: '100', size: '5' },
      { field: 'companyNumber', header: 'Company Number', width: '40', size: '5' },
      //{ field: 'generationFlag', header: 'Populated', width: '40', size: '5' },
      { field: 'tenderResponseStatus', header: 'Response Status', width: '50', size: '5' },
      { field: 'contractSum', header: 'Contract Sum', width: '50', size: '5' },
      { field: 'upload', header: 'Withdraw', width: '50', size: '5' },
      { field: 'withdrawFlag', header: 'Withdrawn (Y/N)', width: '40', size: '5' },
      { field: 'displayName', header: 'Support Letter', width: '80', size: '5' },
      { field: 'actions', header: 'Actions', width: '40', size: '5' },
      //{ field: 'activeFlag', header: 'Active (Y/N)', width: '50', size: '5' },
      //{ field: 'id', header: 'Id', width: '20', size: '10' },
    ];

    this.specificationCols = [
      { field: 'actions', header: 'Actions', width: '30', size: '10' },
      { field: 'lineId', header: 'Line No', width: '30', size: '10' },
      { field: 'tenderDocumentName', header: 'Document Name', width: '80', size: '10' },
      //{ field: 'upload', header: 'Upload', width: '50', size: '10' },
      { field: 'displayName', header: 'File Name', width: '80', size: '10' },
      { field: 'remark', header: 'Remark', width: '150', size: '10' },
      //{ field: 'companyCode', header: 'Company Code', width: '50', size: '10' },
      //{ field: 'attachmentRecordId', header: 'A ID', width: '50', size: '10' },
      //{ field: 'id', header: 'Id', width: '20', size: '10' },
    ];

    this.documentCols = [
      { field: 'actions', header: 'Actions', width: '30', size: '10' },
      { field: 'lineId', header: 'Line No', width: '30', size: '10' },
      { field: 'tenderDocumentName', header: 'Document Name', width: '80', size: '10' },
      { field: 'displayName', header: 'File Name', width: '80', size: '10' },
      { field: 'remark', header: 'Remark', width: '150', size: '10' },
      //{ field: 'companyCode', header: 'Company Code', width: '50', size: '10' },
      //{ field: 'attachmentRecordId', header: 'A ID', width: '50', size: '10' },
      //{ field: 'id', header: 'Id', width: '20', size: '10' },
    ];

    this.projectCols = [
      { field: 'actions', header: 'Actions', width: '35', size: '10' },
      { field: 'lineId', header: 'Line No', width: '35', size: '10' },
      { field: 'documentCategory', header: 'Category', width: '80', size: '10' },
      { field: 'displayName', header: 'Document Type', width: '80', size: '10' },
      { field: 'documentNumber', header: 'File Name', width: '100', size: '10' },
      { field: 'remark', header: 'Remark', width: '100', size: '10' },
      //{ field: 'requestUploadFlag', header: 'User', width: '60', size: '10' },
      { field: 'companyCode', header: 'User', width: '60', size: '10' },
      //{ field: 'attachmentRecordId', header: 'A ID', width: '50', size: '10' },
      //{ field: 'id', header: 'Id', width: '20', size: '10' },
    ];

    this.messageCols = [
      { field: 'actions', header: 'Actions', width: '30', size: '10' },
      { field: 'createDate', header: 'Date', width: '70', size: '10' },
      { field: 'invitedCompanyCode', header: 'Company Code', width: '40', size: '10' },
      { field: 'subject', header: 'Subject', width: '120', size: '10' },
      { field: 'deadline', header: 'Deadline', width: '70', size: '10' },
      { field: 'allowReply', header: 'Allow Reply', width: '30', size: '10' },
      { field: 'replyUser', header: 'Replied By', width: '50', size: '10' },
      { field: 'replyDate', header: 'Replied Date', width: '70', size: '10' },
      { field: 'id', header: 'Id', width: '20', size: '10' }
    ];

    this.responseDocCols = [
      { field: 'upload', header: 'Upload', width: '50', size: '10' },
      { field: 'lineId', header: 'Line No', width: '30', size: '10' },
      { field: 'tenderDocumentName', header: 'Document Name', width: '80', size: '10' },
      { field: 'displayName', header: 'File Name', width: '80', size: '10' },
      { field: 'remark', header: 'Remark', width: '150', size: '10' },
      //{ field: 'requestUploadFlag', header: 'Supplier Upload', width: '40', size: '10' },
      //{ field: 'companyCode', header: 'Company', width: '50', size: '10' },
      { field: 'actions', header: 'Actions', width: '40', size: '10' },
      //{ field: 'attachmentRecordId', header: 'A ID', width: '50', size: '10' },
      //{ field: 'id', header: 'Id', width: '20', size: '10' },
    ];

    this.awardPriceCols = [
      { field: 'displaySequence', header: 'Seq', width: '10', size: '10' },
      { field: 'companyCode', header: 'Company', width: '80', size: '10' },
      { field: 'part', header: 'Part', width: '50', size: '10' },
      { field: 'section', header: 'Section', width: '40', size: '10' },
      { field: 'longDescription', header: 'Description', width: '270', size: '10' },
      { field: 'quantityTendered', header: 'Qty', width: '40', size: '10' },
      //{ field: 'quantityOffered', header: 'Qty (Offered)', width: '80', size: '10' },
      { field: 'unitOfMeasure', header: 'UOM', width: '40', size: '10' },
      { field: 'optionalFlag', header: 'Optional', width: '40', size: '10' },
      { field: 'unitPrice', header: 'Unit Price', width: '65', size: '10' },
      { field: 'lineAmount', header: 'Amount (HK$)', width: '65', size: '10' },
      //{ field: 'id', header: 'Id', width: '20', size: '10' },
    ];

    this.attachmentCols = [
      { field: 'actions', header: 'Actions', width: '40', size: '5' },
      { field: 'id', header: 'Id', width: '40', size: '5' },
      { field: 'sourceRecordId', header: 'Source Record Id', width: '60', size: '5' },
      { field: 'displayName', header: 'File Name', width: '120', size: '5' },
      { field: 'createDate', header: 'Create Date', width: '60', size: '5' },
      //{ field: 'updateUser', header: 'Update User', width: '60', size: '5' }
    ];


    this.logCols = [
      { field: 'createDate', header: 'Action Date & Time', width: '15', size: '10' },
      { field: 'description', header: 'Description', width: '80', size: '10' },
    ];

    this.exportColumns = this.priceCols.map(col => ({ title: col.header, dataKey: col.field }));


  }

  ngOnInit() {

    //console.log("on init");

    FilterUtils['custom'] = (value, filter): boolean => {
      if (filter === undefined || filter === null || filter.trim() === '') {
        return true;
      }

      if (value === undefined || value === null) {
        return false;
      }

      return parseInt(filter) > value;
    };

  }


  //-----------------------------------------------------------------------------
  //                            Fetch/ Search Data
  //-----------------------------------------------------------------------------

  //to get required code list from Web API
  getListValue() {
    //get list value  Box
    //this.http.get(this.PrimaryApiPath + "GetProcessRole", this.bcp.getHttpOptions())
    //  .subscribe((result: any[]) => {
    //    this.DataRoleList = result;
    //  });

    //this.http.get(this.PrimaryApiPath + "GetProcessRole", this.bcp.getHttpOptions())
    //  .subscribe((result: any[]) => {
    //    this.ProcessRoleList = result;
    //  });

    this.http.get(this.ListValueApiPath + "ByListCode2/" + "BCP" + "/ACTIVE_FLAG", this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        this.ActiveFlagList = result;
      });

    //build yes/no list
    this.YesNoList = [{ label: "Y - [Yes]", value: "Y" }, { label: "N - [No]", value: "N" }];

  }


  //to get required code list from Web API
  getListValueByDomain() {
    //get list value  Box
    this.http.get(this.ListValueApiPath + "ByListCode4/" + this.SelectedRecord.domainId + "/TD_CAT", this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        this.TenderCategoryList = result;
      });

    this.http.get(this.ListValueApiPath + "ByListCode2/" + this.SelectedRecord.domainId + "/TD_PPTY", this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        this.TenderPropertyList = result;
      });

    this.http.get(this.ListValueApiPath + "EtsTenderBusinessUnit/" + this.SelectedRecord.domainId + "/" + this.bcp.getCurrentDataRole() + "/BU", this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        this.BusinessUnitList = result;
      });

    this.http.get(this.ListValueApiPath + "ByListCode3/" + this.SelectedRecord.domainId + "/DOC_CAT", this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        this.DocumentCategoryList = result;
      });

    this.getCompanyListD(this.SelectedRecord.domainId, 'D');
    this.getCompanyListE(this.SelectedRecord.domainId, 'E');
  }


  getDomainList() {
    this.http.get("api/BcpDomain/DomainList", this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        this.DomainList = result;
      });
  }


  getCompanyListD(selectedDomain, selectedCompanyType) {
    this.http.get(this.CompanyApiPath + "GetCompanyListByType/" + selectedDomain + "/" + selectedCompanyType, this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        this.CompanyListD = result;
        
      });
  }


  getCompanyListE(selectedDomain, selectedCompanyType) {
    this.http.get(this.CompanyApiPath + "GetCompanyListByType/" + selectedDomain + "/" + selectedCompanyType, this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        this.CompanyListE = result;

      });
  }


  getCompanyListInvited(selectedDomain, selectedCompanyCode, selectedTenderId) {
    this.http.get(this.InvitationApiPath + "GetInvitedCompanyList/" + selectedDomain + "/" + selectedCompanyCode + "/" + selectedTenderId, this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        this.CompanyListInvitedOnly = result;
        this.CompanyListInvited = result;

        var blankRow: IListValue;
        blankRow = null;
        //blankRow = JSON.parse('{"id":0}');
        blankRow = JSON.parse('{"value":""}');
        blankRow.value = selectedCompanyCode;
        blankRow.label = selectedCompanyCode;
        //clone the whole array to a tmpArray and add new blank row
        const tmpArray = [...this.CompanyListInvited];
        tmpArray.push(blankRow);
        this.CompanyListInvited = tmpArray;
      });
  }


  getCompanyListResponsed(selectedDomain, selectedTenderId) {
    this.http.get(this.PrimaryApiPath + "GetResponedCompanyList/" + selectedDomain + "/" + selectedTenderId, this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        this.CompanyListResponsed = result;

        //var blankRow: IListValue;
        //blankRow = null;
        //blankRow = JSON.parse('{"value":""}');
        //blankRow.value = selectedTenderId;
        //blankRow.label = selectedTenderId;
        //clone the whole array to a tmpArray and add new blank row
        //const tmpArray = [...this.CompanyListResponsed];
        //tmpArray.push(blankRow);
        //this.CompanyListResponsed = tmpArray;
      });
  }


  getLabel(list: IListValue[], inputvalue: string): any {
    //console.log('Get label for input value of ' + inputvalue);
    if (list.length > 0) {
      for (var i = 0; i < list.length; i++) {
        if (list[i].value == inputvalue) {
          return list[i].label;
        }
      }
    }
  }


  async getSecurity() {
    //check for tender master creation
    let checkResult1 = await this.http.get(this.SecurityApiPath + "CheckActionSecurity/" + this.bcp.getCurrentDomainId() + "/" + this.bcp.getCurrentActionRole() + "/TDM1", this.bcp.getHttpOptions())
      .map((response: any) => JSON.parse(response.toString())).toPromise();
    if (checkResult1.allowAccess == "Y") {
      this.allowAdd = "Y";
    }
    //check for tender price review
    let checkResult2 = await this.http.get(this.SecurityApiPath + "CheckActionSecurity/" + this.bcp.getCurrentDomainId() + "/" + this.bcp.getCurrentActionRole() + "/TDP4", this.bcp.getHttpOptions())
      .map((response: any) => JSON.parse(response.toString())).toPromise();
    if (checkResult2.allowAccess == "Y") {
      this.allowPriceReview = "Y";
    }
    //check for tender award
    let checkResult3 = await this.http.get(this.SecurityApiPath + "CheckActionSecurity/" + this.bcp.getCurrentDomainId() + "/" + this.bcp.getCurrentActionRole() + "/TDM5", this.bcp.getHttpOptions())
      .map((response: any) => JSON.parse(response.toString())).toPromise();
    if (checkResult3.allowAccess == "Y") {
      this.allowAward = "Y";
    }
    //check for tender purge
    let checkResult4 = await this.http.get(this.SecurityApiPath + "CheckActionSecurity/" + this.bcp.getCurrentDomainId() + "/" + this.bcp.getCurrentActionRole() + "/TDM9", this.bcp.getHttpOptions())
      .map((response: any) => JSON.parse(response.toString())).toPromise();
    if (checkResult4.allowAccess == "Y") {
      this.allowPurge = "Y";
    }
    //check for email required for inviting contractor
    let checkResult5 = await this.http.get(this.SecurityApiPath + "CheckApplyEmail/" + this.bcp.getCurrentDomainId() + "/TDM6", this.bcp.getHttpOptions())
      .map((response: any) => JSON.parse(response.toString())).toPromise();
    if (checkResult5.applyEmail == "Y") {
      this.emailInviteContractor = true;
    }
    //check for email required for submitting response
    let checkResult6 = await this.http.get(this.SecurityApiPath + "CheckApplyEmail/" + this.bcp.getCurrentDomainId() + "/TDE5", this.bcp.getHttpOptions())
      .map((response: any) => JSON.parse(response.toString())).toPromise();
    if (checkResult6.applyEmail == "Y") {
      this.emailSubmitResponse = true;
    }
    //check for email required for sending tender query
    let checkResult7 = await this.http.get(this.SecurityApiPath + "CheckApplyEmail/" + this.bcp.getCurrentDomainId() + "/TDQ1", this.bcp.getHttpOptions())
      .map((response: any) => JSON.parse(response.toString())).toPromise();
    if (checkResult7.applyEmail == "Y") {
      this.emailSendMessage = true;
    }
    //check for email required for award tender
    let checkResult8 = await this.http.get(this.SecurityApiPath + "CheckApplyEmail/" + this.bcp.getCurrentDomainId() + "/TDM5", this.bcp.getHttpOptions())
      .map((response: any) => JSON.parse(response.toString())).toPromise();
    if (checkResult8.applyEmail == "Y") {
      this.emailAwardTender = true;
    }
  }


  //get company status fields
  async getCompanyStatus(domainId, companyCode) {
    this.CompanyStatus = await this.http.get(this.CompanyApiPath + "GetCompanyStatus/" + domainId + "/" + companyCode, this.bcp.getHttpOptions())
      .map((response: any) => response).toPromise();
    this.currentVertificationKey = this.CompanyStatus.vertificationKey;
    this.currentRegisterFlag = this.CompanyStatus.registerFlag;
    this.currentInviteFlag = this.CompanyStatus.inviteFlag;
    this.currentTempCompany = this.CompanyStatus.tempCompany;
    this.currentCompanyStatus = this.CompanyStatus.companyStatus;
  }


  //get user name data
  getUserNameLong(domainId: string, contactId: string) {
    this.currentUserNameLong = "";
    this.UserNameDataSet = null;
    this.UserNameDataSet = JSON.parse('{"id": 0}');
    this.http.get(this.ContactApiPath + "GetUserFullName/" + domainId + "/" + contactId, this.bcp.getHttpOptions())
      .subscribe((result: any) => {
        this.UserNameDataSet = result;
        this.currentUserNameLong = this.UserNameDataSet.userNameLong;
        this.currentUserName = this.UserNameDataSet.userName;
        this.currentUserEmail = this.UserNameDataSet.email1;
        this.currentUserPhone = this.UserNameDataSet.phone1;
      });
  }

  //determine what the first page should be shown
  async getFirstPage() {
    if (this.loggedInType != 'E') {
      this.getData();
    }
    else if (this.loggedInType == 'E') {
      await this.getCompanyStatus(this.bcp.getCurrentDomainId(), this.loggedInCompanyCode);
      if (this.currentCompanyStatus == "ACTIVE" || this.currentTempCompany == 'Y') {
        this.getData();
      } else {
        this.ShowNotAuthorizedForm = true;
      }
    };
  }


  getData() {
    this.AutoReload = true;
    if (this.loggedInType == 'D') {
      this.http.get(this.PrimaryApiPath + "GetByDomainCompany/" + this.bcp.getCurrentDomainId() + "/" + this.bcp.getCurrentDataRole() + "/" + this.loggedInCompanyCode, this.bcp.getHttpOptions())
        .subscribe((result: any) => {
          this.RecordList = result;
          if (this.RecordList.length > 0) {
            for (var i = 0; i < this.RecordList.length; i++) {
              if (this.RecordList[i].tenderDate02 != null) {
                this.RecordList[i].tenderDate02 = this.bcp.convertDateTimetoDate(this.RecordList[i].tenderDate02);
              }
              if (this.RecordList[i].tenderDate03 != null) {
                this.RecordList[i].tenderDate03 = this.bcp.convertDateTimetoDate(this.RecordList[i].tenderDate03);
              }
            }
          } else {
            //this.AutoReload = false;
          }
        });
    } else if (this.loggedInType == 'B') {
      this.http.get(this.PrimaryApiPath, this.bcp.getHttpOptions())
        .subscribe((result: any[]) => {
          this.RecordList = result;
          if (this.RecordList.length > 0) {
            for (var i = 0; i < this.RecordList.length; i++) {
              if (this.RecordList[i].tenderDate02 != null) {
                this.RecordList[i].tenderDate02 = new Date(this.RecordList[i].tenderDate02).toISOString().slice(0, 10);
              }
              if (this.RecordList[i].tenderDate04 != null) {
                this.RecordList[i].tenderDate03 = new Date(this.RecordList[i].tenderDate03).toISOString().slice(0, 10);
              }
            }
          } else {
            //this.AutoReload = false;
          }
        });
    } else {
      this.http.get(this.PrimaryApiPath + "GetByDomainCompanyCurrent/" + this.bcp.getCurrentDomainId() + "/" + this.bcp.getCurrentDataRole() + "/" + this.loggedInCompanyCode, this.bcp.getHttpOptions())
        .subscribe((result: any) => {
          this.RecordList = result;
          if (this.RecordList.length > 0) {
            for (var i = 0; i < this.RecordList.length; i++) {
              if (this.RecordList[i].tenderDate02 != null) {
                this.RecordList[i].tenderDate02 = this.bcp.convertDateTimetoDate(this.RecordList[i].tenderDate02);
              }
              if (this.RecordList[i].tenderDate03 != null) {
                this.RecordList[i].tenderDate03 = this.bcp.convertDateTimetoDate(this.RecordList[i].tenderDate03);
              }
            }
          } else {
            //this.AutoReload = false;
          }
        });
    };

  }


  //refreshExpressInterestText() {
  //  this.expressInterestText = "";
  //  if (this.SelectedRecord.expressInterest == 'Y') {
  //    this.expressInterestText = 'Yes we confirmed to return this tender';
  //  } else {
  //    if (this.SelectedRecord.expressInterest == 'N') {
  //      this.expressInterestText = 'No we are NOT interested to return this tender';
  //    }
  //  };
  //};


  checkPriceInput() {
    var inputAllPrice: boolean = true;
    if (this.PriceRecordList.length > 0) {
      for (var i = 0; i < this.PriceRecordList.length; i++) {
        if (this.PriceRecordList[i].optionalFlag == "N") {
          if (this.PriceRecordList[i].unitPrice == 0 || this.PriceRecordList[i].unitPrice == null || this.PriceRecordList[i].unitPrice == "") {
            inputAllPrice = false;
          }
        }
      }
    }
    if (inputAllPrice) {
      this.priceInputText = "Unit prices for all mandatory items are updated";
    } else {
      this.priceInputText = "Please input unit price for all mandatory items and click 'Update' button";
    }
  }

  //get record by id and assign to selected record
  getDataById(id) {
    this.http.get(this.PrimaryApiPath + id, this.bcp.getHttpOptions())
      .subscribe(async (data: any) => {
        this.SelectedRecord = data;
        this.SelectedRecord.successAward = this.bcp.convertYesNoToBoolean(this.SelectedRecord.successAward);
        this.SelectedRecord.includeOptionalFlag = this.bcp.convertYesNoToBoolean(this.SelectedRecord.includeOptionalFlag);
        //this.refreshExpressInterestText();;
        if (this.SelectedRecord.tenderDate01) {
          this.SelectedRecord.tenderDate01 = new Date(this.SelectedRecord.tenderDate01);
        }
        if (this.SelectedRecord.tenderDate02) {
          this.SelectedRecord.tenderDate02 = new Date(this.SelectedRecord.tenderDate02);
        }
        if (this.SelectedRecord.tenderDate03) {
          this.SelectedRecord.tenderDate03 = new Date(this.SelectedRecord.tenderDate03);
        }
        if (this.SelectedRecord.tenderDate04) {
          this.SelectedRecord.tenderDate04 = new Date(this.SelectedRecord.tenderDate04);
        }
        if (this.SelectedRecord.updateDate) {
          this.SelectedRecord.updateDate = new Date(this.SelectedRecord.updateDate);
        }
        if (this.SelectedRecord.priceValidityDate) {
          this.SelectedRecord.priceValidityDate = new Date(this.SelectedRecord.priceValidityDate);
        }
        if (this.SelectedRecord.responseDate) {
          this.displayResponseDate = this.bcp.formatDateToDisplayString(this.SelectedRecord.responseDate, true, true, "-", ":");
        }
        if (this.SelectedRecord.responseUser) {
          //this.getUserName(this.SelectedRecord.domainId, this.SelectedRecord.responseUser);
          this.UserNameDataSet = null;
          this.UserNameDataSet = JSON.parse('{"id": 0}');
          this.http.get(this.ContactApiPath + "GetUserFullName/" + this.SelectedRecord.domainId + "/" + this.SelectedRecord.responseUser, this.bcp.getHttpOptions())
            .subscribe((result: any) => {
              this.UserNameDataSet = result;
              this.displayResponseUser = this.UserNameDataSet.userNameLong;
            });
        }

        this.getListValueByDomain();
        this.getUserNameLong(this.SelectedRecord.domainId, this.bcp.getCurrentLoginUser());

        //Determine response cycle
        //this.responseCycle = 0;
        //if (this.SelectedRecord.expressInterest.trim() != "") {
        //  this.responseCycle = 1;
        //};
        //if (this.SelectedRecord.tenderResponseType.trim() != "") {
        //  this.responseCycle = 2;
        //};
        //if (this.SelectedRecord.tenderRevisionType.trim() != "") {
        //  this.responseCycle = 3;
        //};
        //if (this.SelectedRecord.acceptAward.trim() != "") {
        //  this.responseCycle = 4;
        //};

        //Load data for Price Sheet tab
        this.getPriceDataByTender(this.SelectedRecord.domainId, this.SelectedRecord.companyCode, this.SelectedRecord.tenderId);

        //Load data for Invitation tab
        this.getInvitationDataByTender(this.SelectedRecord.domainId, this.SelectedRecord.companyCode, this.SelectedRecord.tenderId);

        //Load data for Specification tab
        this.inputDocumentCompany = this.SelectedRecord.companyCode;
        this.getSpecificationDataByTender(this.SelectedRecord.domainId, this.inputDocumentCompany, this.SelectedRecord.tenderId);

        //Load data for Document tab
        this.inputDocumentCompany = this.SelectedRecord.companyCode;
        this.getDocumentDataByTender(this.SelectedRecord.domainId, this.inputDocumentCompany, this.SelectedRecord.tenderId);

        //Load data for Message tab
        if (this.loggedInType == 'E') {
          this.inputMessageCompany = this.loggedInCompanyCode;
        } else {
          this.inputMessageCompany = this.SelectedRecord.domainId;
        };
        this.getMessageDataByTender(this.SelectedRecord.domainId, this.inputMessageCompany, this.SelectedRecord.tenderId, this.inputMessageCompany);
        this.getCompanyListInvited(this.SelectedRecord.domainId, this.SelectedRecord.companyCode, this.SelectedRecord.tenderId);
        this.getCompanyListResponsed(this.SelectedRecord.domainId, this.SelectedRecord.tenderId);

        //Load data for Reponse tab
        if (this.loggedInType!='D') {
          this.getResponseDocDataByTender(this.SelectedRecord.domainId, this.SelectedRecord.companyCode, this.SelectedRecord.tenderId, this.SelectedRecord.id);
        };

        //Load data for Log tab
        if (this.loggedInType == 'E') {
          this.inputLogCompany = this.loggedInCompanyCode;
        } else {
          this.inputLogCompany = this.SelectedRecord.domainId;
        };
        //console.log('inputLogCompany is ' + this.inputLogCompany);
        this.getLogDataByTender(this.SelectedRecord.domainId, this.inputLogCompany, this.SelectedRecord.tenderId);

      });

  }


  //get record by id and assign to selected record
  getDataBySearchField() {
    if (this.loggedInType == 'D') {
      this.SearchFieldHolder["domainId"] = this.bcp.getCurrentDomainId();
      this.SearchFieldHolder["dataRole"] = this.bcp.getCurrentDataRole();
      this.SearchFieldHolder["companyCode"] = this.loggedInCompanyCode;
      this.stringifyValue = JSON.stringify(this.SearchFieldHolder);
      this.http.post(this.PrimaryApiPath + "q", this.stringifyValue, this.bcp.getHttpOptions())
        .subscribe((result: any[]) => {
          this.RecordList = result;
          if (this.RecordList.length > 0) {
            this.applyGlobalFilter();
            for (var i = 0; i < this.RecordList.length; i++) {
              if (this.RecordList[i].tenderDate02 != null) {
                this.RecordList[i].tenderDate02 = this.bcp.convertDateTimetoDate(this.RecordList[i].tenderDate02);
              }
              if (this.RecordList[i].tenderDate03 != null) {
                this.RecordList[i].tenderDate03 = this.bcp.convertDateTimetoDate(this.RecordList[i].tenderDate03);
              }
            }
          } else {
            //this.AutoReload = false;
          }
        });
    } else if (this.loggedInType == 'B') {
      this.stringifyValue = JSON.stringify(this.SearchFieldHolder);
      this.http.post(this.PrimaryApiPath + "q", this.stringifyValue, this.bcp.getHttpOptions())
        .subscribe((result: any[]) => {
          this.RecordList = result;
          if (this.RecordList.length > 0) {
            this.applyGlobalFilter();
            for (var i = 0; i < this.RecordList.length; i++) {
              if (this.RecordList[i].tenderDate02 != null) {
                this.RecordList[i].tenderDate02 = this.bcp.convertDateTimetoDate(this.RecordList[i].tenderDate02);
              }
              if (this.RecordList[i].tenderDate03 != null) {
                this.RecordList[i].tenderDate03 = this.bcp.convertDateTimetoDate(this.RecordList[i].tenderDate03);
              }
            }
          } else {
            //this.AutoReload = false;
          }
        });
    } else {
      this.SearchFieldHolder["domainId"] = this.bcp.getCurrentDomainId();
      this.SearchFieldHolder["dataRole"] = this.bcp.getCurrentDataRole();
      this.SearchFieldHolder["companyCode"] = this.loggedInCompanyCode;
      this.stringifyValue = JSON.stringify(this.SearchFieldHolder);
      this.http.post(this.PrimaryApiPath + "qCurrent", this.stringifyValue, this.bcp.getHttpOptions())
        .subscribe((result: any[]) => {
          this.RecordList = result;
          if (this.RecordList.length > 0) {
            this.applyGlobalFilter();
            for (var i = 0; i < this.RecordList.length; i++) {
              if (this.RecordList[i].tenderDate02 != null) {
                this.RecordList[i].tenderDate02 = this.bcp.convertDateTimetoDate(this.RecordList[i].tenderDate02);
              }
              if (this.RecordList[i].tenderDate03 != null) {
                this.RecordList[i].tenderDate03 = this.bcp.convertDateTimetoDate(this.RecordList[i].tenderDate03);
              }
            }
          } else {
            //this.AutoReload = false;
          }
        });
    };

  }


  //get price record by tender and assign to selected record
  getPriceDataByTender(DomainId: string, CompanyCode: string, TenderId: string) {
    let num = 0;
    this.http.get(this.PriceApiPath + "GetPriceByTender/" + DomainId + "/" + CompanyCode + "/" + TenderId + "/" + 'TOTAL', this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        this.PriceRecordList = result;
        this.numberOfPriceLine = this.PriceRecordList.length;
        if (this.PriceRecordList.length > 0) {
          for (var i = 0; i < this.PriceRecordList.length; i++) {
            if (this.PriceRecordList[i].optionalFlag!='Y') {
              num = num + this.PriceRecordList[i].lineAmount;
            }
          }
        }
        this.displayTotalAmount = num.toLocaleString(undefined, {
          maximumFractionDigits: 2,
          minimumFractionDigits: 2
        });
        this.savedTotalAmount = this.displayTotalAmount;
        this.enteredTotalAmount = num;
        this.checkPriceInput();
      });
      
  }


  getInvitationDataByTender(DomainId: string, CompanyCode: string, TenderId: string) {
    this.http.get(this.InvitationApiPath + "GetByTender/" + DomainId + "/" + CompanyCode + "/" + TenderId, this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        this.InvitationRecordList = result;
      });

  }


  getSpecificationDataByTender(DomainId: string, CompanyCode: string, TenderId: string) {
    //Get for Document tab
    this.http.get(this.DocumentApiPath + "GetByTender/" + DomainId + "/" + CompanyCode + "/" + TenderId + "/SPEC", this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        this.SpecificationRecordList = result;
        this.specificationLineNumber = 0;
        if (this.SpecificationRecordList.length > 0) {
          for (var i = 0; i < this.SpecificationRecordList.length; i++) {
            this.specificationLineNumber = this.SpecificationRecordList[i].lineId;
          }
        }
      });
  }


  getDocumentDataByTender(DomainId: string, CompanyCode: string, TenderId: string) {
    //Get for Document tab
    this.http.get(this.DocumentApiPath + "GetByTender/" + DomainId + "/" + CompanyCode + "/" + TenderId + "/PPSL", this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        this.DocumentRecordList = result;
        this.documentLineNumber = 0;
        if (this.DocumentRecordList.length > 0) {
          for (var i = 0; i < this.DocumentRecordList.length; i++) {
            this.documentLineNumber = this.DocumentRecordList[i].lineId;
          }
        }
      });
  }


  getResponseDocDataByTender(DomainId: string, CompanyCode: string, TenderId: string, Id: number) {
    //get response doc list
    this.http.get(this.DocumentApiPath + "GetByTender/" + DomainId + "/" + CompanyCode + "/" + TenderId + "/PPSL", this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        this.ResponseDocRecordList = result;
        this.responseDocLineNumber = 0;
        if (this.ResponseDocRecordList.length > 0) {
          for (var i = 0; i < this.ResponseDocRecordList.length; i++) {
            this.responseDocLineNumber = this.ResponseDocRecordList[i].lineId;
          }
        }
      });
    this.submissionDoneText = 'The Tender Response has been submitted successfully';
    //get decliine letter
    this.DeclineLetterData = null;
    this.DeclineLetterData = JSON.parse('{"id": 0}');
    this.http.get(this.AttachmentApiPath + "GetDeclineLetter/" + DomainId + "/" + Id, this.bcp.getHttpOptions())
      .subscribe((result: any) => {
        this.DeclineLetterData = result;
        //console.log("Decline Letter Data: " + this.DeclineLetterData.declineLetterName);
      });

  }


  getMessageDataByTender(DomainId: string, CompanyCode: string, TenderId: string, InvitedCompanyCode: string) {
    this.http.get(this.MessageApiPath + "GetByTender/" + DomainId + "/" + CompanyCode + "/" + TenderId + "/" + InvitedCompanyCode, this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        this.MessageRecordList = result;
        this.NewMessageFlag = false;
        this.HideMessage = true;
        if (this.MessageRecordList.length == 0) {
          this.addNewMessageRow();
        }
      });
  }


  getAllMessageDataByTender(DomainId: string, TenderId: string) {
    this.HideMessage = true;
    this.NewMessageFlag = false;
    this.inputMessageCompany = this.SelectedRecord.domainId;
    this.MessageRecordList = null;
    if (this.seeAllCompanyMessage) {
      this.http.get(this.MessageApiPath + "GetAllByTender/" + DomainId + "/" + TenderId, this.bcp.getHttpOptions())
        .subscribe((result: any[]) => {
          this.MessageRecordList = result;
          if (this.MessageRecordList.length == 0) {
            this.addNewMessageRow();
          }
        });
    } else {
      this.inputMessageCompany = this.SelectedRecord.domainId;
    }
  }


  //get award price record by tender for comparison (sorting by seq)
  getAwardPriceDataBySeq(DomainId: string, CompanyCode: string, TenderId: string) {
    this.http.get(this.PriceApiPath + "GetInSeq/" + DomainId + "/" + CompanyCode + "/" + TenderId, this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        this.AwardPriceRecordList = result;
      });
  }


  //get award price record by tender for comparison (sorting by co)
  getAwardPriceDataByCo(DomainId: string, CompanyCode: string, TenderId: string) {
    this.http.get(this.PriceApiPath + "GetInCo/" + DomainId + "/" + CompanyCode + "/" + TenderId, this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        this.AwardPriceRecordList = result;
      });
  }


  getLogDataByTender(DomainId: string, CompanyCode: string, TenderId: string) {
    this.http.get(this.LogApiPath + "GetByTender/" + DomainId + "/" + CompanyCode + "/" + TenderId, this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        this.LogRecordList = result;
        if (this.LogRecordList.length == 0) {
          this.addNewLogRow();
        }
      });

  }


  exportExcel() {
    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(this.RecordList);
      const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
      this.saveAsExcelFile(excelBuffer, "primengTable");
    });
  }


  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      let EXCEL_EXTENSION = '.xlsx';
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
    });
  }


  exportPdf() {
    const doc = new jsPDF({ orientation: "landscape" });
    var head = [];
    head[0] = Object.values(this.priceCols.map(e => Object.keys(e).map(k => e[k]))).map(item => item[0]);
    autoTable(doc, {
      headStyles: { fillColor: [0, 0, 0] },
      styles: { fillColor: [255, 255, 0] },
      columnStyles: { 0: { halign: 'center', fillColor: [0, 255, 0] }, 1: { halign: 'left', fillColor: [0, 255, 255] } },
      head: head,
      body: this.RecordList.map(e => Object.keys(e).map(k => e[k])),
      didDrawCell: (data) => {
        //console.log(data.column.index)
      },
    });

    doc.save('table.pdf');
  }


  findRecord() {
    this.RecordList = null;
    this.getDataBySearchField();
  }


  resetSearchField() {
    //dummy field, not use for searching
    this.SearchFieldHolder = JSON.parse('{"id": 0}');

    //set default value for all search fields
    //available field, please refer to the last part of [TableName]Controller.cs
    this.SearchFieldHolder["domainId"] = "";
    this.SearchFieldHolder["dataRole"] = "";
    this.SearchFieldHolder["companyCode"] = "";
    this.SearchFieldHolder["tenderId"] = "";

  }


  clearGlobalFilter() {
    this.globalFilterValue1 = "";
    this.globalFilterValue2 = "";
    this.globalFilterValue3 = "";
    this.globalFilterValue7 = "";
  }


  clearAwardFilter() {
    this.globalFilterValue4 = "";
    this.globalFilterValue5 = "";
    this.globalFilterValue6 = "";
    
  }


  applyGlobalFilter() {
    var element = document.getElementById('globalFilter1');
    var event = new Event('input');

    element = document.getElementById('globalFilter1');
    element.dispatchEvent(event);

    element = document.getElementById('globalFilter2');
    element.dispatchEvent(event);

    element = document.getElementById('globalFilter3');
    element.dispatchEvent(event);

    element = document.getElementById('globalFilter7');
    element.dispatchEvent(event);
  }


  applyAwardFilter() {
    var element = document.getElementById('globalFilter4');
    var event = new Event('input');

    element = document.getElementById('globalFilter4');
    element.dispatchEvent(event);

    element = document.getElementById('globalFilter5');
    element.dispatchEvent(event);

    element = document.getElementById('globalFilter6');
    element.dispatchEvent(event);
    
  }


  //-----------------------------------------------------------------------------
  //                      Add/Edit/Save/Delete Records
  //-----------------------------------------------------------------------------

  async addRecord() {
    //initialize the SelectedRecord as a new record, and assign default value as required
    this.SelectedRecord = null;
    this.SelectedRecord = JSON.parse('{"id": 0}');
    //set default value 
    this.SelectedRecord.domainId = this.bcp.getCurrentDomainId();
    this.SelectedRecord.companyCode = "";
    this.SelectedRecord.tenderId = "";
    this.SelectedRecord.subject = "";
    this.SelectedRecord.tenderCategory = "";
    this.SelectedRecord.tenderProperty = "";
    this.SelectedRecord.businessUnit = "";
    this.SelectedRecord.estimatedBudget = 0;
    this.SelectedRecord.fullName = this.currentUserName;
    this.SelectedRecord.fullNameOther = "";
    this.SelectedRecord.phoneArea = "";
    this.SelectedRecord.phone = this.currentUserPhone;
    this.SelectedRecord.email = this.currentUserEmail;
    this.SelectedRecord.tenderStatus = "DRAFT";
    this.SelectedRecord.tenderSummary = "";
    this.SelectedRecord.tenderDate01 = "";
    this.SelectedRecord.tenderDate02 = this.bcp.getCurrentDate();
    this.SelectedRecord.tenderDate03 = new Date();
    this.SelectedRecord.tenderDate03.setHours(12);
    this.SelectedRecord.tenderDate03.setMinutes(0);
    this.SelectedRecord.tenderDate03.setSeconds(0);
    this.SelectedRecord.tenderDate04 = "";
    this.SelectedRecord.tenderDate05 = this.bcp.get1900Date();
    this.SelectedRecord.tenderDate06 = this.bcp.get1900Date();
    this.SelectedRecord.tenderDate07 = this.bcp.get1900Date();
    this.SelectedRecord.tenderDate08 = this.bcp.get1900Date();
    this.SelectedRecord.tenderDate09 = this.bcp.get1900Date();
    this.SelectedRecord.tenderDate10 = this.bcp.get1900Date();
    this.SelectedRecord.tenderDate11 = this.bcp.get1900Date();
    this.SelectedRecord.tenderDate12 = this.bcp.get1900Date();
    this.SelectedRecord.purchaseNumber = 0;
    this.SelectedRecord.priceValidityMonths = 0;
    this.SelectedRecord.priceValidityDate = "";
    this.SelectedRecord.retentionPercent = 10;
    this.SelectedRecord.liquidatedDamages = 1500;
    this.SelectedRecord.defectsLiabilityPeriod = 12;
    this.SelectedRecord.approveUser = "";
    this.SelectedRecord.approveDate = this.bcp.get1900Date();
    this.SelectedRecord.tenderResponseStatus = "";
    this.SelectedRecord.expressInterest = "";
    this.SelectedRecord.expressUser = "";
    this.SelectedRecord.expressDate = this.bcp.get1900Date();
    this.SelectedRecord.tenderResponseType = "";
    this.SelectedRecord.tenderRevisionType = "";
    this.SelectedRecord.remark = "";
    this.SelectedRecord.title = "";
    this.SelectedRecord.contractSum = 0;
    this.SelectedRecord.includeOptionalFlag = "";
    this.SelectedRecord.adjustedContractSum = 0;
    this.SelectedRecord.adjustmentRemark = "";
    this.SelectedRecord.withdrawFlag = "N";
    this.SelectedRecord.withdrawUser = "";
    this.SelectedRecord.withdrawDate = "";
    this.SelectedRecord.controlFlag01 = "";
    this.SelectedRecord.controlFlag02 = "";
    this.SelectedRecord.controlFlag03 = "";
    this.SelectedRecord.responseUser = "";
    this.SelectedRecord.responseDate = "";
    this.SelectedRecord.acceptAward = "";
    this.SelectedRecord.reason = "";
    this.SelectedRecord.acceptUser = "";
    this.SelectedRecord.acceptDate = this.bcp.get1900Date();
    this.SelectedRecord.successAward = "";
    this.SelectedRecord.awardCompanyCode = "";
    this.SelectedRecord.awardComment = "";
    this.SelectedRecord.createUser = this.bcp.getCurrentLoginUser();
    this.SelectedRecord.createDate = this.bcp.getCurrentDateTime();
    this.SelectedRecord.updateUser = "";
    this.SelectedRecord.updateDate = "";

    if (this.loggedInType == 'D') {
      this.SelectedRecord.domainId = this.bcp.getCurrentDomainId();
      this.SelectedRecord.companyCode = this.bcp.getCurrentDomainId();
    }

    this.PriceRecordList = [{ part: "", section: "", longDescription: "", quantityTendered: "", optionalFlag: "N", unitOfMeasure: "Sum", id: 0 }];
    this.InvitationRecordList = [{ invitedCompanyCode: "", generationFlag: "N", withdrawFlag: "N", id: 0}];
   
    this.getListValueByDomain();

    // this.FormTitle = "Tender Process";
    this.newLinePendingCT = true;
    this.newLinePendingTI = true;
    this.numberOfPriceLine = 1;
    this.ShowAddForm = true;
    this.ShowEditForm = false;
    this.AddMode = "Y";
  }


  addPriceRecord() {
    //initialize the SelectedPriceRecord as a new record, and assign default value as required
    this.SelectedPriceRecord = null;
    this.SelectedPriceRecord = JSON.parse('{"id": 0}');
    //set default value
    this.SelectedPriceRecord.domainId = "";
    this.SelectedPriceRecord.companyCode = "";
    this.SelectedPriceRecord.tenderId = "";
    this.SelectedPriceRecord.part = "";
    this.SelectedPriceRecord.section = 0;
    this.SelectedPriceRecord.subSection = 0;
    this.SelectedPriceRecord.inventoryItem = "";
    this.SelectedPriceRecord.accountNumber = "";
    this.SelectedPriceRecord.longDescription = "";
    this.SelectedPriceRecord.lineDescription01 = "";
    this.SelectedPriceRecord.lineDescription02 = "";
    this.SelectedPriceRecord.quantityTendered = 0;
    this.SelectedPriceRecord.quantityOffered = 0;
    this.SelectedPriceRecord.unitOfMeasure = "";
    this.SelectedPriceRecord.unitPrice = 0;
    this.SelectedPriceRecord.lineAmount = 0;
    this.SelectedPriceRecord.currencyCode = "";
    this.SelectedPriceRecord.unitPriceCurrency = 0;
    this.SelectedPriceRecord.lineAmountCurrency = 0;
    this.SelectedPriceRecord.tenderRecordId = 0;
    this.SelectedPriceRecord.mandatoryFlag = "";
    this.SelectedPriceRecord.optionalFlag = "";
    this.SelectedPriceRecord.displaySequence = 0;
    this.SelectedPriceRecord.accountCostCenter = "";
    this.SelectedPriceRecord.accountObject = "";
    this.SelectedPriceRecord.accountSubsidiary = "";
    this.SelectedPriceRecord.createUser = "";
    this.SelectedPriceRecord.createDate = "";
    this.SelectedPriceRecord.updateUser = "";
    this.SelectedPriceRecord.updateDate = "";

  }


  addInvitationRecord() {
    //initialize the SelectedInvitationRecord as a new record, and assign default value as required
    this.SelectedInvitationRecord = null;
    this.SelectedInvitationRecord = JSON.parse('{"id": 0}');
    //set default value
    this.SelectedInvitationRecord.domainId = "";
    this.SelectedInvitationRecord.companyCode = "";
    this.SelectedInvitationRecord.tenderId = "";
    this.SelectedInvitationRecord.invitedCompanyCode = "";
    this.SelectedInvitationRecord.companyNumber = 0;
    this.SelectedInvitationRecord.generationFlag = "N";
    this.SelectedInvitationRecord.withdrawFlag = "N";
    this.SelectedInvitationRecord.withdrawUser = "";
    this.SelectedInvitationRecord.withdrawDate = "";
    this.SelectedInvitationRecord.remark = "";
    this.SelectedInvitationRecord.reason = "";
    this.SelectedInvitationRecord.activeFlag = "Y";
    this.SelectedInvitationRecord.controlFlag01 = "";
    this.SelectedInvitationRecord.controlFlag02 = "";
    this.SelectedInvitationRecord.controlFlag03 = "";
    this.SelectedInvitationRecord.tenderRecordId = "";
    this.SelectedInvitationRecord.createUser = "";
    this.SelectedInvitationRecord.createDate = "";
    this.SelectedInvitationRecord.generationUser = "";
    this.SelectedInvitationRecord.generationDate = "";
    this.SelectedInvitationRecord.updateUser = "";
    this.SelectedInvitationRecord.updateDate = "";

  }


  initSpecificationRecord() {
    //initialize the SelectedSpecificationRecordd as a new record, and assign default value as required
    this.SelectedSpecificationRecord = null;
    this.SelectedSpecificationRecord = JSON.parse('{"id": 0}');
    //set default value
    this.SelectedSpecificationRecord.domainId = "";
    this.SelectedSpecificationRecord.companyCode = "";
    this.SelectedSpecificationRecord.tenderId = "";
    this.SelectedSpecificationRecord.tenderDocumentType = "SPEC";
    this.SelectedSpecificationRecord.lineId = 0;
    this.SelectedSpecificationRecord.tenderDocumentName = "";
    this.SelectedSpecificationRecord.tenderDocumentCategory = "";
    this.SelectedSpecificationRecord.documentNumber = "";
    this.SelectedSpecificationRecord.documentIssuedDate = "";
    this.SelectedSpecificationRecord.documentExpiryDate = "";
    this.SelectedSpecificationRecord.remark = "";
    this.SelectedSpecificationRecord.instructionText = "";
    this.SelectedSpecificationRecord.mandatoryFlag = "";
    this.SelectedSpecificationRecord.optionalFlag = "";
    this.SelectedSpecificationRecord.displaySequence = 0;
    this.SelectedSpecificationRecord.requestUploadFlag = "N";
    this.SelectedSpecificationRecord.tenderRecordId = 0;
    this.SelectedSpecificationRecord.createUser = this.bcp.getCurrentLoginUser();
    this.SelectedSpecificationRecord.createDate = this.bcp.getCurrentDateTime();
    this.SelectedSpecificationRecord.uploadUser = "";
    this.SelectedSpecificationRecord.uploadDate = "";
    this.SelectedSpecificationRecord.downloadUser = "";
    this.SelectedSpecificationRecord.downloadDate = "";
    this.SelectedSpecificationRecord.updateUser = "";
    this.SelectedSpecificationRecord.updateDate = "";

  }


  initDocumentRecord() {
    //initialize the SelectedDocumentRecord as a new record, and assign default value as required
    this.SelectedDocumentRecord = null;
    this.SelectedDocumentRecord = JSON.parse('{"id": 0}');
    //set default value
    this.SelectedDocumentRecord.domainId = "";
    this.SelectedDocumentRecord.companyCode = "";
    this.SelectedDocumentRecord.tenderId = "";
    this.SelectedDocumentRecord.tenderDocumentType = "PPSL";
    this.SelectedDocumentRecord.lineId = 0;
    this.SelectedDocumentRecord.tenderDocumentName = "";
    this.SelectedDocumentRecord.tenderDocumentCategory = "";
    this.SelectedDocumentRecord.documentNumber = "";
    this.SelectedDocumentRecord.documentIssuedDate = "";
    this.SelectedDocumentRecord.documentExpiryDate = "";
    this.SelectedDocumentRecord.remark = "";
    this.SelectedDocumentRecord.instructionText = "";
    this.SelectedDocumentRecord.mandatoryFlag = "";
    this.SelectedDocumentRecord.optionalFlag = "";
    this.SelectedDocumentRecord.displaySequence = 0;
    this.SelectedDocumentRecord.requestUploadFlag = "Y";
    this.SelectedDocumentRecord.tenderRecordId = 0;
    this.SelectedDocumentRecord.createUser = this.bcp.getCurrentLoginUser();
    this.SelectedDocumentRecord.createDate = this.bcp.getCurrentDateTime();
    this.SelectedDocumentRecord.uploadUser = "";
    this.SelectedDocumentRecord.uploadDate = "";
    this.SelectedDocumentRecord.downloadUser = "";
    this.SelectedDocumentRecord.downloadDate = "";
    this.SelectedDocumentRecord.updateUser = "";
    this.SelectedDocumentRecord.updateDate = "";

  }


  initMessageRecord() {
    const today = new Date();
    //initialize the SelectedMessageRecord as a new record, and assign default value as required
    this.SelectedMessageRecord = null;
    this.SelectedMessageRecord = JSON.parse('{"id": 0}');
    //set default value
    this.SelectedMessageRecord.domainId = "";
    this.SelectedMessageRecord.companyCode = "";
    this.SelectedMessageRecord.tenderId = "";
    this.SelectedMessageRecord.invitedCompanyCode = "";
    this.SelectedMessageRecord.createDate = "";
    this.SelectedMessageRecord.createUser = this.bcp.getCurrentLoginUser();
    this.SelectedMessageRecord.messageId = "";
    this.SelectedMessageRecord.messageStatus = "";
    this.SelectedMessageRecord.approveUser = "";
    this.SelectedMessageRecord.approveDate = "";
    this.SelectedMessageRecord.subject = "";
    this.SelectedMessageRecord.contentBody = "";
    this.SelectedMessageRecord.allowReply = "";
    this.SelectedMessageRecord.replyBody = "";
    this.SelectedMessageRecord.deadline = "";
    this.SelectedMessageRecord.loginId = "";
    this.SelectedMessageRecord.email = "";
    this.SelectedMessageRecord.emailSent = "";
    this.SelectedMessageRecord.readFlag = "";
    this.SelectedMessageRecord.tenderRecordId = 0;
    this.SelectedMessageRecord.replyUser = "";
    this.SelectedMessageRecord.replyDate = "";
    this.SelectedMessageRecord.updateUser = this.bcp.getCurrentLoginUser();
    this.SelectedMessageRecord.updateDate = "";

    //initialize the SelectedMessageRecord as a new record, and assign default value as required
    this.EnteredMessageRecord = null;
    this.EnteredMessageRecord = JSON.parse('{"id": 0}');
    //set default value
    this.EnteredMessageRecord.domainId = "";
    this.EnteredMessageRecord.companyCode = "";
    this.EnteredMessageRecord.tenderId = "";
    this.EnteredMessageRecord.invitedCompanyCode = "";
    this.EnteredMessageRecord.createDate = "";
    this.EnteredMessageRecord.createUser = this.bcp.getCurrentLoginUser();
    this.EnteredMessageRecord.messageId = "";
    this.EnteredMessageRecord.messageStatus = "";
    this.EnteredMessageRecord.approveUser = "";
    this.EnteredMessageRecord.approveDate = "";
    this.EnteredMessageRecord.subject = "";
    this.EnteredMessageRecord.contentBody = "";
    this.EnteredMessageRecord.allowReply = "";
    this.EnteredMessageRecord.replyBody = "";
    this.EnteredMessageRecord.deadline = new Date(today);
    this.EnteredMessageRecord.deadline.setDate(today.getDate() + 1);
    this.EnteredMessageRecord.deadline.setHours(12);
    this.EnteredMessageRecord.deadline.setMinutes(0);
    this.EnteredMessageRecord.deadline.setSeconds(0);
    this.EnteredMessageRecord.loginId = "";
    this.EnteredMessageRecord.email = "";
    this.EnteredMessageRecord.emailSent = "";
    this.EnteredMessageRecord.readFlag = "";
    this.EnteredMessageRecord.tenderRecordId = 0;
    this.EnteredMessageRecord.replyUser = "";
    this.EnteredMessageRecord.replyDate = "";
    this.EnteredMessageRecord.updateUser = this.bcp.getCurrentLoginUser();
    this.EnteredMessageRecord.updateDate = "";

  }


  initMessageEnteredRecord() {
    const today = new Date();
    //initialize the SelectedMessageRecord as a new record, and assign default value as required
    this.EnteredMessageRecord = null;
    this.EnteredMessageRecord = JSON.parse('{"id": 0}');
    //set default value
    this.EnteredMessageRecord.domainId = "";
    this.EnteredMessageRecord.companyCode = "";
    this.EnteredMessageRecord.tenderId = "";
    this.EnteredMessageRecord.invitedCompanyCode = "";
    this.EnteredMessageRecord.createDate = "";
    this.EnteredMessageRecord.createUser = this.bcp.getCurrentLoginUser();
    this.EnteredMessageRecord.messageId = "";
    this.EnteredMessageRecord.messageStatus = "";
    this.EnteredMessageRecord.approveUser = "";
    this.EnteredMessageRecord.approveDate = "";
    this.EnteredMessageRecord.subject = "";
    this.EnteredMessageRecord.contentBody = "";
    this.EnteredMessageRecord.allowReply = "";
    this.EnteredMessageRecord.replyBody = "";
    this.EnteredMessageRecord.deadline = new Date(today);
    this.EnteredMessageRecord.deadline.setDate(today.getDate() + 1);
    this.EnteredMessageRecord.deadline.setHours(12);
    this.EnteredMessageRecord.deadline.setMinutes(0);
    this.EnteredMessageRecord.deadline.setSeconds(0);
    this.EnteredMessageRecord.loginId = "";
    this.EnteredMessageRecord.email = "";
    this.EnteredMessageRecord.emailSent = "";
    this.EnteredMessageRecord.readFlag = "";
    this.EnteredMessageRecord.tenderRecordId = 0;
    this.EnteredMessageRecord.replyUser = "";
    this.EnteredMessageRecord.replyDate = "";
    this.EnteredMessageRecord.updateUser = this.bcp.getCurrentLoginUser();
    this.EnteredMessageRecord.updateDate = "";

  }


  initResponseDocRecord() {
    //initialize the SelectedResponseDocRecord as a new record, and assign default value as required
    this.SelectedResponseDocRecord = null;
    this.SelectedResponseDocRecord = JSON.parse('{"id": 0}');
    //set default value
    this.SelectedResponseDocRecord.domainId = "";
    this.SelectedResponseDocRecord.companyCode = "";
    this.SelectedResponseDocRecord.tenderId = "";
    this.SelectedResponseDocRecord.lineId = 0;
    this.SelectedResponseDocRecord.tenderDocumentCategory = "";
    this.SelectedResponseDocRecord.documentNumber = "";
    this.SelectedResponseDocRecord.documentIssuedDate = "";
    this.SelectedResponseDocRecord.documentExpiryDate = "";
    this.SelectedResponseDocRecord.remark = "";
    this.SelectedResponseDocRecord.instructionText = "";
    this.SelectedResponseDocRecord.mandatoryFlag = "";
    this.SelectedResponseDocRecord.optionalFlag = "";
    this.SelectedResponseDocRecord.displaySequence = 0;
    this.SelectedResponseDocRecord.requestUploadFlag = "N";
    this.SelectedResponseDocRecord.tenderRecordId = 0;
    this.SelectedResponseDocRecord.createUser = "";
    this.SelectedResponseDocRecord.createDate = "";
    this.SelectedResponseDocRecord.uploadUser = "";
    this.SelectedResponseDocRecord.uploadDate = this.bcp.get1900Date();
    this.SelectedResponseDocRecord.downloadUser = "";
    this.SelectedResponseDocRecord.downloadDate = this.bcp.get1900Date();
    this.SelectedResponseDocRecord.updateUser = "";
    this.SelectedResponseDocRecord.updateDate = "";

  }


  async editRecord(recordId, domainId, companyCode, tenderId, tenderStatus) {
    this.clearAllMessage();
    this.newLinePendingCD = false;
    this.newLinePendingCT = false;
    this.newLinePendingTI = false;
    this.numberOfPriceLine = 0;
    //check and write lock record
    this.RecordLocked = true;
    this.SelectedLockRecord = null;
    this.SelectedLockRecord = JSON.parse('{"id": 0}');
    this.SelectedLockRecord.domainId = domainId;
    this.SelectedLockRecord.sourceTableName = "EtsTender";
    this.SelectedLockRecord.sourceRecordId = recordId;
    this.SelectedLockRecord.fullName = this.currentUserNameLong;
    this.SelectedLockRecord.updateUser = this.bcp.getCurrentLoginUser();
    this.SelectedLockRecord.updateDate = this.bcp.getCurrentDateTime();
    let tmpApiString1: string = "";
    tmpApiString1 = JSON.stringify(this.SelectedLockRecord);
    if (tenderStatus == "OPEN" || tenderStatus == "CLOSED") {
      let checkResult = await this.http.post(this.LockApiPath + "CheckLockedUser/", tmpApiString1, this.bcp.getHttpOptions())
        .map((response: any) => JSON.parse(response.toString())).toPromise();
      if (checkResult.lockRecordExisted == "Y" && checkResult.lockedUser != this.bcp.getCurrentLoginUser()) {
        //console.log("user is " + checkResult.lockedUser);
        //console.log("name is " + checkResult.lockedFullName);
        this.SelectedLockRecord.id = checkResult.lockedId;
        this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Tender is now processing by ' + checkResult.lockedFullName });
      } else if (checkResult.lockRecordExisted == "N") {
        this.RecordLocked = false;
        this.stringifyValue = JSON.stringify(this.SelectedLockRecord);
        if (this.SelectedLockRecord.id == 0) {
          let addResult = await this.http.post(this.LockApiPath, this.stringifyValue, this.bcp.getHttpOptions())
            .map((response: any) => response).toPromise();
          this.SelectedLockRecord.id = addResult.id;
        }
      } else if (checkResult.lockRecordExisted == "Y" && checkResult.lockedUser == this.bcp.getCurrentLoginUser()) {
        this.SelectedLockRecord.id = checkResult.lockedId;
        this.RecordLocked = false;
      }
    } else {
      this.RecordLocked = false;
    }

    if (!this.RecordLocked) {
      this.SelectedRecord = null;
      this.SelectedPriceRecord = null;
      this.SelectedDocumentRecord = null;
      this.EnteredMessageRecord = null;
      this.SelectedMessageRecord = null;
      this.RecordList = null;
      this.PriceRecordList = null;
      this.SpecificationRecordList = null;
      this.DocumentRecordList = null;
      this.MessageRecordList = null;
      this.ResponseDocRecordList = null;
      this.AwardPriceRecordList = null;

      this.initMessageRecord();

      this.getDataById(recordId);
      this.getAttachmentList(recordId);

      this.FormTitle = "Tender Process";// - ID = " + recordId;
      this.ShowAddForm = false;
      this.ShowEditForm = true;
      this.ShowSubmissionForm = false;
      this.AddMode = "N";
    }

  }


  editMessageRecord(recordId) {
    //this.SelectedMessageRecord = null;
    //this.initMessageEnteredRecord();
    this.http.get(this.MessageApiPath + recordId, this.bcp.getHttpOptions())
      .subscribe((data: any) => {
        this.SelectedMessageRecord = data;
        this.OverDeadline = false;
        if (this.SelectedMessageRecord.deadline && this.SelectedMessageRecord.deadline < this.bcp.getCurrentDateTime()) {
          this.OverDeadline = true;
        }
        this.SelectedMessageRecord.deadline = this.bcp.formatDateToDisplayString(this.SelectedMessageRecord.deadline,true,false,"-",":");
        //console.log("deadline is " + this.SelectedMessageRecord.deadline);
        this.getMessageReviewAttachmentList(recordId);
        this.HideMessage = false;
      });
  }


  hideMessageRecord() {
    //this.SelectedMessageRecord = null;
    this.HideMessage = true;
  }


  async saveRecord() {

    this.InputErrorMsg = [];

    //convert check box field value from boolean to character
    this.SelectedRecord.successAward = this.bcp.convertBooleanToYesNo(this.SelectedRecord.successAward);
    this.SelectedRecord.includeOptionalFlag = this.bcp.convertBooleanToYesNo(this.SelectedRecord.includeOptionalFlag);

    this.SelectedRecord.updateDate = this.bcp.getCurrentDateTime();
    this.SelectedRecord.updateUser = this.bcp.getCurrentLoginUser();

    if (this.SelectedRecord.tenderDate01) {
      this.SelectedRecord.tenderDate01 = this.bcp.convertCalendarDateToJson(this.SelectedRecord.tenderDate01);
    }
    if (this.SelectedRecord.tenderDate02) {
      this.SelectedRecord.tenderDate02 = this.bcp.convertCalendarDateToJson(this.SelectedRecord.tenderDate02);
    }
    if (this.SelectedRecord.tenderDate03) {
      this.SelectedRecord.tenderDate03 = this.bcp.convertCalendarDateTimeToJson(this.SelectedRecord.tenderDate03);
    }
    if (this.SelectedRecord.tenderDate04) {
      this.SelectedRecord.tenderDate04 = this.bcp.convertCalendarDateToJson(this.SelectedRecord.tenderDate04);
    }
    if (this.SelectedRecord.priceValidityDate) {
      this.SelectedRecord.priceValidityDate = this.bcp.convertCalendarDateToJson(this.SelectedRecord.priceValidityDate);
    }
    this.stringifyValue = JSON.stringify(this.SelectedRecord);
    //alert(this.stringifyValue);
    if (this.SelectedRecord.id == 0) {
      await this.http.post(this.PrimaryApiPath, this.stringifyValue, this.bcp.getHttpOptions())
        .toPromise();
    }
    else {
      //console.log("ready to put  " + this.stringifyValue);
      await this.http.put(this.PrimaryApiPath + "" + this.SelectedRecord.id, this.stringifyValue, this.bcp.getHttpOptions())
        .toPromise();
    }
    //format response data for re-display after save
    if (this.SelectedRecord.responseDate) {
      this.displayResponseDate = this.bcp.formatDateToDisplayString(this.SelectedRecord.responseDate, true, true, "-", ":");
    }
    if (this.SelectedRecord.responseUser) {
      this.UserNameDataSet = null;
      this.UserNameDataSet = JSON.parse('{"id": 0}');
      this.http.get(this.ContactApiPath + "GetUserFullName/" + this.SelectedRecord.domainId + "/" + this.SelectedRecord.responseUser, this.bcp.getHttpOptions())
        .subscribe((result: any) => {
          this.UserNameDataSet = result;
          this.displayResponseUser = this.UserNameDataSet.userNameLong;
        });
    }
  }


  savePriceRecord() {
    this.SelectedPriceRecord.updateDate = this.bcp.getCurrentDateTime();
    this.SelectedPriceRecord.updateUser = this.bcp.getCurrentLoginUser();
    this.stringifyValue = JSON.stringify(this.SelectedPriceRecord);
    //console.log(this.stringifyValue);
    if (this.SelectedPriceRecord.id == 0) {
      this.http.post(this.PriceApiPath, this.stringifyValue, this.bcp.getHttpOptions())
        .subscribe(
          (result: any) => {
            //do nothing
          },
          (err) => {
            if (err.status === 400) {
              // handle validation error
              let validationErrorDictionary = JSON.parse(err.text());
              for (var fieldName in validationErrorDictionary) {
                if (validationErrorDictionary.hasOwnProperty(fieldName)) {
                  this.InputErrorMsg.push(validationErrorDictionary[fieldName]);
                }
              }
            } else {
              this.InputErrorMsg.push("something went wrong!");
            }
          });
    }
    else {
      //console.log("ready to put  " + this.stringifyValue);
      this.http.put(this.PriceApiPath + "" + this.SelectedPriceRecord.id, this.stringifyValue, this.bcp.getHttpOptions())
        .subscribe(
          (result: any) => {
            // Do nothing
          },
          (err) => {
            if (err.status === 400) {
              // handle validation error
              let validationErrorDictionary = JSON.parse(err.text());
              for (var fieldName in validationErrorDictionary) {
                if (validationErrorDictionary.hasOwnProperty(fieldName)) {
                  this.InputErrorMsg.push(validationErrorDictionary[fieldName]);
                }
              }
            } else {
              this.InputErrorMsg.push("something went wrong!");
            }
          });
    }

  }


  saveInvitationRecord() {
    this.stringifyValue = JSON.stringify(this.SelectedInvitationRecord);
    //console.log(this.stringifyValue);
    if (this.SelectedInvitationRecord.id == 0) {
      this.http.post(this.InvitationApiPath, this.stringifyValue, this.bcp.getHttpOptions())
        .subscribe(
          (result: any) => {
            //do nothing
          },
          (err) => {
            if (err.status === 400) {
              // handle validation error
              let validationErrorDictionary = JSON.parse(err.text());
              for (var fieldName in validationErrorDictionary) {
                if (validationErrorDictionary.hasOwnProperty(fieldName)) {
                  this.InputErrorMsg.push(validationErrorDictionary[fieldName]);
                }
              }
            } else {
              this.InputErrorMsg.push("something went wrong!");
            }
          });
    }
    else {
      //console.log("ready to put  " + this.stringifyValue);
      this.http.put(this.InvitationApiPath + "" + this.SelectedInvitationRecord.id, this.stringifyValue, this.bcp.getHttpOptions())
        .subscribe(
          (result: any) => {
            // Do nothing
          },
          (err) => {
            if (err.status === 400) {
              // handle validation error
              let validationErrorDictionary = JSON.parse(err.text());
              for (var fieldName in validationErrorDictionary) {
                if (validationErrorDictionary.hasOwnProperty(fieldName)) {
                  this.InputErrorMsg.push(validationErrorDictionary[fieldName]);
                }
              }
            } else {
              this.InputErrorMsg.push("something went wrong!");
            }
          });
    }

  }


  async createDocumentRecord(CompanyCode: string) {

    this.InputErrorMsg = [];

    this.SelectedDocumentRecord.domainId = this.SelectedRecord.domainId;
    this.SelectedDocumentRecord.companyCode = CompanyCode;
    this.SelectedDocumentRecord.tenderId = this.SelectedRecord.tenderId;
    this.SelectedDocumentRecord.tenderDocumentType = "SPEC";
    this.documentLineNumber = this.documentLineNumber + 1;
    this.SelectedDocumentRecord.lineId = this.documentLineNumber;
    this.SelectedDocumentRecord.tenderDocumentName = "";
    this.SelectedDocumentRecord.tenderDocumentCategory = "";
    this.SelectedDocumentRecord.requestUploadFlag = "N";
    this.SelectedDocumentRecord.tenderRecordId = this.SelectedRecord.id;

    this.SelectedDocumentRecord.updateDate = this.bcp.getCurrentDateTime();
    this.SelectedDocumentRecord.updateUser = this.bcp.getCurrentLoginUser();

    this.stringifyValue = JSON.stringify(this.SelectedDocumentRecord);
    //alert(this.stringifyValue);
    if (this.SelectedDocumentRecord.id == 0) {
      await this.http.post(this.DocumentApiPath, this.stringifyValue, this.bcp.getHttpOptions())
        .toPromise();

    }
    else {
      //console.log("ready to put  " + this.stringifyValue);
      this.http.put(this.DocumentApiPath + "" + this.SelectedDocumentRecord.id, this.stringifyValue, this.bcp.getHttpOptions())
        .subscribe(
          (result: any) => {
            //Do Nothing
          },
          (err) => {
            if (err.status === 400) {
              // handle validation error
              let validationErrorDictionary = JSON.parse(err.text());
              for (var fieldName in validationErrorDictionary) {
                if (validationErrorDictionary.hasOwnProperty(fieldName)) {
                  this.InputErrorMsg.push(validationErrorDictionary[fieldName]);
                }
              }
            } else {
              this.InputErrorMsg.push("something went wrong!");
            }
          });
    }

  }


  async createSpecificationRecord(CompanyCode: string, DocumentName: string, DocumentRemark: string) {

    this.InputErrorMsg = [];

    this.SelectedSpecificationRecord.domainId = this.SelectedRecord.domainId;
    this.SelectedSpecificationRecord.companyCode = CompanyCode;
    this.SelectedSpecificationRecord.tenderId = this.SelectedRecord.tenderId;
    this.SelectedSpecificationRecord.tenderDocumentType = "SPEC";
    this.specificationLineNumber = this.specificationLineNumber + 1;
    this.SelectedSpecificationRecord.lineId = this.specificationLineNumber;
    this.SelectedSpecificationRecord.tenderDocumentName = DocumentName;
    this.SelectedSpecificationRecord.tenderDocumentCategory = "";
    this.SelectedSpecificationRecord.remark = DocumentRemark;
    this.SelectedSpecificationRecord.requestUploadFlag = "N";
    this.SelectedSpecificationRecord.tenderRecordId = this.SelectedRecord.id;

    this.SelectedSpecificationRecord.updateDate = this.bcp.getCurrentDateTime();
    this.SelectedSpecificationRecord.updateUser = this.bcp.getCurrentLoginUser();

    this.stringifyValue = JSON.stringify(this.SelectedSpecificationRecord);
    //alert(this.stringifyValue);
    if (this.SelectedSpecificationRecord.id == 0) {
      await this.http.post(this.DocumentApiPath, this.stringifyValue, this.bcp.getHttpOptions())
        .toPromise();

    }
    else {
      //console.log("ready to put  " + this.stringifyValue);
      this.http.put(this.DocumentApiPath + "" + this.SelectedSpecificationRecord.id, this.stringifyValue, this.bcp.getHttpOptions())
        .subscribe(
          (result: any) => {
            //Do Nothing
          },
          (err) => {
            if (err.status === 400) {
              // handle validation error
              let validationErrorDictionary = JSON.parse(err.text());
              for (var fieldName in validationErrorDictionary) {
                if (validationErrorDictionary.hasOwnProperty(fieldName)) {
                  this.InputErrorMsg.push(validationErrorDictionary[fieldName]);
                }
              }
            } else {
              this.InputErrorMsg.push("something went wrong!");
            }
          });
    }

  }


  saveSpecificationRecord() {
    this.stringifyValue = JSON.stringify(this.SelectedSpecificationRecord);
    //console.log(this.stringifyValue);
    if (this.SelectedSpecificationRecord.id == 0) {
      this.http.post(this.DocumentApiPath, this.stringifyValue, this.bcp.getHttpOptions())
        .subscribe(
          (result: any) => {
            //do nothing
          },
          (err) => {
            if (err.status === 400) {
              // handle validation error
              let validationErrorDictionary = JSON.parse(err.text());
              for (var fieldName in validationErrorDictionary) {
                if (validationErrorDictionary.hasOwnProperty(fieldName)) {
                  this.InputErrorMsg.push(validationErrorDictionary[fieldName]);
                }
              }
            } else {
              this.InputErrorMsg.push("something went wrong!");
            }
          });
    }
    else {
      //console.log("ready to put  " + this.stringifyValue);
      this.http.put(this.DocumentApiPath + "" + this.SelectedSpecificationRecord.id, this.stringifyValue, this.bcp.getHttpOptions())
        .subscribe(
          (result: any) => {
            // Do nothing
          },
          (err) => {
            if (err.status === 400) {
              // handle validation error
              let validationErrorDictionary = JSON.parse(err.text());
              for (var fieldName in validationErrorDictionary) {
                if (validationErrorDictionary.hasOwnProperty(fieldName)) {
                  this.InputErrorMsg.push(validationErrorDictionary[fieldName]);
                }
              }
            } else {
              this.InputErrorMsg.push("something went wrong!");
            }
          });
    }

  }


  saveDocumentRecord() {
    this.stringifyValue = JSON.stringify(this.SelectedDocumentRecord);
    //console.log(this.stringifyValue);
    if (this.SelectedDocumentRecord.id == 0) {
      this.http.post(this.DocumentApiPath, this.stringifyValue, this.bcp.getHttpOptions())
        .subscribe(
          (result: any) => {
            //do nothing
          },
          (err) => {
            if (err.status === 400) {
              // handle validation error
              let validationErrorDictionary = JSON.parse(err.text());
              for (var fieldName in validationErrorDictionary) {
                if (validationErrorDictionary.hasOwnProperty(fieldName)) {
                  this.InputErrorMsg.push(validationErrorDictionary[fieldName]);
                }
              }
            } else {
              this.InputErrorMsg.push("something went wrong!");
            }
          });
    }
    else {
      //console.log("ready to put  " + this.stringifyValue);
      this.http.put(this.DocumentApiPath + "" + this.SelectedDocumentRecord.id, this.stringifyValue, this.bcp.getHttpOptions())
        .subscribe(
          (result: any) => {
            // Do nothing
          },
          (err) => {
            if (err.status === 400) {
              // handle validation error
              let validationErrorDictionary = JSON.parse(err.text());
              for (var fieldName in validationErrorDictionary) {
                if (validationErrorDictionary.hasOwnProperty(fieldName)) {
                  this.InputErrorMsg.push(validationErrorDictionary[fieldName]);
                }
              }
            } else {
              this.InputErrorMsg.push("something went wrong!");
            }
          });
    }

  }


  saveResponseDocRecord() {
    this.stringifyValue = JSON.stringify(this.SelectedResponseDocRecord);
    //console.log(this.stringifyValue);
    if (this.SelectedResponseDocRecord.id == 0) {
      this.http.post(this.DocumentApiPath, this.stringifyValue, this.bcp.getHttpOptions())
        .subscribe(
          (result: any) => {
            this.inputTenderDocumentName = "";
            this.inputRemark = "";
            this.getResponseDocDataByTender(this.SelectedRecord.domainId, this.SelectedRecord.companyCode, this.SelectedRecord.tenderId, this.SelectedRecord.id);
          },
          (err) => {
            if (err.status === 400) {
              // handle validation error
              let validationErrorDictionary = JSON.parse(err.text());
              for (var fieldName in validationErrorDictionary) {
                if (validationErrorDictionary.hasOwnProperty(fieldName)) {
                  this.InputErrorMsg.push(validationErrorDictionary[fieldName]);
                }
              }
            } else {
              this.InputErrorMsg.push("something went wrong!");
            }
          });
    }
    else {
      //console.log("ready to put  " + this.stringifyValue);
      this.http.put(this.DocumentApiPath + "" + this.SelectedResponseDocRecord.id, this.stringifyValue, this.bcp.getHttpOptions())
        .subscribe(
          (result: any) => {
            // Do nothing
          },
          (err) => {
            if (err.status === 400) {
              // handle validation error
              let validationErrorDictionary = JSON.parse(err.text());
              for (var fieldName in validationErrorDictionary) {
                if (validationErrorDictionary.hasOwnProperty(fieldName)) {
                  this.InputErrorMsg.push(validationErrorDictionary[fieldName]);
                }
              }
            } else {
              this.InputErrorMsg.push("something went wrong!");
            }
          });
    }

  }


  async confirmSubmission() {
    //this.SelectedRecord.tenderResponseStatus = 'SUBMITTED';
    //this.SelectedRecord.responseUser = this.bcp.getCurrentLoginUser();
    //this.SelectedRecord.responseDate = this.bcp.getCurrentDateTime();
    //this.SelectedRecord.contractSum = this.enteredTotalAmount;
    await this.saveRecord();
    //send email to contractor user
    if (this.emailSubmitResponse) {
      this.tenderProcessEmail = {};
      this.tenderProcessEmail.companyCode = this.SelectedRecord.companyCode;
      this.tenderProcessEmail.tenderResponseStatus = this.SelectedRecord.tenderResponseStatus;
      //this.tenderProcessEmail.tenderResponseUser = this.displayResponseUser;
      this.tenderProcessEmail.tenderResponseDate = this.displayResponseDate;
      this.sendSubmitResponseEmail();
    }
    // write tender log
    this.WriteLogFieldHolder = JSON.parse('{"id": 0}');
    this.WriteLogFieldHolder.recordId = this.SelectedRecord.id;
    //if (this.responseCycle == 0) {
    //  this.WriteLogFieldHolder.tenderLogCode = "20";
    //}
    //else if (this.responseCycle == 1) {
    //  this.WriteLogFieldHolder.tenderLogCode = "30";
    //}
    //else if (this.responseCycle >= 2) {
    //  this.WriteLogFieldHolder.tenderLogCode = "40";
    //};
    this.WriteLogFieldHolder.domainId = this.SelectedRecord.domainId;
    this.WriteLogFieldHolder.tenderLogCode = "30";
    this.WriteLogFieldHolder.companyCode = this.SelectedRecord.companyCode;
    this.WriteLogFieldHolder.createDate = this.bcp.getCurrentDateTime();
    this.WriteLogFieldHolder.createUser = this.bcp.getCurrentLoginUser();
    this.stringifyValue = JSON.stringify(this.WriteLogFieldHolder);
    this.http.post(this.LogApiPath + "WriteTenderLog/", this.stringifyValue, this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        this.getLogDataByTender(this.SelectedRecord.domainId, this.SelectedRecord.companyCode, this.SelectedRecord.tenderId);
      });
    this.ShowAddForm = false;
    this.ShowEditForm = true;
    this.ShowSubmissionForm = false;
    this.index = 4;
  }


  cancelSubmission() {
    this.SelectedRecord.tenderResponseStatus = "";
    this.ShowAddForm = false;
    this.ShowEditForm = true;
    this.ShowSubmissionForm = false;
    this.index = 4;
  }


  createMessageRecord() {
    //clear existing messages
    this.clearAllMessage();
    this.checkedError = 'N';
    //check company must be selected
    if (this.inputMessageCompany.trim() == "" || this.inputMessageCompany.trim() == null) {
      this.checkedError = 'Y';
      this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Company must be selected   ' });
    }
    //perform send if no error
    if (this.checkedError == "N") {
      this.confirmationService.confirm({
        message: 'Are you sure that you want to send the new message?',
        accept: async () => {
          this.EnteredMessageRecord.domainId = this.SelectedRecord.domainId;
          this.EnteredMessageRecord.tenderId = this.SelectedRecord.tenderId;
          this.EnteredMessageRecord.tenderRecordId = this.SelectedRecord.id;
          this.EnteredMessageRecord.createDate = this.bcp.getCurrentDateTime();
          this.EnteredMessageRecord.updateDate = this.EnteredMessageRecord.createDate;
          this.EnteredMessageRecord.allowReply = this.bcp.convertBooleanToYesNo(this.EnteredMessageRecord.allowReply);
          if (this.EnteredMessageRecord.deadline) {
            this.EnteredMessageRecord.deadline = this.bcp.convertCalendarDateTimeToJson(this.EnteredMessageRecord.deadline);
          }
          //sending to all company is now obsolete
          if (this.inputSendAllCompany) {
            this.CompanyListInvitedOnly.forEach(async (line, index, arr) => {
              if (line.value.trim() != "") {
                this.EnteredMessageRecord.companyCode = line.value;
                this.EnteredMessageRecord.invitedCompanyCode = line.value;
                this.stringifyValue = JSON.stringify(this.EnteredMessageRecord);
                //write message record for each supplier
                let addResult = await this.http.post(this.MessageApiPath, this.stringifyValue, this.bcp.getHttpOptions())
                  .map((response: any) => response).toPromise();
                this.EnteredMessageRecord.id = addResult.id;
                //copy attachments to new message record
                this.CopyAttachmentFieldHolder = JSON.parse('{"id": 0}');
                this.CopyAttachmentFieldHolder.domainId = this.SelectedRecord.domainId;
                this.CopyAttachmentFieldHolder.fromSourceTableName = "BcpLock";
                this.CopyAttachmentFieldHolder.fromSourceRecordId = this.SelectedLockRecord.id;
                this.CopyAttachmentFieldHolder.toSourceTableName = "EtsMessage";
                this.CopyAttachmentFieldHolder.toSourceRecordId = this.EnteredMessageRecord.id;
                this.CopyAttachmentFieldHolder.createUser = this.bcp.getCurrentLoginUser();
                this.CopyAttachmentFieldHolder.createDate = this.bcp.getCurrentDateTime();
                this.stringifyValue = JSON.stringify(this.CopyAttachmentFieldHolder);
                await this.http.post(this.AttachmentApiPath + "CopyAttachment/", this.stringifyValue, this.bcp.getHttpOptions())
                  .subscribe((result: any[]) => {
                    if (!arr[index + 1]) {
                      if (this.MessageNewAttachmentAutoReload) {
                        //delete temp new message attachments by the final loop
                        this.http.delete(this.AttachmentApiPath + "DeleteAttachmentByKey/" + this.SelectedRecord.domainId + "/BcpLock/" + this.SelectedLockRecord.id, this.bcp.getHttpOptions())
                          .subscribe(
                            (data: any) => {
                              this.getMessageNewAttachmentList(this.SelectedLockRecord.id);
                              //refresh message table
                              this.getMessageDataByTender(this.SelectedRecord.domainId, this.inputMessageCompany, this.SelectedRecord.tenderId, this.inputMessageCompany);
                            });
                      } else {
                        //refresh message table
                        this.getMessageDataByTender(this.SelectedRecord.domainId, this.inputMessageCompany, this.SelectedRecord.tenderId, this.inputMessageCompany);
                      }
                    }
                  });
              }
            })
          } else {
            if (this.inputMessageCompany.trim() != "") {
              this.EnteredMessageRecord.companyCode = this.inputMessageCompany;
              this.EnteredMessageRecord.invitedCompanyCode = this.inputMessageCompany;
              this.stringifyValue = JSON.stringify(this.EnteredMessageRecord);
              //write message record for each supplier
              let addResult = await this.http.post(this.MessageApiPath, this.stringifyValue, this.bcp.getHttpOptions())
                .map((response: any) => response).toPromise();
              this.EnteredMessageRecord.id = addResult.id;
              //copy attachments to new message record
              if (this.MessageNewAttachmentAutoReload) {
                this.CopyAttachmentFieldHolder = JSON.parse('{"id": 0}');
                this.CopyAttachmentFieldHolder.domainId = this.SelectedRecord.domainId;
                this.CopyAttachmentFieldHolder.fromSourceTableName = "BcpLock";
                this.CopyAttachmentFieldHolder.fromSourceRecordId = this.SelectedLockRecord.id;
                this.CopyAttachmentFieldHolder.toSourceTableName = "EtsMessage";
                this.CopyAttachmentFieldHolder.toSourceRecordId = this.EnteredMessageRecord.id;
                this.CopyAttachmentFieldHolder.createUser = this.bcp.getCurrentLoginUser();
                this.CopyAttachmentFieldHolder.createDate = this.bcp.getCurrentDateTime();
                this.stringifyValue = JSON.stringify(this.CopyAttachmentFieldHolder);
                this.http.post(this.AttachmentApiPath + "CopyAttachment/", this.stringifyValue, this.bcp.getHttpOptions())
                  .subscribe((result: any[]) => {
                    //send email to contractor user (send after attachment existed with etsmessage)
                    if (this.emailSendMessage) {
                      this.tenderProcessEmail = {};
                      this.tenderProcessEmail.companyCode = this.inputMessageCompany;
                      this.tenderProcessEmail.messageSubject = this.EnteredMessageRecord.subject;
                      this.tenderProcessEmail.messageBody = this.EnteredMessageRecord.contentBody;
                      this.tenderProcessEmail.messageId = addResult.id;
                      this.sendTenderQueryEmail();
                      //reset new message working fields
                      this.initMessageEnteredRecord();
                      this.MessageNewAttachmentAutoReload = false;
                      this.inputSendAllCompany = false;
                    }
                    //delete temp new message attachments
                    this.http.delete(this.AttachmentApiPath + "DeleteAttachmentByKey/" + this.SelectedRecord.domainId + "/BcpLock/" + this.SelectedLockRecord.id, this.bcp.getHttpOptions())
                      .subscribe(
                        (data: any) => {
                          this.getMessageNewAttachmentList(this.SelectedLockRecord.id);
                        });
                  });
              } else {
                //send email to contractor user (send directly without attachment)
                if (this.emailSendMessage) {
                  this.tenderProcessEmail = {};
                  this.tenderProcessEmail.companyCode = this.inputMessageCompany;
                  this.tenderProcessEmail.messageSubject = this.EnteredMessageRecord.subject;
                  this.tenderProcessEmail.messageBody = this.EnteredMessageRecord.contentBody;
                  this.tenderProcessEmail.messageId = addResult.id;
                  this.sendTenderQueryEmail();
                  //reset new message working fields
                  this.initMessageEnteredRecord();
                  this.MessageNewAttachmentAutoReload = false;
                  this.inputSendAllCompany = false;
                }
              }
              //refresh message table
              this.getMessageDataByTender(this.SelectedRecord.domainId, this.inputMessageCompany, this.SelectedRecord.tenderId, this.inputMessageCompany);
            }
          }
          //reset new message working fields
          //this.initMessageEnteredRecord();
          //this.MessageNewAttachmentAutoReload = false;
          //this.EnteredMessageRecord.subject = "";
          //this.EnteredMessageRecord.contentBody = "";
          //this.EnteredMessageRecord.allowReply = this.bcp.convertYesNoToBoolean(this.EnteredMessageRecord.allowReply);
          //this.EnteredMessageRecord.allowReply = false;
          //this.EnteredMessageRecord.deadline = "";
          //this.inputSendAllCompany = false;
        },
        reject: () => {
          //Do Nothing
        }
      });
    }
  }


  saveMessageRecord() {
    this.SelectedMessageRecord.replyDate = this.bcp.getCurrentDateTime();
    this.SelectedMessageRecord.replyUser = this.bcp.getCurrentLoginUser();
    this.SelectedMessageRecord.updateDate = this.SelectedMessageRecord.replyDate;
    this.SelectedMessageRecord.updateUser = this.SelectedMessageRecord.replyUser;
    this.stringifyValue = JSON.stringify(this.SelectedMessageRecord);
    //console.log(this.stringifyValue);
    if (this.SelectedMessageRecord.id != 0) {
      //console.log("ready to put  " + this.stringifyValue);
      this.http.put(this.MessageApiPath + "" + this.SelectedMessageRecord.id, this.stringifyValue, this.bcp.getHttpOptions())
        .subscribe(
          (result: any) => {
            this.getMessageDataByTender(this.SelectedRecord.domainId, this.inputMessageCompany, this.SelectedRecord.tenderId, this.inputMessageCompany);
            this.SelectedMessageRecord.subject = "";
            this.SelectedMessageRecord.contentBody = "";
            this.SelectedMessageRecord.replyBody = "";
            this.SelectedMessageRecord.allowReply = "N";
            this.HideMessage = true;
          },
          (err) => {
            if (err.status === 400) {
              // handle validation error
              let validationErrorDictionary = JSON.parse(err.text());
              for (var fieldName in validationErrorDictionary) {
                if (validationErrorDictionary.hasOwnProperty(fieldName)) {
                  this.InputErrorMsg.push(validationErrorDictionary[fieldName]);
                }
              }
            } else {
              this.InputErrorMsg.push("something went wrong!");
            }
          });
    }

  }


  submitResponse() {
    this.InputErrorMsg = [];
    this.clearAllMessage();
    this.confirmationService.confirm({
      message: 'Are you sure that you want to submit response?',
      accept: async () => {
        if (this.SelectedRecord.tenderResponseType == 'D') {
          //Clear Search Form Error Message
          this.clearAllMessage();
          this.checkedError = 'N';
          //get submit data
          //this.SelectedRecord.tenderResponseStatus = 'DECLINED';
          this.SelectedRecord.responseUser = this.bcp.getCurrentLoginUser();
          this.SelectedRecord.responseDate = this.bcp.getCurrentDateTime();
          //check submission time
          let currentDate = new Date();
          if (this.bcp.convertCalendarDateTimeToJson(currentDate) > this.bcp.convertCalendarDateTimeToJson(this.SelectedRecord.tenderDate03)) {
            this.checkedError = 'Y';
            this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Submission Time is overdue   ' });
          };
          //check remark
          if (this.SelectedRecord.remark.trim() == "") {
            this.checkedError = 'Y';
            this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Decline Reason must be provided in Remark   ' });
          };
          //
          if (this.checkedError == 'N') {
            this.SelectedRecord.tenderResponseStatus = 'DECLINED';
            //this.SelectedRecord.responseUser = this.bcp.getCurrentLoginUser();
            //this.SelectedRecord.responseDate = this.bcp.getCurrentDateTime();
            await this.saveRecord();
            //send email to contractor user
            if (this.emailSubmitResponse) {
              this.tenderProcessEmail = {};
              this.tenderProcessEmail.companyCode = this.SelectedRecord.companyCode;
              this.tenderProcessEmail.tenderResponseStatus = this.SelectedRecord.tenderResponseStatus;
              //this.tenderProcessEmail.tenderResponseUser = this.displayResponseUser;
              this.tenderProcessEmail.tenderResponseDate = this.displayResponseDate;
              this.sendSubmitResponseEmail();
            }
            //write tender log
            this.WriteLogFieldHolder = JSON.parse('{"id": 0}');
            this.WriteLogFieldHolder.recordId = this.SelectedRecord.id;
            this.WriteLogFieldHolder.domainId = this.SelectedRecord.domainId;
            this.WriteLogFieldHolder.tenderLogCode = "40";
            this.WriteLogFieldHolder.companyCode = this.SelectedRecord.companyCode;
            this.WriteLogFieldHolder.createDate = this.bcp.getCurrentDateTime();
            this.WriteLogFieldHolder.createUser = this.bcp.getCurrentLoginUser();
            this.stringifyValue = JSON.stringify(this.WriteLogFieldHolder);
            this.http.post(this.LogApiPath + "WriteTenderLog/", this.stringifyValue, this.bcp.getHttpOptions())
              .subscribe((result: any[]) => {
                this.getLogDataByTender(this.SelectedRecord.domainId, this.SelectedRecord.companyCode, this.SelectedRecord.tenderId);
              });
          }
        } else if (this.SelectedRecord.tenderResponseType == 'S') {
          //Clear Search Form Error Message
          this.clearAllMessage();
          this.checkedError = 'N';
          //set submit data
          //this.SelectedRecord.tenderResponseStatus = 'SUBMITTED';
          this.SelectedRecord.responseUser = this.bcp.getCurrentLoginUser();
          this.SelectedRecord.responseDate = this.bcp.getCurrentDateTime();
          this.SelectedRecord.contractSum = this.enteredTotalAmount;
          //check submission time not overdue
          let currentDate = new Date();
          if (this.bcp.convertCalendarDateTimeToJson(currentDate) > this.bcp.convertCalendarDateTimeToJson(this.SelectedRecord.tenderDate03)) {
            this.checkedError = 'Y';
            this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Submission Time is overdue   ' });
          };
          //check contract sum
          if (this.enteredTotalAmount == 0) {
            this.checkedError = 'Y';
            this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Contract Sum is zero   ' });
          };
          //check contract sum
          this.fullUploadDoc = true;
          if (this.ResponseDocRecordList.length > 0) {
            await this.ResponseDocRecordList.forEach(line => {
              if (line.displayName.trim() == "") {
                this.fullUploadDoc = false;
              }
            })
          }
          if (!this.fullUploadDoc) {
            this.checkedError = 'Y';
            this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'All documents are required   ' });
          };
          //save record if no error
          if (this.checkedError == 'N') {
            this.SelectedRecord.tenderResponseStatus = 'SUBMITTED'
            this.ShowAddForm = false;
            this.ShowEditForm = false;
            this.ShowSubmissionForm = true;
          }
        }
      },
      reject: () => {
        //Do Nothing
      }
    });

  }


  confirmAward() {
    this.InputErrorMsg = [];
    this.clearAllMessage();
    this.confirmationService.confirm({
      message: 'Are you sure that you want to confirm award?',
      accept: async () => {
        this.SelectedRecord.tenderStatus = "AWARDED";
        await this.saveRecord();
        this.AwardTenderFieldHolder = JSON.parse('{"id": 0}');
        this.AwardTenderFieldHolder.domainId = this.SelectedRecord.domainId;
        this.AwardTenderFieldHolder.companyCode = this.SelectedRecord.companyCode;
        this.AwardTenderFieldHolder.tenderId = this.SelectedRecord.tenderId;
        this.AwardTenderFieldHolder.successAward = this.SelectedRecord.successAward;
        this.AwardTenderFieldHolder.awardCompanyCode = this.SelectedRecord.awardCompanyCode;
        this.stringifyValue = JSON.stringify(this.AwardTenderFieldHolder);
        this.http.put(this.PrimaryApiPath + "AwardTenderToSupplier/", this.stringifyValue, this.bcp.getHttpOptions())
          .subscribe((result: any[]) => {
            //remove lock record if awarded
            this.http.delete(this.LockApiPath + this.SelectedLockRecord.id, this.bcp.getHttpOptions())
              .subscribe(
                (data: any) => {
                  //do nothing
                });
            //send email to award contractor
            if (this.emailAwardTender) {
              this.tenderProcessEmail = {};
              this.tenderProcessEmail.companyCode = this.SelectedRecord.awardCompanyCode;
              this.sendAwardContractorEmail();
            }
            //send eamil to regret contractors
            if (this.emailAwardTender) {
              if (this.InvitationRecordList.length > 0) {
                this.InvitationRecordList.forEach(line => {
                  if (line.invitedCompanyCode != this.SelectedRecord.awardCompanyCode && line.tenderResponseStatus=="SUBMITTED" && line.withdrawFlag!="Y") {
                    this.tenderProcessEmail = {};
                    this.tenderProcessEmail.companyCode = line.invitedCompanyCode;
                    this.sendRegretContractorEmail();
                  }
                })
              }
            }
            // convert into boolean
            this.SelectedRecord.successAward = this.bcp.convertYesNoToBoolean(this.SelectedRecord.successAward);
            // write tender log for procurement
            this.WriteLogFieldHolder = JSON.parse('{"id": 0}');
            this.WriteLogFieldHolder.recordId = this.SelectedRecord.id;
            this.WriteLogFieldHolder.domainId = this.SelectedRecord.domainId;
            this.WriteLogFieldHolder.tenderLogCode = "50";
            this.WriteLogFieldHolder.companyCode = this.SelectedRecord.companyCode;
            this.WriteLogFieldHolder.createDate = this.bcp.getCurrentDateTime();
            this.WriteLogFieldHolder.createUser = this.bcp.getCurrentLoginUser();
            this.stringifyValue = JSON.stringify(this.WriteLogFieldHolder);
            this.http.post(this.LogApiPath + "WriteTenderLog/", this.stringifyValue, this.bcp.getHttpOptions())
              .subscribe((result: any[]) => {
                this.getLogDataByTender(this.SelectedRecord.domainId, this.SelectedRecord.companyCode, this.SelectedRecord.tenderId);
              });
            // write tender log for awarded supplier
            this.WriteLogFieldHolder = JSON.parse('{"id": 0}');
            this.WriteLogFieldHolder.recordId = this.SelectedRecord.id;
            this.WriteLogFieldHolder.domainId = this.SelectedRecord.domainId;
            this.WriteLogFieldHolder.tenderLogCode = "50";
            this.WriteLogFieldHolder.companyCode = this.SelectedRecord.awardCompanyCode;
            this.WriteLogFieldHolder.createDate = this.bcp.getCurrentDateTime();
            this.WriteLogFieldHolder.createUser = this.SelectedRecord.domainId;
            this.stringifyValue = JSON.stringify(this.WriteLogFieldHolder);
            this.http.post(this.LogApiPath + "WriteTenderLog/", this.stringifyValue, this.bcp.getHttpOptions())
              .subscribe((result: any[]) => {
                //no need to refresh log table for awarded supplier
              });
            // convert to project
            this.ConvertProjectFieldHolder = JSON.parse('{"id": 0}');
            this.ConvertProjectFieldHolder.domainId = this.SelectedRecord.domainId;
            this.ConvertProjectFieldHolder.companyCode = this.SelectedRecord.awardCompanyCode;
            this.ConvertProjectFieldHolder.projectId = this.SelectedRecord.tenderId;
            this.ConvertProjectFieldHolder.recordId = this.SelectedRecord.id;
            this.ConvertProjectFieldHolder.createUser = this.bcp.getCurrentLoginUser();
            this.ConvertProjectFieldHolder.createDate = this.bcp.getCurrentDateTime();
            this.stringifyValue = JSON.stringify(this.ConvertProjectFieldHolder);
            this.http.post(this.ProjectApiPath + "ConvertEtsProject/", this.stringifyValue, this.bcp.getHttpOptions())
              .subscribe((result: any[]) => {
                //do nothing
              });
          });
      },
      reject: () => {
        //Do Nothing
      }
    });

  }


  confirmAcceptAward() {
    this.InputErrorMsg = [];
    this.clearAllMessage();
    this.confirmationService.confirm({
      message: 'Are you sure that you want to confirm your choice of acceptance?',
      accept: async () => {
        await this.saveRecord();
        // write tender log
        this.WriteLogFieldHolder = JSON.parse('{"id": 0}');
        this.WriteLogFieldHolder.recordId = this.SelectedRecord.id;
        this.WriteLogFieldHolder.domainId = this.SelectedRecord.domainId;
        this.WriteLogFieldHolder.tenderLogCode = "60";
        this.WriteLogFieldHolder.companyCode = this.SelectedRecord.companyCode;
        this.WriteLogFieldHolder.createDate = this.bcp.getCurrentDateTime();
        this.WriteLogFieldHolder.createUser = this.bcp.getCurrentLoginUser();
        this.stringifyValue = JSON.stringify(this.WriteLogFieldHolder);
        this.http.post(this.LogApiPath + "WriteTenderLog/", this.stringifyValue, this.bcp.getHttpOptions())
          .subscribe((result: any[]) => {
            this.getLogDataByTender(this.SelectedRecord.domainId, this.SelectedRecord.companyCode, this.SelectedRecord.tenderId);
          });
      },
      reject: () => {
        //Do Nothing
      }
    });

  }


  //not used
  deleteRecord(pId) {
    if (window.confirm('Do you confirm to delete the selected record  ?')) {
      this.http.delete(this.PrimaryApiPath + pId, this.bcp.getHttpOptions())
        .subscribe(
          (data: any) => {
            this.findRecord();
          });
    }
  }


  deleteInvitationRecord(pId) {
    if (window.confirm('Do you confirm to delete the selected record  ?')) {
      this.http.delete(this.InvitationApiPath + pId, this.bcp.getHttpOptions())
        .subscribe(
          (data: any) => {
            this.getInvitationDataByTender(this.SelectedRecord.domainId, this.SelectedRecord.companyCode, this.SelectedRecord.tenderId);
          });
    }
  }


  deletePriceRecord(pId) {
    this.confirmationService.confirm({
      message: 'Do you confirm to delete the seleceted record ?',
      accept: () => {
        this.http.delete(this.PriceApiPath + pId, this.bcp.getHttpOptions())
          .subscribe(
            (data: any) => {
              this.getPriceDataByTender(this.SelectedRecord.domainId, this.SelectedRecord.companyCode, this.SelectedRecord.tenderId);
            });
      },
      reject: () => {
        //do nothing
      }
    });
  }


  deleteResponseDocRecord(pId) {
    if (window.confirm('Do you confirm to delete the selected record  ?')) {
      this.http.delete(this.DocumentApiPath + pId, this.bcp.getHttpOptions())
        .subscribe(
          (data: any) => {
            this.getResponseDocDataByTender(this.SelectedRecord.domainId, this.SelectedRecord.companyCode, this.SelectedRecord.tenderId, this.SelectedRecord.id);
          });
    }
  }


  deleteTender(pId) {
    this.confirmationService.confirm({
      message: 'Are you sure that you want to delete the selected tender ?',
      accept: () => {
        this.http.delete(this.PrimaryApiPath + "DeleteTender/" + pId, this.bcp.getHttpOptions())
          .subscribe(
            (data: any) => {
              this.findRecord();
            });
      },
      reject: () => {
        //Do Nothing
      }
    });
  }


  cancel() {
    this.findRecord();
    this.SelectedRecord = null;
    this.SelectedPriceRecord = null;
    this.SelectedDocumentRecord = null;
    //this.SelectedMessageRecord = null;
    this.RecordList = null;
    this.PriceRecordList = null;
    this.DocumentRecordList = null;
    this.MessageRecordList = null;
    this.ResponseDocRecordList = null;
    this.AwardPriceRecordList = null;
    this.specificationLineNumber = 0;
    this.documentLineNumber = 0;
    this.responseDocLineNumber = 0;
    this.InputErrorMsg = [];

    this.ShowAddForm = false;
    this.ShowEditForm = false;
    this.FormTitle = "Work With Tender Process";
    this.index = 0;

    this.clearAllMessage();
  }


  close() {
    //remove lock record if formally closing
    if (this.ShowAddForm == false && (this.SelectedRecord.tenderStatus == "OPEN" || this.SelectedRecord.tenderStatus == "CLOSED") && this.SelectedLockRecord.id>0) {
      this.http.delete(this.LockApiPath + this.SelectedLockRecord.id, this.bcp.getHttpOptions())
        .subscribe(
          (data: any) => {
            //do nothing
          });
    }
    //this.findRecord();
    this.SelectedRecord = null;
    this.SelectedLockRecord = null;
    this.SelectedPriceRecord = null;
    this.SelectedDocumentRecord = null;
    this.EnteredMessageRecord = null;
    this.SelectedMessageRecord = null;
    this.MessageReviewAttachmentList = null;
    this.HideMessage = true;
    this.seeAllCompanyMessage = false;
    this.Accept1 = false;
    this.Accept2 = false;
    this.RecordList = null;
    this.PriceRecordList = null;
    this.DocumentRecordList = null;
    this.MessageRecordList = null;
    this.ResponseDocRecordList = null;
    this.AwardPriceRecordList = null;
    this.specificationLineNumber = 0;
    this.documentLineNumber = 0;
    this.responseDocLineNumber = 0;
    this.InputErrorMsg = [];

    this.ShowAddForm = false;
    this.ShowEditForm = false;
    this.FormTitle = "Work With Tender Process";
    this.findRecord();
    this.index = 0;

    this.clearAllMessage();
  }

  //-----------------------------------------------------------------------------
  //                                  Tab Table
  //-----------------------------------------------------------------------------

  addNewPriceRow() {
    this.sortPriceTable(this.PriceRecordList);
    var blankRow: ITenderPrice;
    blankRow = null;
    blankRow = JSON.parse('{"id":0}');
    blankRow.part = "";
    blankRow.section = "";
    blankRow.longDescription = "";
    blankRow.quantityTendered = "";
    blankRow.unitPrice = "";
    blankRow.lineAmount = "";
    blankRow.optionalFlag = "N";
    blankRow.unitOfMeasure = "Sum";
    //clone the whole array to a tmpArray and add new blank row
    const tmpArray = [...this.PriceRecordList];
    tmpArray.push(blankRow);
    this.PriceRecordList = tmpArray;
    //prevent adding new line without entering
    this.newLinePendingTI = true;
    this.numberOfPriceLine = this.PriceRecordList.length;

  }


  addNewInvitationRow() {
    this.InvitationRecordList.sort((a, b) => (a.fullName > b.fullName ? 1 : -1));
    var blankRow: ITenderInvitation;
    blankRow = null;
    blankRow = JSON.parse('{"id":0}');
    blankRow.invitedCompanyCode = "";
    blankRow.generationFlag = "N";
    blankRow.withdrawFlag = "N";
    //clone the whole array to a tmpArray and add new blank row
    const tmpArray = [...this.InvitationRecordList];
    tmpArray.push(blankRow);
    this.InvitationRecordList = tmpArray;
    //prevent adding new line without entering
    this.newLinePendingCT = true;
  }


  addNewDocumentRow() {
    var blankRow: ITenderDocument;
    blankRow = null;
    blankRow = JSON.parse('{"id":0}');
    //incement line number by 1
    this.documentLineNumber = this.documentLineNumber + 1;
    blankRow.tenderDocumentType = "PPSL";
    blankRow.lineId = this.documentLineNumber;
    blankRow.tenderDocumentName = "";
    blankRow.tenderDocumentCategory = "";
    blankRow.documentNumber = "";
    blankRow.documentExpiryDate = "";
    blankRow.remark = "";
    blankRow.requestUploadFlag = "Y";
    blankRow.tenderRecordId = this.SelectedRecord.id;
    blankRow.createUser = "";
    blankRow.createDate = "";
    blankRow.uploadUser = "";
    blankRow.uploadDate = "";
    blankRow.downloadUser = "";
    blankRow.downloadDate = "";
    //clone the whole array to a tmpArray and add new blank row
    const tmpArray = [...this.DocumentRecordList];
    tmpArray.push(blankRow);
    this.DocumentRecordList = tmpArray;
    //prevent add new line before entering
    this.newLinePendingCD = true;

  }


  addNewMessageRow() {
    var blankRow: ITenderMessage;
    blankRow = null;
    blankRow = JSON.parse('{"id":0}');
    //clone the whole array to a tmpArray and add new blank row
    const tmpArray = [...this.MessageRecordList];
    tmpArray.push(blankRow);
    this.MessageRecordList = tmpArray;
  }


  addNewLogRow() {
    var blankRow: ITenderLog;
    blankRow = null;
    blankRow = JSON.parse('{"id":0}');
    //clone the whole array to a tmpArray and add new blank row
    const tmpArray = [...this.LogRecordList];
    tmpArray.push(blankRow);
    this.LogRecordList = tmpArray;
  }



  addNewResponseDocLine() {
    this.initResponseDocRecord();
    this.SelectedResponseDocRecord.domainId = this.SelectedRecord.domainId;
    this.SelectedResponseDocRecord.companyCode = this.inputDocumentCompany;
    this.SelectedResponseDocRecord.tenderId = this.SelectedRecord.tenderId;
    this.SelectedResponseDocRecord.tenderDocumentType = "PPSL";
    this.responseDocLineNumber = this.responseDocLineNumber + 1;
    this.SelectedResponseDocRecord.lineId = this.responseDocLineNumber;
    this.SelectedResponseDocRecord.tenderDocumentName = this.inputTenderDocumentName;
    this.SelectedResponseDocRecord.remark = this.inputRemark;
    this.SelectedResponseDocRecord.requestUploadFlag = "N";
    this.SelectedResponseDocRecord.tenderRecordId = this.SelectedRecord.id;
    this.SelectedResponseDocRecord.createUser = this.bcp.getCurrentLoginUser();
    this.SelectedResponseDocRecord.createDate = this.bcp.getCurrentDateTime();
    this.SelectedResponseDocRecord.updateUser = this.bcp.getCurrentLoginUser();
    this.SelectedResponseDocRecord.updateDate = this.bcp.getCurrentDateTime();
    this.saveResponseDocRecord();
  }


  processPriceTable() {
    this.addPriceRecord();
    this.SelectedPriceRecord.domainId = this.SelectedRecord.domainId;
    this.SelectedPriceRecord.companyCode = this.SelectedRecord.companyCode;
    this.SelectedPriceRecord.tenderId = this.SelectedRecord.tenderId;
    this.SelectedPriceRecord.tenderRecordId = this.newTenderRecordId;
    this.SelectedPriceRecord.createDate = this.bcp.getCurrentDateTime();
    this.SelectedPriceRecord.createUser = this.bcp.getCurrentLoginUser();
    //add part TOTAL for total amount
    if (this.ShowAddForm) {
      this.SelectedPriceRecord.part = "TOTAL";
      this.SelectedPriceRecord.section = 0;
      this.SelectedPriceRecord.longDescription = "Total Price";
      this.SelectedPriceRecord.quantityTendered = "";
      this.SelectedPriceRecord.optionalFlag = "";
      this.SelectedPriceRecord.unitOfMeasure = "";
      this.savePriceRecord();
    }
    //read every line and then save
    this.enteredTotalAmount = 0;
    if (this.PriceRecordList.length > 0) {
      for (var i = 0; i < this.PriceRecordList.length; i++) {
        if (this.PriceRecordList[i].part != "" && this.PriceRecordList[i].part != null && this.PriceRecordList[i].longDescription != "" && this.PriceRecordList[i].longDescription != null) {
          this.SelectedPriceRecord.id = this.PriceRecordList[i].id;
          this.SelectedPriceRecord.part = this.PriceRecordList[i].part;
          this.SelectedPriceRecord.part = this.bcp.upper(this.SelectedPriceRecord.part);
          this.SelectedPriceRecord.section = this.PriceRecordList[i].section;
          if (this.SelectedPriceRecord.section == "" || this.SelectedPriceRecord.section == "") {
            this.SelectedPriceRecord.section = 0;
          }
          this.SelectedPriceRecord.subSection = 0;
          this.SelectedPriceRecord.longDescription = this.PriceRecordList[i].longDescription;
          this.SelectedPriceRecord.quantityTendered = this.PriceRecordList[i].quantityTendered;
          //this.SelectedPriceRecord.quantityOffered = this.PriceRecordList[i].quantityOffered;
          this.SelectedPriceRecord.optionalFlag = this.PriceRecordList[i].optionalFlag;
          //this.SelectedPriceRecord.unitOfMeasure = this.bcp.upper(this.PriceRecordList[i].unitOfMeasure);
          this.SelectedPriceRecord.unitOfMeasure = this.PriceRecordList[i].unitOfMeasure;
          this.SelectedPriceRecord.unitPrice = this.PriceRecordList[i].unitPrice;
          this.SelectedPriceRecord.lineAmount = this.PriceRecordList[i].lineAmount;
          if (this.SelectedPriceRecord.optionalFlag!='Y') {
            this.enteredTotalAmount = this.enteredTotalAmount + this.PriceRecordList[i].lineAmount;
          }
          if (this.PriceRecordList[i].section<=0) {
            this.SelectedPriceRecord.quantityTendered = "";
            this.SelectedPriceRecord.optionalFlag = "";
            this.SelectedPriceRecord.unitOfMeasure = "";
          }
          this.savePriceRecord();
        }
      }
      this.savedTotalAmount = this.displayTotalAmount;
    }
    this.checkPriceInput();
  }


  processInvitationTable() {
    this.addInvitationRecord();
    this.SelectedInvitationRecord.domainId = this.SelectedRecord.domainId;
    this.SelectedInvitationRecord.companyCode = this.SelectedRecord.companyCode;
    this.SelectedInvitationRecord.tenderId = this.SelectedRecord.tenderId;
    this.SelectedInvitationRecord.tenderRecordId = this.newTenderRecordId;
    this.SelectedInvitationRecord.createDate = this.bcp.getCurrentDateTime();
    this.SelectedInvitationRecord.createUser = this.bcp.getCurrentLoginUser();
    this.SelectedInvitationRecord.updateDate = this.SelectedInvitationRecord.createDate;
    this.SelectedInvitationRecord.updateUser = this.SelectedInvitationRecord.createUser;
    if (this.InvitationRecordList.length > 0) {
      this.InvitationRecordList.forEach(line => {
        if (line.invitedCompanyCode != "" && line.invitedCompanyCode != null) {
          this.SelectedInvitationRecord.id = line.id;
          this.SelectedInvitationRecord.invitedCompanyCode = line.invitedCompanyCode;
          this.SelectedInvitationRecord.companyNumber = line.companyNumber;
          this.SelectedInvitationRecord.generationFlag = line.generationFlag;
          this.SelectedInvitationRecord.withdrawFlag = line.withdrawFlag;
          this.saveInvitationRecord();
        }
      })
    }

  }


  //porcess attachment tab
  processSpecificationTable() {
    if (this.SpecificationRecordList.length > 0) {
      this.SpecificationRecordList.forEach(line => {
        if (line.lineId != 0) {
          this.initSpecificationRecord();
          this.SelectedSpecificationRecord.id = line.id;
          this.SelectedSpecificationRecord.domainId = this.SelectedRecord.domainId;
          this.SelectedSpecificationRecord.companyCode = this.inputDocumentCompany;
          this.SelectedSpecificationRecord.tenderId = this.SelectedRecord.tenderId;
          //this.SelectedSpecificationRecord.tenderDocumentType = "SPEC";
          this.SelectedSpecificationRecord.lineId = line.lineId;
          this.SelectedSpecificationRecord.tenderDocumentName = line.tenderDocumentName;
          //this.SelectedSpecificationRecord.tenderDocumentCategory = "";
          //this.SelectedSpecificationRecord.documentNumber = "";
          //this.SelectedSpecificationRecord.documentExpiryDate = "";
          this.SelectedSpecificationRecord.remark = line.remark;
          //this.SelectedSpecificationRecord.requestUploadFlag = "N";
          this.SelectedSpecificationRecord.tenderRecordId = this.SelectedRecord.id;
          this.SelectedSpecificationRecord.createUser = line.createUser;
          this.SelectedSpecificationRecord.createDate = line.createDate;
          this.SelectedSpecificationRecord.uploadUser = line.uploadUser;
          this.SelectedSpecificationRecord.uploadDate = line.uploadDate;
          this.SelectedSpecificationRecord.downloadUser = line.downloadUser;
          this.SelectedSpecificationRecord.downloadDate = line.downloadDate;
          this.SelectedSpecificationRecord.updateUser = this.bcp.getCurrentLoginUser();
          this.SelectedSpecificationRecord.updateDate = this.bcp.getCurrentDateTime();
          //console.log("updating line is " + line.lineId);
          this.saveSpecificationRecord();
        }
      })
    }

  }


  //process contractor document tab
  processDocumentTable() {
    if (this.DocumentRecordList.length > 0) {
      this.DocumentRecordList.forEach(line => {
        if (line.lineId != 0 && line.tenderDocumentName != "" && line.tenderDocumentName != null) {
          this.initDocumentRecord();
          this.SelectedDocumentRecord.id = line.id;
          this.SelectedDocumentRecord.domainId = this.SelectedRecord.domainId;
          this.SelectedDocumentRecord.companyCode = this.inputDocumentCompany;
          this.SelectedDocumentRecord.tenderId = this.SelectedRecord.tenderId;
          //this.SelectedDocumentRecord.tenderDocumentType = "PPSL";
          this.SelectedDocumentRecord.lineId = line.lineId;
          this.SelectedDocumentRecord.tenderDocumentName = line.tenderDocumentName;
         // this.SelectedDocumentRecord.tenderDocumentCategory = line.tenderDocumentCategory;
          //this.SelectedDocumentRecord.documentNumber = line.documentNumber;
          //this.SelectedDocumentRecord.documentExpiryDate = line.documentExpiryDate;
          this.SelectedDocumentRecord.remark = line.remark;
          //this.SelectedDocumentRecord.requestUploadFlag = line.requestUploadFlag;
          this.SelectedDocumentRecord.tenderRecordId = this.SelectedRecord.id;
          this.SelectedDocumentRecord.createUser = line.createUser;
          this.SelectedDocumentRecord.createDate = line.createDate;
          this.SelectedDocumentRecord.uploadUser = line.uploadUser;
          this.SelectedDocumentRecord.uploadDate = line.uploadDate;
          this.SelectedDocumentRecord.downloadUser = line.downloadUser;
          this.SelectedDocumentRecord.downloadDate = line.downloadDate;
          this.SelectedDocumentRecord.updateUser = this.bcp.getCurrentLoginUser();
          this.SelectedDocumentRecord.updateDate = this.bcp.getCurrentDateTime();
          this.saveDocumentRecord();
        }
      })
    }

  }


  //no need to process until line field is required for update
  async processResponseDocTable() {
    if (this.ResponseDocRecordList.length > 0) {
      await this.ResponseDocRecordList.forEach(line => {
        if (line.tenderDocumentCategory.trim() != "") {
          this.initResponseDocRecord();
          this.SelectedResponseDocRecord.id = line.id;
          this.SelectedResponseDocRecord.domainId = this.SelectedRecord.domainId;
          this.SelectedResponseDocRecord.companyCode = this.inputDocumentCompany;
          this.SelectedResponseDocRecord.tenderId = this.SelectedRecord.tenderId;
          this.SelectedResponseDocRecord.tenderDocumentType = "PPSL";
          this.SelectedResponseDocRecord.lineId = line.lineId;
          this.SelectedResponseDocRecord.tenderDocumentName = line.tenderDocumentName;
          this.SelectedResponseDocRecord.tenderDocumentCategory = line.tenderDocumentCategory;
          this.SelectedResponseDocRecord.documentNumber = line.documentNumber;
          this.SelectedResponseDocRecord.documentExpiryDate = line.documentExpiryDate;
          this.SelectedResponseDocRecord.remark = line.remark;
          this.SelectedResponseDocRecord.requestUploadFlag = line.requestUploadFlag;
          this.SelectedResponseDocRecord.tenderRecordId = this.SelectedRecord.id;
          this.SelectedResponseDocRecord.createUser = line.createUser;
          this.SelectedResponseDocRecord.createDate = line.createDate;
          this.SelectedResponseDocRecord.uploadUser = line.uploadUser;
          this.SelectedResponseDocRecord.uploadDate = line.uploadDate;
          this.SelectedResponseDocRecord.downloadUser = line.downloadUser;
          this.SelectedResponseDocRecord.downloadDate = line.downloadDate;
          this.SelectedResponseDocRecord.updateUser = this.bcp.getCurrentLoginUser();
          this.SelectedResponseDocRecord.updateDate = this.bcp.getCurrentDateTime();
          this.saveResponseDocRecord();
        }
      })
    }
    this.getResponseDocDataByTender(this.SelectedRecord.domainId, this.SelectedRecord.companyCode, this.SelectedRecord.tenderId, this.SelectedRecord.id);

  }


  sortAwardPriceInSeq() {
    this.UpdateTenderPriceFieldHolder = JSON.parse('{"id": 0}');
    this.UpdateTenderPriceFieldHolder.domainId = this.SelectedRecord.domainId;
    this.UpdateTenderPriceFieldHolder.tenderId = this.SelectedRecord.tenderId;
    this.stringifyValue = JSON.stringify(this.UpdateTenderPriceFieldHolder);
    this.http.put(this.PriceApiPath + "PutTenderPriceSeq/", this.stringifyValue, this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        this.getAwardPriceDataBySeq(this.SelectedRecord.domainId, this.SelectedRecord.companyCode, this.SelectedRecord.tenderId);
      });
  }


  sortAwardPriceInCo() {
    this.UpdateTenderPriceFieldHolder = JSON.parse('{"id": 0}');
    this.UpdateTenderPriceFieldHolder.domainId = this.SelectedRecord.domainId;
    this.UpdateTenderPriceFieldHolder.tenderId = this.SelectedRecord.tenderId;
    this.stringifyValue = JSON.stringify(this.UpdateTenderPriceFieldHolder);
    this.http.put(this.PriceApiPath + "PutTenderPriceSeq/", this.stringifyValue, this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        if (this.inputPriceCompany.trim()!="") {
          this.getAwardPriceDataByCo(this.SelectedRecord.domainId, this.inputPriceCompany, this.SelectedRecord.tenderId);
        }
      });
  }


  checkPriceDataEntry(part: string, longDescription: string, indexNumber: number) {
    this.PriceRecordList[indexNumber].part = this.bcp.upper(this.PriceRecordList[indexNumber].part);
    if (part != "" && part != null && longDescription != "" && longDescription != null) {
      this.resetNewLinePending("TI");
    } else {
      this.newLinePendingTI = true;
    }
  }


  checkQuantityDataEntry(quantityTendered: number, indexNumber: number) {
    this.PriceRecordList[indexNumber].quantityTendered = Math.abs(this.PriceRecordList[indexNumber].quantityTendered);
    quantityTendered = this.PriceRecordList[indexNumber].quantityTendered;
  }


  checkDocumentDataEntry(tenderDocumentName: string, indexNumber: number) {
    if (tenderDocumentName != "" && tenderDocumentName != null) {
      this.resetNewLinePending("CD");
    } else {
      this.newLinePendingCD = true;
    }
  }


  getCompanyDataByCode(companyCode: string, indexNumber: number) {
    if (companyCode != "" && companyCode != null) {
      this.http.get(this.CompanyApiPath + "GetID/" + this.SelectedRecord.domainId + "/" + companyCode, this.bcp.getHttpOptions())
        .subscribe((result: any) => {
          this.CompanyDataSet = result;
          this.InvitationRecordList[indexNumber].fullName = this.CompanyDataSet.fullName;
          this.InvitationRecordList[indexNumber].companyNumber = this.CompanyDataSet.companyNumber;
        });
      this.resetNewLinePending("CT");
    } else {
      this.InvitationRecordList[indexNumber].fullName = "";
      this.InvitationRecordList[indexNumber].companyNumber = "";
      this.newLinePendingCT = true;
    }

  }


  getCompanyDataByNumber(companyNumber: number, indexNumber: number) {
    this.CompanyDataSet = null;
    this.InvitationRecordList[indexNumber].fullName = "";
    this.InvitationRecordList[indexNumber].invitedCompanyCode = "";
    this.http.get(this.CompanyApiPath + "GetCompanyDatabyNumber/" + this.SelectedRecord.domainId + "/" + companyNumber, this.bcp.getHttpOptions())
      .subscribe((result: any) => {
        this.CompanyDataSet = result;
        if (this.CompanyDataSet.companyCode.trim() != "") {
          this.InvitationRecordList[indexNumber].fullName = this.CompanyDataSet.fullName;
          this.InvitationRecordList[indexNumber].invitedCompanyCode = this.CompanyDataSet.companyCode;
        }
      });
    this.resetNewLinePending("CT");
  }


  calculateTotalAmount(quantityTendered: number, unitPrice: number, indexNumber: number) {
    this.PriceRecordList[indexNumber].unitPrice = Math.abs(this.PriceRecordList[indexNumber].unitPrice);
    unitPrice = this.PriceRecordList[indexNumber].unitPrice;
    this.PriceRecordList[indexNumber].unitPrice = this.bcp.roundToDP(unitPrice, 2);
    this.PriceRecordList[indexNumber].lineAmount = this.bcp.roundToDP(quantityTendered * unitPrice, 2);
    let num = 0;
    if (this.PriceRecordList.length > 0) {
      for (var i = 0; i < this.PriceRecordList.length; i++) {
        if (this.PriceRecordList[i].optionalFlag!='Y') {
          num = num + this.PriceRecordList[i].lineAmount;
        }
      }
    }
    this.displayTotalAmount = num.toLocaleString(undefined, {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2
    });
  }


  generateTenderToSuppliers() {
    if (this.InvitationRecordList.length > 0) {
      this.InvitationRecordList.forEach((line,index) => {
        if (line.invitedCompanyCode.length > 0) {
          if (line.generationFlag != 'Y') {
            line.generationFlag = 'Y';
            this.CopyTenderFieldHolder = JSON.parse('{"id": 0}');
            this.CopyTenderFieldHolder.domainId = this.SelectedRecord.domainId;
            this.CopyTenderFieldHolder.tenderId = this.SelectedRecord.tenderId;
            this.CopyTenderFieldHolder.recordId = this.SelectedRecord.id;
            this.CopyTenderFieldHolder.invitedCompanyCode = line.invitedCompanyCode;
            this.CopyTenderFieldHolder.createUser = this.bcp.getCurrentLoginUser();
            this.CopyTenderFieldHolder.createDate = this.bcp.getCurrentDateTime();
            this.stringifyValue = JSON.stringify(this.CopyTenderFieldHolder);
            this.http.post(this.PrimaryApiPath + "CopyTenderToSupplier/", this.stringifyValue, this.bcp.getHttpOptions())
              .subscribe((result: any[]) => {
                // write tender log
                this.WriteLogFieldHolder = JSON.parse('{"id": 0}');
                this.WriteLogFieldHolder.recordId = this.SelectedRecord.id;
                this.WriteLogFieldHolder.domainId = this.SelectedRecord.domainId;
                this.WriteLogFieldHolder.tenderLogCode = "10";
                this.WriteLogFieldHolder.companyCode = line.invitedCompanyCode;
                this.WriteLogFieldHolder.createDate = this.bcp.getCurrentDateTime();
                this.WriteLogFieldHolder.createUser = this.SelectedRecord.domainId;
                this.stringifyValue = JSON.stringify(this.WriteLogFieldHolder);
                this.http.post(this.LogApiPath + "WriteTenderLog/", this.stringifyValue, this.bcp.getHttpOptions())
                  .subscribe((result: any[]) => {
                    // do nothing
                  });
                //send email to contractor user
                if (this.emailInviteContractor) {
                  this.tenderProcessEmail = {};
                  this.tenderProcessEmail.companyCode = line.invitedCompanyCode;
                  this.sendInviteTenderEmail();
                }
                //close at the last iteration
                if (index == this.InvitationRecordList.length-1) {
                  //this.close();
                }
              });
          };
        }
      })
      //this.getLogDataByTender(this.SelectedRecord.domainId, this.inputLogCompany, this.SelectedRecord.tenderId);
      //this.close();
    }
  }


  resetNewLinePending(code: string) {
    if (code == "CD") {
      this.newLinePendingCD = false;
    } else if (code == "CT") {
      this.newLinePendingCT = false;
    } else if (code == "TI") {
      this.newLinePendingTI = false;
    }
  }


  addNewMessage() {
    this.NewMessageFlag = true;
    //delete temp new message attachments
    this.http.delete(this.AttachmentApiPath + "DeleteAttachmentByKey/" + this.SelectedRecord.domainId + "/BcpLock/" + this.SelectedLockRecord.id, this.bcp.getHttpOptions())
      .subscribe(
        (data: any) => {
          //do nothing
        });
  }


  cancelNewMessageRecord() {
    this.NewMessageFlag = false;
    //reset new message working fields
    this.initMessageEnteredRecord();
    this.MessageNewAttachmentAutoReload = false;
    //delete temp new message attachments
    this.http.delete(this.AttachmentApiPath + "DeleteAttachmentByKey/" + this.SelectedRecord.domainId + "/BcpLock/" + this.SelectedLockRecord.id, this.bcp.getHttpOptions())
      .subscribe(
        (data: any) => {
          //do nothing
        });
  }

  //-----------------------------------------------------------------------------
  //                                  Attachment
  //-----------------------------------------------------------------------------

  //set file object for upload when file is selected
  selectUploadFile(event: any) {
    for (let file of event.files) {
      this.uploadFile = file;
    }
  }


  //upload the selected attachment for Document tab
  async processUploadFile(event, fileUpload) {

    this.SuccessUpload = false;
    

    if (this.uploadFile) {

      this.initSpecificationRecord();
      this.SelectedSpecificationRecord.id = 0;
      await this.createSpecificationRecord(this.inputDocumentCompany, this.inputNewTenderDocumentName, this.inputNewDocumentRemark);
      this.newDocumentRecordId = await this.http.get(this.DocumentApiPath + "GetID/" + this.SelectedRecord.domainId + "/" + this.inputDocumentCompany + "/" + this.SelectedRecord.tenderId + "/SPEC/" + this.specificationLineNumber, this.bcp.getHttpOptions()).toPromise();
      var sourceRecordId = this.newDocumentRecordId;

      var filePrefix: String;
      filePrefix = "BCP_ID" + ("0000000000" + sourceRecordId).substr(-10);
      filePrefix = filePrefix + "_" + this.bcp.convertDateToString() + "_";

      let fileToUpload = this.uploadFile;
      let formData: FormData = new FormData();

      formData.append(fileToUpload.name, fileToUpload, filePrefix + fileToUpload.name);
      formData.append("DomainId", this.SelectedRecord.domainId);
      formData.append("SourceTableName", "EtsDocument");
      formData.append("SourceRecordId", this.newDocumentRecordId);
      formData.append("UpdateUser", this.bcp.getCurrentLoginUser());

      let headers = new HttpHeaders();
      console.log("file name is " + fileToUpload.name);
      //save attachment record
      this.http.post(this.AttachmentApiPath + "UploadFile/" + sourceRecordId, formData, this.bcp.getHttpOptionsAtt())
        .subscribe((r: any) => {
          var result = JSON.parse(r);
          if (result.message == "succeed") {
            this.SuccessUpload = true;
            this.resultMsgs = [{ severity: 'info', summary: 'Confirmed', detail: 'File uploaded successfully' }];
            // write tender doc log
            this.WriteDocLogFieldHolder = JSON.parse('{"id": 0}');
            this.WriteDocLogFieldHolder.recordId = this.SelectedRecord.id;
            this.WriteDocLogFieldHolder.domainId = this.SelectedRecord.domainId;
            this.WriteDocLogFieldHolder.tenderLogCode = "72";
            this.WriteDocLogFieldHolder.companyCode = this.SelectedRecord.companyCode;
            this.WriteDocLogFieldHolder.tenderDocumentName = this.inputNewTenderDocumentName;
            this.WriteDocLogFieldHolder.displayName = fileToUpload.name;
            this.WriteDocLogFieldHolder.invitedCompanyCode = "";
            this.WriteDocLogFieldHolder.createDate = this.bcp.getCurrentDateTime();
            this.WriteDocLogFieldHolder.createUser = this.bcp.getCurrentLoginUser();
            this.stringifyValue = JSON.stringify(this.WriteDocLogFieldHolder);
            this.http.post(this.LogApiPath + "WriteTenderDocLog/", this.stringifyValue, this.bcp.getHttpOptions())
              .subscribe((result: any[]) => {
                //do nothing
              });
            //reset input variables
            this.inputNewTenderDocumentName = "";
            this.inputNewDocumentRemark = "";
            //refresh table
            this.getSpecificationDataByTender(this.SelectedRecord.domainId, this.inputDocumentCompany, this.SelectedRecord.tenderId);
            fileUpload.clear();
          } else {
            this.resultMsgs = [{ severity: 'info', summary: 'Confirmed', detail: result.message }];
          }
        });
      //write

    }

  }


  //upload the selected attachment for Response tab
  async processResponseUploadFile(event, fileUpload, sourceRecordId: any, tenderDocumentName: any) {

    this.SuccessUpload = false;
    

    if (this.uploadFile) {

      var filePrefix: String;
      filePrefix = "BCP_ID" + ("0000000000" + sourceRecordId).substr(-10);
      filePrefix = filePrefix + "_" + this.bcp.convertDateToString() + "_";

      let fileToUpload = this.uploadFile;
      let formData: FormData = new FormData();

      formData.append(fileToUpload.name, fileToUpload, filePrefix + fileToUpload.name);
      formData.append("DomainId", this.SelectedRecord.domainId);
      formData.append("SourceTableName", "EtsDocument");
      formData.append("SourceRecordId", sourceRecordId);
      formData.append("UpdateUser", this.bcp.getCurrentLoginUser());

      let headers = new HttpHeaders();

      //save attachment record
      this.http.post(this.AttachmentApiPath + "UploadFile/"  + sourceRecordId, formData, this.bcp.getHttpOptionsAtt())
        .subscribe((r: any) => {
          var result = JSON.parse(r);
          if (result.message == "succeed") {
            this.SuccessUpload = true;
            this.resultMsgs = [{ severity: 'info', summary: 'Confirmed', detail: 'File uploaded successfully' }];
            // write tender doc log
            this.WriteDocLogFieldHolder = JSON.parse('{"id": 0}');
            this.WriteDocLogFieldHolder.recordId = this.SelectedRecord.id;
            this.WriteDocLogFieldHolder.domainId = this.SelectedRecord.domainId;
            this.WriteDocLogFieldHolder.tenderLogCode = "72";
            this.WriteDocLogFieldHolder.companyCode = this.SelectedRecord.companyCode;
            this.WriteDocLogFieldHolder.tenderDocumentName = tenderDocumentName;
            this.WriteDocLogFieldHolder.displayName = fileToUpload.name;
            this.WriteDocLogFieldHolder.invitedCompanyCode = "";
            this.WriteDocLogFieldHolder.createDate = this.bcp.getCurrentDateTime();
            this.WriteDocLogFieldHolder.createUser = this.bcp.getCurrentLoginUser();
            this.stringifyValue = JSON.stringify(this.WriteDocLogFieldHolder);
            this.http.post(this.LogApiPath + "WriteTenderDocLog/", this.stringifyValue, this.bcp.getHttpOptions())
              .subscribe((result: any[]) => {
                //do nothing
              });
            //refresh response document table
            this.getResponseDocDataByTender(this.SelectedRecord.domainId, this.SelectedRecord.companyCode, this.SelectedRecord.tenderId, this.SelectedRecord.id);
            fileUpload.clear();
          } else {
            this.resultMsgs = [{ severity: 'info', summary: 'Confirmed', detail: result.message }];
          }
          
        });
    }

  }


  //upload the decline letter for Response tab
  async processDeclineUploadFile(event, fileUpload, sourceRecordId: any) {

    this.SuccessUpload = false;
    

    if (this.uploadFile) {

      var filePrefix: String;
      filePrefix = "BCP_ID" + ("0000000000" + sourceRecordId).substr(-10);
      filePrefix = filePrefix + "_" + this.bcp.convertDateToString() + "_";

      let fileToUpload = this.uploadFile;
      let formData: FormData = new FormData();

      formData.append(fileToUpload.name, fileToUpload, filePrefix + fileToUpload.name);
      formData.append("DomainId", this.SelectedRecord.domainId);
      formData.append("SourceTableName", "EtsTender");
      formData.append("SourceRecordId", sourceRecordId);
      formData.append("UpdateUser", this.bcp.getCurrentLoginUser());

      let headers = new HttpHeaders();

      //save attachment record
      this.http.post(this.AttachmentApiPath + "UploadFile/" + sourceRecordId, formData, this.bcp.getHttpOptionsAtt())
        .subscribe((r: any) => {
          var result = JSON.parse(r);
          if (result.message == "succeed") {
            this.SuccessUpload = true;
            this.resultMsgs = [{ severity: 'info', summary: 'Confirmed', detail: 'File uploaded successfully' }];
            this.getResponseDocDataByTender(this.SelectedRecord.domainId, this.SelectedRecord.companyCode, this.SelectedRecord.tenderId, this.SelectedRecord.id);
            fileUpload.clear();
          } else {
            this.resultMsgs = [{ severity: 'info', summary: 'Confirmed', detail: result.message }];
          }
          
          
        });
    }

  }


  //upload withdraw letter and update flag for Invitation tab
  async processWithdrawUploadFile(event, fileUpload, sourceRecordId: any, invitedCompanyCode: any) {

    this.SuccessUpload = false;
    
    if (this.uploadFile) {

      var filePrefix: String;
      filePrefix = "BCP_ID" + ("0000000000" + sourceRecordId).substr(-10);
      filePrefix = filePrefix + "_" + this.bcp.convertDateToString() + "_";

      let fileToUpload = this.uploadFile;
      let formData: FormData = new FormData();

      formData.append(fileToUpload.name, fileToUpload, filePrefix + fileToUpload.name);
      formData.append("DomainId", this.SelectedRecord.domainId);
      formData.append("SourceTableName", "EtsTender");
      formData.append("SourceRecordId", sourceRecordId);
      formData.append("UpdateUser", this.bcp.getCurrentLoginUser());

      let headers = new HttpHeaders();

      //save attachment record
      this.http.post(this.AttachmentApiPath + "UploadFile/" + sourceRecordId, formData, this.bcp.getHttpOptionsAtt())
        .subscribe((r : any) => {
          var result = JSON.parse(r);
          if (result.message == "succeed") {
            this.SuccessUpload = true;
            this.resultMsgs = [{ severity: 'info', summary: 'Confirmed', detail: 'File uploaded successfully' }];
            //update withdraw flag
            this.WithdrawTenderFieldHolder = null;
            this.WithdrawTenderFieldHolder = JSON.parse('{"id": 0}');
            this.WithdrawTenderFieldHolder.id = sourceRecordId;
            this.WithdrawTenderFieldHolder.withdrawUser = this.bcp.getCurrentLoginUser();
            this.WithdrawTenderFieldHolder.withdrawDate = this.bcp.getCurrentDateTime();
            this.WithdrawTenderFieldHolder.reverseFlag = 'N';
            this.stringifyValue = JSON.stringify(this.WithdrawTenderFieldHolder);
            this.http.put(this.InvitationApiPath + "WithdrawTender/", this.stringifyValue, this.bcp.getHttpOptions())
              .subscribe((result: any[]) => {
                //refresh price summy
                this.GenPriceSummary = JSON.parse('{"id": 0}');
                this.GenPriceSummary.domainId = this.SelectedRecord.domainId;
                this.GenPriceSummary.tenderId = this.SelectedRecord.tenderId;
                this.GenPriceSummary.createUser = this.bcp.getCurrentLoginUser();
                this.GenPriceSummary.createDate = this.bcp.getCurrentDateTime();
                this.stringifyValue = JSON.stringify(this.GenPriceSummary);
                this.http.post(this.PrimaryApiPath + "GenPriceSummary/", this.stringifyValue, this.bcp.getHttpOptions())
                  .subscribe((result: any[]) => {
                    //do nothing
                  });
                // write tender log
                this.WriteLogFieldHolder = JSON.parse('{"id": 0}');
                this.WriteLogFieldHolder.recordId = this.SelectedRecord.id;
                this.WriteLogFieldHolder.domainId = this.SelectedRecord.domainId;
                this.WriteLogFieldHolder.tenderLogCode = "41";
                this.WriteLogFieldHolder.companyCode = invitedCompanyCode;
                this.WriteLogFieldHolder.createDate = this.bcp.getCurrentDateTime();
                this.WriteLogFieldHolder.createUser = this.bcp.getCurrentLoginUser();
                this.stringifyValue = JSON.stringify(this.WriteLogFieldHolder);
                this.http.post(this.LogApiPath + "WriteTenderLog/", this.stringifyValue, this.bcp.getHttpOptions())
                  .subscribe((result: any[]) => {
                    this.getLogDataByTender(this.SelectedRecord.domainId, this.inputLogCompany, this.SelectedRecord.tenderId);
                  });
                //reload data for Invitation tab
                this.getInvitationDataByTender(this.SelectedRecord.domainId, this.SelectedRecord.companyCode, this.SelectedRecord.tenderId);
                this.getCompanyListResponsed(this.SelectedRecord.domainId, this.SelectedRecord.tenderId);
                fileUpload.clear();
              });
          } else {
            this.resultMsgs = [{ severity: 'info', summary: 'Confirmed', detail: result.message }];
          }
        });
    }

  }


  //upload the selected attachment for Award tab
  async processAwardUploadFile(event, fileUpload, sourceRecordId: any) {

    this.SuccessUpload = false;
    this.AttachmentAutoReload = false;

    if (this.uploadFile) {

      var filePrefix: String;
      filePrefix = "BCP_ID" + ("0000000000" + sourceRecordId).substr(-10);
      filePrefix = filePrefix + "_" + this.bcp.convertDateToString() + "_";

      let fileToUpload = this.uploadFile;
      let formData: FormData = new FormData();

      formData.append(fileToUpload.name, fileToUpload, filePrefix + fileToUpload.name);
      formData.append("DomainId", this.SelectedRecord.domainId);
      formData.append("SourceTableName", "EtsTender");
      formData.append("SourceRecordId", sourceRecordId);
      formData.append("UpdateUser", this.bcp.getCurrentLoginUser());

      let headers = new HttpHeaders();

      //save attachment record
      this.http.post(this.AttachmentApiPath + "UploadFile/" + sourceRecordId, formData, this.bcp.getHttpOptionsAtt())
        .subscribe((r : any) => {
          var result = JSON.parse(r);
          if (result.message == "succeed") {
            this.SuccessUpload = true;
            this.AttachmentAutoReload = true;
            this.getAttachmentList(sourceRecordId);
            this.resultMsgs = [{ severity: 'info', summary: 'Confirmed', detail: 'File uploaded successfully' }];
            fileUpload.clear();
          } else {
            this.resultMsgs = [{ severity: 'info', summary: 'Confirmed', detail: result.message }];
          }

        });
    }

  }


  //upload the selected attachment for Message tab - new message
  async processMessageNewUploadFile(event, fileUpload, sourceRecordId: any) {

    this.SuccessUpload = false;
    this.MessageNewAttachmentAutoReload = false;

    if (this.uploadFile) {

      var filePrefix: String;
      filePrefix = "BCP_ID" + ("0000000000" + sourceRecordId).substr(-10);
      filePrefix = filePrefix + "_" + this.bcp.convertDateToString() + "_";

      let fileToUpload = this.uploadFile;
      let formData: FormData = new FormData();

      formData.append(fileToUpload.name, fileToUpload, filePrefix + fileToUpload.name);
      formData.append("DomainId", this.SelectedRecord.domainId);
      formData.append("SourceTableName", "BcpLock");
      formData.append("SourceRecordId", sourceRecordId);
      formData.append("UpdateUser", this.bcp.getCurrentLoginUser());

      let headers = new HttpHeaders();

      //save attachment record
      this.http.post(this.AttachmentApiPath + "UploadFile/" + sourceRecordId, formData, this.bcp.getHttpOptionsAtt())
        .subscribe((r : any) => {
          var result = JSON.parse(r);
          if (result.message == "succeed") {
            this.SuccessUpload = true;
            this.MessageNewAttachmentAutoReload = true;
            this.getMessageNewAttachmentList(sourceRecordId);
            this.resultMsgs = [{ severity: 'info', summary: 'Confirmed', detail: 'File uploaded successfully' }];
            fileUpload.clear();
          } else {
            this.resultMsgs = [{ severity: 'info', summary: 'Confirmed', detail: result.message }];
          }
        });
    }

  }


  //upload the selected attachment for Message tab - review message
  async processMessageReviewUploadFile(event, fileUpload, sourceRecordId: any) {

    this.SuccessUpload = false;
    this.MessageReviewAttachmentAutoReload = false;

    if (this.uploadFile) {

      var filePrefix: String;
      filePrefix = "BCP_ID" + ("0000000000" + sourceRecordId).substr(-10);
      filePrefix = filePrefix + "_" + this.bcp.convertDateToString() + "_";

      let fileToUpload = this.uploadFile;
      let formData: FormData = new FormData();

      formData.append(fileToUpload.name, fileToUpload, filePrefix + fileToUpload.name);
      formData.append("DomainId", this.SelectedRecord.domainId);
      formData.append("SourceTableName", "EtsMessage");
      formData.append("SourceRecordId", sourceRecordId);
      formData.append("UpdateUser", this.bcp.getCurrentLoginUser());

      let headers = new HttpHeaders();

      //save attachment record
      this.http.post(this.AttachmentApiPath + "UploadFile/"  + sourceRecordId, formData, this.bcp.getHttpOptionsAtt())
        .subscribe((r : any) => {
          var result = JSON.parse(r);
          if (result.message == "succeed") {
            this.SuccessUpload = true;
            this.MessageReviewAttachmentAutoReload = true;
            this.getMessageReviewAttachmentList(sourceRecordId);
            this.resultMsgs = [{ severity: 'info', summary: 'Confirmed', detail: 'File uploaded successfully' }];
            fileUpload.clear();
          } else {
            this.resultMsgs = [{ severity: 'info', summary: 'Confirmed', detail: result.message }];
          }
        });
    }

  }


  //download attachment by click on the filename
  downloadFile(recordID, fileName) {
    //this.http.get(this.AttachmentApiPath + "File/" + recordID, { 'responseType': 'blob'} )
    this.http.get(this.AttachmentApiPath + "DownloadFile/" + recordID, this.bcp.getHttpOptionsAtt("blob"))
      .catch((err) => { return Observable.throw(err); })
      .subscribe((result: HttpResponse<Blob>) => {
        var returnFilename = this.bcp.getFilenameFromHttpResponse(result.headers.get('content-disposition'));

        if (window.navigator.msSaveOrOpenBlob) { // for IE and Edge
          var blob = new Blob([result.body]);
          window.navigator.msSaveOrOpenBlob(blob, returnFilename);
        } else {
          var a = document.createElement("a");
          var blob = new Blob([result.body]);
          a.href = URL.createObjectURL(result.body);
          a.download = returnFilename;
          a.click();
        }
      })
  }


  //download attachment for Attachment tab
  downloadDocumentFile(recordID, tenderDocumentName, displayName) {
    //this.http.get(this.AttachmentApiPath + "File/" + recordID, { 'responseType': 'blob'} )
    this.http.get(this.AttachmentApiPath + "DownloadFile/" + recordID, this.bcp.getHttpOptionsAtt("blob"))
      .catch((err) => { return Observable.throw(err); })
      .subscribe((result: HttpResponse<Blob>) => {
        var returnFilename = this.bcp.getFilenameFromHttpResponse(result.headers.get('content-disposition'));

        if (window.navigator.msSaveOrOpenBlob) { // for IE and Edge
          var blob = new Blob([result.body]);
          window.navigator.msSaveOrOpenBlob(blob, returnFilename);
        } else {
          var a = document.createElement("a");
          var blob = new Blob([result.body]);
          a.href = URL.createObjectURL(result.body);
          a.download = returnFilename;
          a.click();
        }
        // write tender doc log
        this.WriteDocLogFieldHolder = JSON.parse('{"id": 0}');
        this.WriteDocLogFieldHolder.recordId = this.SelectedRecord.id;
        this.WriteDocLogFieldHolder.domainId = this.SelectedRecord.domainId;
        this.WriteDocLogFieldHolder.tenderLogCode = "76";
        this.WriteDocLogFieldHolder.companyCode = this.SelectedRecord.companyCode;
        this.WriteDocLogFieldHolder.tenderDocumentName = tenderDocumentName;
        this.WriteDocLogFieldHolder.displayName = displayName;
        this.WriteDocLogFieldHolder.invitedCompanyCode = "";
        this.WriteDocLogFieldHolder.createDate = this.bcp.getCurrentDateTime();
        this.WriteDocLogFieldHolder.createUser = this.bcp.getCurrentLoginUser();
        this.stringifyValue = JSON.stringify(this.WriteDocLogFieldHolder);
        this.http.post(this.LogApiPath + "WriteTenderDocLog/", this.stringifyValue, this.bcp.getHttpOptions())
          .subscribe((result: any[]) => {
            //do nothing
          });
      })
  }


  //download attachment for Contractor Document tab by domain user
  downloadResponseDocumentFile(recordID, tenderDocumentName, displayName, invitedCompanyCode) {
    //this.http.get(this.AttachmentApiPath + "File/" + recordID, { 'responseType': 'blob'} )
    this.http.get(this.AttachmentApiPath + "DownloadFile/" + recordID, this.bcp.getHttpOptionsAtt("blob"))
      .catch((err) => { return Observable.throw(err); })
      .subscribe((result: HttpResponse<Blob>) => {
        var returnFilename = this.bcp.getFilenameFromHttpResponse(result.headers.get('content-disposition'));

        if (window.navigator.msSaveOrOpenBlob) { // for IE and Edge
          var blob = new Blob([result.body]);
          window.navigator.msSaveOrOpenBlob(blob, returnFilename);
        } else {
          var a = document.createElement("a");
          var blob = new Blob([result.body]);
          a.href = URL.createObjectURL(result.body);
          a.download = returnFilename;
          a.click();
        }
        // write tender doc log
        this.WriteDocLogFieldHolder = JSON.parse('{"id": 0}');
        this.WriteDocLogFieldHolder.recordId = this.SelectedRecord.id;
        this.WriteDocLogFieldHolder.domainId = this.SelectedRecord.domainId;
        this.WriteDocLogFieldHolder.tenderLogCode = "76";
        this.WriteDocLogFieldHolder.companyCode = this.SelectedRecord.companyCode;
        this.WriteDocLogFieldHolder.tenderDocumentName = tenderDocumentName;
        this.WriteDocLogFieldHolder.displayName = displayName;
        this.WriteDocLogFieldHolder.invitedCompanyCode = invitedCompanyCode;
        this.WriteDocLogFieldHolder.createDate = this.bcp.getCurrentDateTime();
        this.WriteDocLogFieldHolder.createUser = this.bcp.getCurrentLoginUser();
        this.stringifyValue = JSON.stringify(this.WriteDocLogFieldHolder);
        this.http.post(this.LogApiPath + "WriteTenderDocLog/", this.stringifyValue, this.bcp.getHttpOptions())
          .subscribe((result: any[]) => {
            //do nothing
          });
      })
  }


  //Delete the attachment for Documents tab (obsolete)
  deleteAttachment(recordID, documentRecordID) {
    this.confirmationService.confirm({
      message: 'Are you sure that you want to delete attachment?',
      accept: () => {
        this.http.delete(this.DocumentApiPath + documentRecordID, this.bcp.getHttpOptions())
          .subscribe((result: any) => {
            this.getDocumentDataByTender(this.SelectedRecord.domainId, this.inputDocumentCompany, this.SelectedRecord.tenderId);
            if (recordID > 0) {
              this.http.delete(this.AttachmentApiPath + "DeleteFile/"  + recordID, this.bcp.getHttpOptions())
                .subscribe((result: any) => {
                  this.resultMsgs = [{ severity: 'info', summary: 'Confirmed', detail: 'File deleted successfully' }];
                  //refresh table
                  this.getSpecificationDataByTender(this.SelectedRecord.domainId, this.inputDocumentCompany, this.SelectedRecord.tenderId);
                });
            } else {
              this.getSpecificationDataByTender(this.SelectedRecord.domainId, this.inputDocumentCompany, this.SelectedRecord.tenderId);
            }
          });
      },
      reject: () => {
        //Do Nothing
      }
    });
  }


  //Delete the attachment for Documents tab
  deleteDocumentAttachment(recordID, documentRecordID,tenderDocumentName,displayName) {
    this.confirmationService.confirm({
      message: 'Are you sure that you want to delete attachment?',
      accept: () => {
        this.http.delete(this.DocumentApiPath + documentRecordID, this.bcp.getHttpOptions())
          .subscribe((result: any) => {
            this.getDocumentDataByTender(this.SelectedRecord.domainId, this.inputDocumentCompany, this.SelectedRecord.tenderId);
            if (recordID > 0) {
              this.http.delete(this.AttachmentApiPath + "DeleteFile/" + recordID, this.bcp.getHttpOptions())
                .subscribe((result: any) => {
                  this.resultMsgs = [{ severity: 'info', summary: 'Confirmed', detail: 'File deleted successfully' }];
                  // write tender doc log
                  this.WriteDocLogFieldHolder = JSON.parse('{"id": 0}');
                  this.WriteDocLogFieldHolder.recordId = this.SelectedRecord.id;
                  this.WriteDocLogFieldHolder.domainId = this.SelectedRecord.domainId;
                  this.WriteDocLogFieldHolder.tenderLogCode = "74";
                  this.WriteDocLogFieldHolder.companyCode = this.SelectedRecord.companyCode;
                  this.WriteDocLogFieldHolder.tenderDocumentName = tenderDocumentName;
                  this.WriteDocLogFieldHolder.displayName = displayName;
                  this.WriteDocLogFieldHolder.invitedCompanyCode = "";
                  this.WriteDocLogFieldHolder.createDate = this.bcp.getCurrentDateTime();
                  this.WriteDocLogFieldHolder.createUser = this.bcp.getCurrentLoginUser();
                  this.stringifyValue = JSON.stringify(this.WriteDocLogFieldHolder);
                  this.http.post(this.LogApiPath + "WriteTenderDocLog/", this.stringifyValue, this.bcp.getHttpOptions())
                    .subscribe((result: any[]) => {
                      //do nothing
                    });
                  //refresh table
                  this.getSpecificationDataByTender(this.SelectedRecord.domainId, this.inputDocumentCompany, this.SelectedRecord.tenderId);
                });
            } else {
              this.getSpecificationDataByTender(this.SelectedRecord.domainId, this.inputDocumentCompany, this.SelectedRecord.tenderId);
            }
          });
      },
      reject: () => {
        //Do Nothing
      }
    });
  }


  //Delete the attachment for Response tab
  deleteResponseDocAttachment(recordID,tenderDocumentName,displayName) {
    this.confirmationService.confirm({
      message: 'Are you sure that you want to delete attachment?',
      accept: () => {
        this.http.delete(this.AttachmentApiPath + "DeleteFile/"  + recordID, this.bcp.getHttpOptions())
          .subscribe((result: any) => {
            this.resultMsgs = [{ severity: 'info', summary: 'Confirmed', detail: 'File deleted successfully' }];
            // write tender doc log
            this.WriteDocLogFieldHolder = JSON.parse('{"id": 0}');
            this.WriteDocLogFieldHolder.recordId = this.SelectedRecord.id;
            this.WriteDocLogFieldHolder.domainId = this.SelectedRecord.domainId;
            this.WriteDocLogFieldHolder.tenderLogCode = "74";
            this.WriteDocLogFieldHolder.companyCode = this.SelectedRecord.companyCode;
            this.WriteDocLogFieldHolder.tenderDocumentName = tenderDocumentName;
            this.WriteDocLogFieldHolder.displayName = displayName;
            this.WriteDocLogFieldHolder.invitedCompanyCode = "";
            this.WriteDocLogFieldHolder.createDate = this.bcp.getCurrentDateTime();
            this.WriteDocLogFieldHolder.createUser = this.bcp.getCurrentLoginUser();
            this.stringifyValue = JSON.stringify(this.WriteDocLogFieldHolder);
            this.http.post(this.LogApiPath + "WriteTenderDocLog/", this.stringifyValue, this.bcp.getHttpOptions())
              .subscribe((result: any[]) => {
                //do nothing
              });
            //refresh response document table
            this.getResponseDocDataByTender(this.SelectedRecord.domainId, this.SelectedRecord.companyCode, this.SelectedRecord.tenderId, this.SelectedRecord.id);
          });
      },
      reject: () => {
        //Do Nothing
      }
    });
  }


  //Delete the withdraw attachment for Contractor tab
  deleteWithdrawAttachment(recordID, sourceRecordId, invitedCompanyCode: any) {
    this.confirmationService.confirm({
      message: 'Are you sure that you want to delete withdraw letter?',
      accept: () => {
        this.http.delete(this.AttachmentApiPath + "DeleteFile/" + recordID, this.bcp.getHttpOptions())
          .subscribe((result: any) => {
            this.resultMsgs = [{ severity: 'info', summary: 'Confirmed', detail: 'File deleted successfully' }];
            //remove withdraw flag
            this.WithdrawTenderFieldHolder = null;
            this.WithdrawTenderFieldHolder = JSON.parse('{"id": 0}');
            this.WithdrawTenderFieldHolder.id = sourceRecordId;
            this.WithdrawTenderFieldHolder.withdrawUser = this.bcp.getCurrentLoginUser();
            this.WithdrawTenderFieldHolder.withdrawDate = this.bcp.getCurrentDateTime();
            this.WithdrawTenderFieldHolder.reverseFlag = 'R';
            this.stringifyValue = JSON.stringify(this.WithdrawTenderFieldHolder);
            this.http.put(this.InvitationApiPath + "WithdrawTender/", this.stringifyValue, this.bcp.getHttpOptions())
              .subscribe((result: any[]) => {
                //refresh price summy
                this.GenPriceSummary = JSON.parse('{"id": 0}');
                this.GenPriceSummary.domainId = this.SelectedRecord.domainId;
                this.GenPriceSummary.tenderId = this.SelectedRecord.tenderId;
                this.GenPriceSummary.createUser = this.bcp.getCurrentLoginUser();
                this.GenPriceSummary.createDate = this.bcp.getCurrentDateTime();
                this.stringifyValue = JSON.stringify(this.GenPriceSummary);
                this.http.post(this.PrimaryApiPath + "GenPriceSummary/", this.stringifyValue, this.bcp.getHttpOptions())
                  .subscribe((result: any[]) => {
                    //do nothing
                  });
                // write tender log
                this.WriteLogFieldHolder = JSON.parse('{"id": 0}');
                this.WriteLogFieldHolder.recordId = this.SelectedRecord.id;
                this.WriteLogFieldHolder.domainId = this.SelectedRecord.domainId;
                this.WriteLogFieldHolder.tenderLogCode = "42";
                this.WriteLogFieldHolder.companyCode = invitedCompanyCode;
                this.WriteLogFieldHolder.createDate = this.bcp.getCurrentDateTime();
                this.WriteLogFieldHolder.createUser = this.bcp.getCurrentLoginUser();
                this.stringifyValue = JSON.stringify(this.WriteLogFieldHolder);
                this.http.post(this.LogApiPath + "WriteTenderLog/", this.stringifyValue, this.bcp.getHttpOptions())
                  .subscribe((result: any[]) => {
                    this.getLogDataByTender(this.SelectedRecord.domainId, this.inputLogCompany, this.SelectedRecord.tenderId);
                  });
                //reload data for Invitation tab
                this.getInvitationDataByTender(this.SelectedRecord.domainId, this.SelectedRecord.companyCode, this.SelectedRecord.tenderId);
                this.getCompanyListResponsed(this.SelectedRecord.domainId, this.SelectedRecord.tenderId);
              });
          });
      },
      reject: () => {
        //Do Nothing
      }
    });
  }


  //Delete the attachment for Award tab
  deleteDeclineLetter(recordID) {
    this.confirmationService.confirm({
      message: 'Are you sure that you want to remove Decline Letter?',
      accept: () => {
        this.http.delete(this.AttachmentApiPath + "DeleteFile/" + recordID, this.bcp.getHttpOptions())
          .subscribe((result: any) => {
            this.resultMsgs = [{ severity: 'info', summary: 'Confirmed', detail: 'Letter deleted successfully' }];
            this.DeclineLetterData.declineLetterId = 0;
            this.DeclineLetterData.declineLetterName = "";
          });
      },
      reject: () => {
        //Do Nothing
      }
    });
  }


  //Delete the attachment for Message tab - review message
  deleteMessageReviewAttachment(recordID) {
    this.confirmationService.confirm({
      message: 'Are you sure that you want to delete attachment?',
      accept: () => {
        this.http.delete(this.AttachmentApiPath + "DeleteFile/" + recordID, this.bcp.getHttpOptions())
          .subscribe((result: any) => {
            this.resultMsgs = [{ severity: 'info', summary: 'Confirmed', detail: 'File deleted successfully' }];
            this.getMessageReviewAttachmentList(this.SelectedMessageRecord.id);
          });
      },
      reject: () => {
        //Do Nothing
      }
    });
  }


  //Delete the attachment for Message tab - new message
  deleteMessageNewAttachment(recordID) {
    this.confirmationService.confirm({
      message: 'Are you sure that you want to delete attachment?',
      accept: () => {
        this.http.delete(this.AttachmentApiPath + "DeleteFile/" + recordID, this.bcp.getHttpOptions())
          .subscribe(
            (data: any) => {
              this.getMessageNewAttachmentList(this.SelectedLockRecord.id);
              //refresh message table
              //this.getMessageDataByTender(this.SelectedRecord.domainId, this.inputMessageCompany, this.SelectedRecord.tenderId, this.inputMessageCompany);
            });
      },
      reject: () => {
        //Do Nothing
      }
    });
  }


  //Delete the attachment for Award tab
  deleteAwardAttachment(recordID) {
    this.confirmationService.confirm({
      message: 'Are you sure that you want to delete attachment?',
      accept: () => {
        this.http.delete(this.AttachmentApiPath + "DeleteFile/"  + recordID, this.bcp.getHttpOptions())
          .subscribe((result: any) => {
            this.resultMsgs = [{ severity: 'info', summary: 'Confirmed', detail: 'File deleted successfully' }];
            this.getAttachmentList(recordID);
          });
      },
      reject: () => {
        //Do Nothing
      }
    });
  }


  //Return to Inquiry Form for Save button
  saveThenFindRecord() {
    this.confirmationService.confirm({
      message: 'Are you sure that you want to save this record?',
      accept: () => {
        this.preProcessingAndSave();
      },
      reject: () => {
        //Do Nothing
      }
    });
  }


  //Return to Inquiry Form for Approve Button
  async approveThenFindRecord() {
    //Save and Get Tender Record ID
    this.SelectedRecord.tenderStatus = "OPEN";
    this.SelectedRecord.tenderDate02 = this.bcp.getCurrentDate();
    await this.saveRecord();
    // write tender log
    this.WriteLogFieldHolder = JSON.parse('{"id": 0}');
    this.WriteLogFieldHolder.recordId = this.SelectedRecord.id;
    this.WriteLogFieldHolder.domainId = this.SelectedRecord.domainId;
    this.WriteLogFieldHolder.tenderLogCode = "05";
    this.WriteLogFieldHolder.companyCode = this.SelectedRecord.companyCode;
    this.WriteLogFieldHolder.createDate = this.bcp.getCurrentDateTime();
    this.WriteLogFieldHolder.createUser = this.bcp.getCurrentLoginUser();
    this.stringifyValue = JSON.stringify(this.WriteLogFieldHolder);
    this.http.post(this.LogApiPath + "WriteTenderLog/", this.stringifyValue, this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        //this.getLogDataByTender(this.WriteLogFieldHolder.domainId, this.SelectedRecord.companyCode, this.SelectedRecord.tenderId);
      });
    //generate tender records to invited suppliers
    await this.generateTenderToSuppliers();
    //return to inquiry form
    //this.ShowAddForm = false;
    //this.ShowEditForm = false;
    //this.FormTitle = "Work With Tender Process";
    //this.findRecord();
    //this.close();
  }


  //return to Inquiry from for reject action
  async rejectThenFindRecord() {
    //Save and Get Tender Record ID
    this.SelectedRecord.tenderStatus = "DRAFT";
    await this.saveRecord();
    //return to inquiry form
    //this.ShowAddForm = false;
    //this.ShowEditForm = false;
    //this.FormTitle = "Work With Tender Process";
    //this.findRecord();
    this.close();
  }


  //get attachment list for Award tab
  getAttachmentList(recordID) {
    this.http.get(this.AttachmentApiPath + "List/" + this.bcp.getCurrentDomainId() + "/EtsTender/" + recordID, this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        this.AttachmentList = result;
        this.AttachmentAutoReload = true;
      });
  }


  //get new message attachment list for Award tab
  getMessageNewAttachmentList(recordID) {
    this.http.get(this.AttachmentApiPath + "List/" + this.bcp.getCurrentDomainId() + "/BcpLock/" + recordID, this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        this.MessageNewAttachmentList = result;
        //this.MessageNewAttachmentAutoReload = true;
      });
  }


  //get review message attachment list for Award tab
  getMessageReviewAttachmentList(recordID) {
    this.http.get(this.AttachmentApiPath + "List/" + this.bcp.getCurrentDomainId() + "/EtsMessage/" + recordID, this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        this.MessageReviewAttachmentList = result;
        this.MessageReviewAttachmentAutoReload = true;
      });
  }


  //sorting event trigger, default is sorting by id
  changeSort(event) {
    if (!event.order) {
      this.sortF = 'id';
    } else {
      this.sortF = event.field;
    }
  }

  tenderApprovalRoute() {
    var serviceInput: IDialogApprovalRoute;
    var serviceOutput: IReturnDialogApprovalRoute;

    serviceInput = JSON.parse('{"id": 0}');
    serviceInput.domainId = this.SelectedRecord.domainId;
    serviceInput.actionCode = "TDM6";
    serviceInput.approveData = this.SelectedRecord.tenderId;
    serviceInput.requestDate = this.bcp.getCurrentDateTime();
    serviceInput.routeCode = "0";
    serviceInput.maxApproveLevel = "2";
    serviceInput.copyPreviousApprover = "Y";
    serviceInput.defaultApprover = "0";
    serviceInput.businessUnit = this.SelectedRecord.businessUnit;


    serviceOutput = null;
    this.bcpApprovalRoute.openDialog(serviceInput)
      .subscribe(res => {
        serviceOutput = JSON.parse(JSON.stringify(res));
        //console.log("getting output from approval route");
        //console.log(serviceOutput);
        if (serviceOutput.approvalSubmitted) {
          this.SelectedRecord.tenderStatus = "REVIEW";
          this.preProcessingAndSave();
          //remove record lock
          //this.http.delete(this.LockApiPath + this.SelectedLockRecord.id, this.bcp.getHttpOptions())
          //  .subscribe(
          //    (data: any) => {
          //      //do nothing
          //    });
          //write tender log
          this.WriteLogFieldHolder = JSON.parse('{"id": 0}');
          this.WriteLogFieldHolder.recordId = this.SelectedRecord.id;
          this.WriteLogFieldHolder.domainId = this.SelectedRecord.domainId;
          this.WriteLogFieldHolder.tenderLogCode = "03";
          this.WriteLogFieldHolder.companyCode = this.SelectedRecord.companyCode;
          this.WriteLogFieldHolder.createDate = this.bcp.getCurrentDateTime();
          this.WriteLogFieldHolder.createUser = this.bcp.getCurrentLoginUser();
          this.stringifyValue = JSON.stringify(this.WriteLogFieldHolder);
          this.http.post(this.LogApiPath + "WriteTenderLog/", this.stringifyValue, this.bcp.getHttpOptions())
            .subscribe((result: any[]) => {
              this.getLogDataByTender(this.SelectedRecord.domainId, this.SelectedRecord.companyCode, this.SelectedRecord.tenderId);
            });
        }
      }
      );
  }


  tenderApprovalAction() {
    var serviceInput: IDialogApprovalAction;
    var serviceOutput: IReturnDialogApprovalAction;

    serviceInput = JSON.parse('{"id": 0}');
    serviceInput.domainId = this.SelectedRecord.domainId;
    serviceInput.actionCode = "TDM6";
    serviceInput.approveData = this.SelectedRecord.tenderId;
    serviceInput.requestDate = this.bcp.getCurrentDateTime();
    serviceInput.routeCode = "0";
    serviceInput.approveLevel = "0";
    serviceInput.businessUnit = this.SelectedRecord.businessUnit;

    serviceOutput = null;
    this.bcpApprovalAction.openDialog(serviceInput)
      .subscribe(res => {
        serviceOutput = JSON.parse(JSON.stringify(res));
        console.log("getting output from approval action");
        console.log(serviceOutput);
        if (serviceOutput.finalApprover && serviceOutput.approveAction == "APPROVE") {
          this.approveThenFindRecord();
        } else if (serviceOutput.approveAction == "REJECT") {
          this.rejectThenFindRecord();
        }
      }
      );
  }

  //-----------------------------------------------------------------------------
  //                      Fetch List Data for Drop Down List
  //-----------------------------------------------------------------------------



  //-----------------------------------------------------------------------------
  //                      Email Functions
  //-----------------------------------------------------------------------------

  sendInviteTenderEmail() {
    //this.tenderProcessEmail = {};
    this.tenderProcessEmail.inputDomain = this.SelectedRecord.domainId;
    this.tenderProcessEmail.inputUser = this.bcp.getCurrentLoginUser();
    this.tenderProcessEmail.tenderId = this.SelectedRecord.tenderId;
    this.tenderProcessEmail.tenderSubject = this.SelectedRecord.subject;
    this.tenderProcessEmail.tenderCloseDate = this.bcp.formatDateToDisplayString(this.SelectedRecord.tenderDate03,true,false,"-",":");
    this.stringifyValue = "";
    this.stringifyValue = JSON.stringify(this.tenderProcessEmail);

    this.emailReturnStatus = false;

    this.http.post(this.SendEmailPath + "SendInviteTenderEmail", this.stringifyValue, this.bcp.getHttpOptions())
      .subscribe((result: any) => {
        this.emailReturnStatus = true;
        this.resultMsgs = [{ severity: 'info', summary: 'Confirmed', detail: 'Email had been sent out to contractor user' }];
      },
        (err) => {
          this.emailReturnStatus = false;
          this.resultMsgs = [{ severity: 'info', summary: 'Confirmed', detail: 'Failed to sent out email to contractor user' }];
        });
  }

  sendSubmitResponseEmail() {
    //this.tenderProcessEmail = {};
    this.tenderProcessEmail.inputDomain = this.SelectedRecord.domainId;
    this.tenderProcessEmail.inputUser = this.bcp.getCurrentLoginUser();
    this.tenderProcessEmail.tenderId = this.SelectedRecord.tenderId;
    this.tenderProcessEmail.tenderSubject = this.SelectedRecord.subject;
    //this.tenderProcessEmail.tenderCloseDate = this.bcp.formatDateToDisplayString(this.SelectedRecord.tenderDate03, true, false, "-", ":");
    this.stringifyValue = "";
    this.stringifyValue = JSON.stringify(this.tenderProcessEmail);

    this.emailReturnStatus = false;

    this.http.post(this.SendEmailPath + "SendSubmitResponseEmail", this.stringifyValue, this.bcp.getHttpOptions())
      .subscribe((result: any) => {
        this.emailReturnStatus = true;
        this.resultMsgs = [{ severity: 'info', summary: 'Confirmed', detail: 'Email had been sent out to contractor user' }];
      },
        (err) => {
          this.emailReturnStatus = false;
          this.resultMsgs = [{ severity: 'info', summary: 'Confirmed', detail: 'Failed to sent out email to contractor user' }];
        });
  }

  sendTenderQueryEmail() {
    //this.tenderProcessEmail = {};
    this.tenderProcessEmail.inputDomain = this.SelectedRecord.domainId;
    this.tenderProcessEmail.inputUser = this.bcp.getCurrentLoginUser();
    this.tenderProcessEmail.tenderId = this.SelectedRecord.tenderId;
    this.tenderProcessEmail.tenderSubject = this.SelectedRecord.subject;
    //this.tenderProcessEmail.tenderCloseDate = this.bcp.formatDateToDisplayString(this.SelectedRecord.tenderDate03, true, false, "-", ":");
    this.stringifyValue = "";
    this.stringifyValue = JSON.stringify(this.tenderProcessEmail);

    this.emailReturnStatus = false;

    this.http.post(this.SendEmailPath + "SendTenderQueryEmail", this.stringifyValue, this.bcp.getHttpOptions())
      .subscribe((result: any) => {
        this.emailReturnStatus = true;
        this.resultMsgs = [{ severity: 'info', summary: 'Confirmed', detail: 'Email had been sent out to contractor user' }];
      },
        (err) => {
          this.emailReturnStatus = false;
          this.resultMsgs = [{ severity: 'info', summary: 'Confirmed', detail: 'Failed to sent out email to contractor user' }];
        });
  }

  sendAwardContractorEmail() {
    //this.tenderProcessEmail = {};
    this.tenderProcessEmail.inputDomain = this.SelectedRecord.domainId;
    this.tenderProcessEmail.inputUser = this.bcp.getCurrentLoginUser();
    this.tenderProcessEmail.tenderId = this.SelectedRecord.tenderId;
    this.tenderProcessEmail.tenderSubject = this.SelectedRecord.subject;
    //this.tenderProcessEmail.tenderCloseDate = this.bcp.formatDateToDisplayString(this.SelectedRecord.tenderDate03, true, false, "-", ":");
    this.stringifyValue = "";
    this.stringifyValue = JSON.stringify(this.tenderProcessEmail);

    this.emailReturnStatus = false;

    this.http.post(this.SendEmailPath + "SendAwardContractorEmail", this.stringifyValue, this.bcp.getHttpOptions())
      .subscribe((result: any) => {
        this.emailReturnStatus = true;
        this.resultMsgs = [{ severity: 'info', summary: 'Confirmed', detail: 'Email had been sent out to contractor user' }];
      },
        (err) => {
          this.emailReturnStatus = false;
          this.resultMsgs = [{ severity: 'info', summary: 'Confirmed', detail: 'Failed to sent out email to contractor user' }];
        });
  }

  sendRegretContractorEmail() {
    //this.tenderProcessEmail = {};
    this.tenderProcessEmail.inputDomain = this.SelectedRecord.domainId;
    this.tenderProcessEmail.inputUser = this.bcp.getCurrentLoginUser();
    this.tenderProcessEmail.tenderId = this.SelectedRecord.tenderId;
    this.tenderProcessEmail.tenderSubject = this.SelectedRecord.subject;
    //this.tenderProcessEmail.tenderCloseDate = this.bcp.formatDateToDisplayString(this.SelectedRecord.tenderDate03, true, false, "-", ":");
    this.stringifyValue = "";
    this.stringifyValue = JSON.stringify(this.tenderProcessEmail);

    this.emailReturnStatus = false;

    this.http.post(this.SendEmailPath + "SendRegretContractorEmail", this.stringifyValue, this.bcp.getHttpOptions())
      .subscribe((result: any) => {
        this.emailReturnStatus = true;
        this.resultMsgs = [{ severity: 'info', summary: 'Confirmed', detail: 'Email had been sent out to contractor user' }];
      },
        (err) => {
          this.emailReturnStatus = false;
          this.resultMsgs = [{ severity: 'info', summary: 'Confirmed', detail: 'Failed to sent out email to contractor user' }];
        });
  }

  //-----------------------------------------------------------------------------
  //                      Checking/ Other Actions
  //-----------------------------------------------------------------------------

  clearAllMessage() {
    this.InputErrorMsg = [];
    this.resultMsgs = [];

  }


  clearAwardCompanyCode() {
    this.SelectedRecord.awardCompanyCode = "";
    this.getCompanyListResponsed(this.SelectedRecord.domainId, this.SelectedRecord.tenderId);
  }


  clearAdjustedContractSum() {
    this.SelectedRecord.adjustedContractSum = 0;
    this.SelectedRecord.adjustmentRemark = "";
  }


  async preProcessingAndSave() {
    //clear existing messages
    this.clearAllMessage();
    this.checkedError = 'N';
    //check domain
    if (this.SelectedRecord.domainId.trim() == "") {
      this.checkedError = 'Y';
      this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Domain is missing   ' });
    };
    //check subject
    if (this.SelectedRecord.subject.trim() == "") {
      this.checkedError = 'Y';
      this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Subject is missing   ' });
    };
    //check tender category
    if (this.SelectedRecord.tenderCategory.trim() == "") {
      this.checkedError = 'Y';
      this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Tender Category is missing   ' });
    };
    //check tender property
    if (this.SelectedRecord.tenderProperty.trim() == "") {
      this.checkedError = 'Y';
      this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Tender Property is missing   ' });
    };
    //check business unit
    if (this.SelectedRecord.businessUnit.trim() == "") {
      this.checkedError = 'Y';
      this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Business Unit is missing   ' });
    };
    //check contact person
    if (this.SelectedRecord.fullName.trim() == "") {
      this.checkedError = 'Y';
      this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Contact Person is missing   ' });
    };
    //check open date
    if (this.SelectedRecord.tenderDate02 == "" || this.SelectedRecord.tenderDate02 == null) {
      this.checkedError = 'Y';
      this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Open Date is missing   ' });
    } else {
      if (this.SelectedRecord.tenderDate01 != "" && this.SelectedRecord.tenderDate01 != null && this.bcp.convertCalendarDateToJson(this.SelectedRecord.tenderDate01) > this.bcp.convertCalendarDateToJson(this.SelectedRecord.tenderDate02)) {
        this.checkedError = 'Y';
        this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Open Date should be later than Issue Date   ' });
      }
    };
    //check due date
    if (this.SelectedRecord.tenderDate03 == "" || this.SelectedRecord.tenderDate03 == null) {
      this.checkedError = 'Y';
      this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Due Date is missing   ' });
    } else {
      if (this.bcp.convertCalendarDateToJson(this.SelectedRecord.tenderDate02) >= this.bcp.convertCalendarDateToJson(this.SelectedRecord.tenderDate03)) {
        this.checkedError = 'Y';
        this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Due Date should be later than Open Date   ' });
      }
    };
    //check due date time
    if (this.SelectedRecord.tenderDate03 != "" && this.bcp.convertCalendarDateTimeToJson(this.SelectedRecord.tenderDate03).substring(11, 19)!="12:00:00") {
      this.checkedError = 'Y';
      this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Due Date Time must be at 12:00   ' });
    }
    //check award date
    if (this.SelectedRecord.tenderDate04 != "" && this.SelectedRecord.tenderDate04 != null && this.bcp.convertCalendarDateToJson(this.SelectedRecord.tenderDate03) > this.bcp.convertCalendarDateToJson(this.SelectedRecord.tenderDate04)) {
      this.checkedError = 'Y';
      this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Award Date should be later than Due Date   ' });
    }
    //check price validity date
    if (this.SelectedRecord.priceValidityDate == "" || this.SelectedRecord.priceValidityDate == null) {
      this.checkedError = 'Y';
      this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Price Validity Date is missing   ' });
    } else {
      if (this.bcp.convertCalendarDateToJson(this.SelectedRecord.tenderDate03) >= this.bcp.convertCalendarDateToJson(this.SelectedRecord.priceValidityDate)) {
        this.checkedError = 'Y';
        this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Price Validity Date should be later than Due Date   ' });
      }
    };
    //check price table
    if (this.PriceRecordList.length > 0) {
      this.sortPriceTable(this.PriceRecordList);
      var prePart: string = "";
      var preSection: number = 0;
      for (var i = 0; i < this.PriceRecordList.length; i++) {
        if ((this.PriceRecordList[i].part != "" && this.PriceRecordList[i].part != null) || (this.PriceRecordList[i].section != "" && this.PriceRecordList[i].section != null)
          || (this.PriceRecordList[i].longDescription != "" && this.PriceRecordList[i].longDescription != null)) {
          if (this.PriceRecordList[i].part == "" || this.PriceRecordList[i].part == null) {
            this.checkedError = 'Y';
            this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Part Number in Tender Items table is missing   ' });
          }
          if (this.PriceRecordList[i].longDescription == "" || this.PriceRecordList[i].longDescription == null) {
            this.checkedError = 'Y';
            this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Description in Tender Items table is missing   ' });
          }
          if (this.PriceRecordList[i].section == null) {
            this.PriceRecordList[i].section = 0;
          }
          if (this.PriceRecordList[i].section > 0) {
            if (this.PriceRecordList[i].quantityTendered == "" || this.PriceRecordList[i].quantityTendered == null || this.PriceRecordList[i].quantityTendered == 0) {
              this.checkedError = 'Y';
              this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Quantity must not be zero   ' });
            }
          }
          if (this.PriceRecordList[i].part.length != 0 || this.PriceRecordList[i].section > 0) {
            if (this.PriceRecordList[i].part == prePart && this.PriceRecordList[i].section == preSection) {
              this.checkedError = 'Y';
              this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Part/Section Number in Tender Items table is duplicated   ' });
            }
            prePart = this.PriceRecordList[i].part;
            preSection = this.PriceRecordList[i].section;
          }
        }
      }
    }
    //check invitation table
    if (this.InvitationRecordList.length>0) {
      this.InvitationRecordList.sort((a, b) => (a.fullName > b.fullName ? 1 : -1));
      var preFullName: string = "";
      for (var i = 0; i < this.InvitationRecordList.length; i++) {
        if (this.InvitationRecordList[i].fullName != "" && this.InvitationRecordList[i].fullName != null) {
          if (this.InvitationRecordList[i].fullName == preFullName) {
            this.checkedError = 'Y';
            this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Invited Company in Contractor table is duplicated   ' });
          }
          preFullName = this.InvitationRecordList[i].fullName;
        }
      }
    }
    //check document table
    if (this.ShowEditForm) {
      if (this.DocumentRecordList.length > 0) {
        for (var i = 0; i < this.DocumentRecordList.length; i++) {
          if (this.DocumentRecordList[i].id != 0) {
            if (this.DocumentRecordList[i].tenderDocumentName == "" || this.DocumentRecordList[i].tenderDocumentName == null) {
              this.checkedError = 'Y';
              this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Document Name in Contractor Document table is missing   ' });
            }
          } else {
            if (this.DocumentRecordList[i].tenderDocumentName == "" || this.DocumentRecordList[i].tenderDocumentName == null) {
              if (this.DocumentRecordList[i].remark != "" && this.DocumentRecordList[i].remark != null) {
                this.checkedError = 'Y';
                this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Document Name in Contractor Document table is missing   ' });
              }
            }
          }
        }
      }
    }

    //assign default and check unique if above checking passed
    if (this.checkedError == 'N') {
      if (this.SelectedRecord.tenderId.trim() == "") {
        if (this.SelectedRecord.tenderProperty == "TSM") {
          await this.genNextNumber(this.SelectedRecord.domainId, 'TD01', this.bcp.getCurrentDateTime());
        } else if (this.SelectedRecord.tenderProperty == "WCM") {
          await this.genNextNumber(this.SelectedRecord.domainId, 'TD02', this.bcp.getCurrentDateTime());
        }
        if (this.NextNumberOutput.nextKey == "NOT_FOUND") {
          this.checkedError = 'Y';
          this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Default Next Number is not setup   ' });
        } else if (this.NextNumberOutput.nextKey == "MAX_NUMBER") {
          this.checkedError = 'Y';
          this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Maximum Next Number is reached   ' });
        } else {
          this.SelectedRecord.tenderId = this.NextNumberOutput.nextKey;
        }
      };
    }

    //check unique if above checking passed
    if (this.checkedError == 'N') {
      let tmpApiString1: string = "";
      tmpApiString1 = JSON.stringify(this.SelectedRecord);
      //console.log("sstring is" + tmpApiString1);
      let checkResult1 = await this.http.post(this.PrimaryApiPath + "ValidateKeyFields/", tmpApiString1, this.bcp.getHttpOptions())
        .map((response: any) => JSON.parse(response.toString())).toPromise();
      if (checkResult1.validFlag == "N") {
        this.checkedError = 'Y';
        this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Tender Id is duplicated   ' });
      }
    };

    //save record finally if no error
    if (this.checkedError == 'N') {
      //Save and Get Tender Record ID
      await this.saveRecord();
      this.newTenderRecordId = await this.http.get(this.PrimaryApiPath + "GetID/" + this.SelectedRecord.domainId + "/" + this.SelectedRecord.companyCode + "/" + this.SelectedRecord.tenderId, this.bcp.getHttpOptions()).toPromise();
      if (this.SelectedRecord.id == 0) {
        // write tender log
        this.WriteLogFieldHolder = JSON.parse('{"id": 0}');
        this.WriteLogFieldHolder.recordId = this.newTenderRecordId;
        this.WriteLogFieldHolder.domainId = this.SelectedRecord.domainId;
        this.WriteLogFieldHolder.tenderLogCode = "00";
        this.WriteLogFieldHolder.companyCode = this.SelectedRecord.companyCode;
        this.WriteLogFieldHolder.createDate = this.bcp.getCurrentDateTime();
        this.WriteLogFieldHolder.createUser = this.bcp.getCurrentLoginUser();
        this.stringifyValue = JSON.stringify(this.WriteLogFieldHolder);
        this.http.post(this.LogApiPath + "WriteTenderLog/", this.stringifyValue, this.bcp.getHttpOptions())
          .subscribe((result: any[]) => {
            //this.getLogDataByTender(this.WriteLogFieldHolder.domainId, this.WriteLogFieldHolder.companyCode, this.SelectedRecord.tenderId);
          });
        //bring new tender Id back to global filter 1
        this.globalFilterValue1 = this.SelectedRecord.tenderId;
      }
      //process tag table
      this.processPriceTable();
      this.processInvitationTable();
      if (this.ShowEditForm) {
        this.processSpecificationTable();
        this.processDocumentTable();
      };
      //control process flow
      //this.ShowAddForm = false;
      //this.ShowEditForm = false;
      //this.FormTitle = "Work With Tender Process";
      //this.findRecord();
      this.close();
    };

  }


  //getNextNumber for new contact record
  async genNextNumber(domainId: string, tableKey: string, inputDate: any) {
    this.NextNumberOutput = null;
    this.NextNumberOutput = JSON.parse('{"id": 0}');
    this.GenNextNumberFieldHolder = null;
    this.GenNextNumberFieldHolder = JSON.parse('{"id": 0}');
    this.GenNextNumberFieldHolder.domainId = domainId;
    this.GenNextNumberFieldHolder.tableKey = tableKey;
    this.GenNextNumberFieldHolder.inputDate = inputDate;
    this.GenNextNumberFieldHolder.updateUser = this.bcp.getCurrentLoginUser();
    this.GenNextNumberFieldHolder.updateDate = this.bcp.getCurrentDateTime();
    this.stringifyValue = JSON.stringify(this.GenNextNumberFieldHolder);
    //console.log("FieldHolder is " + this.stringifyValue);
    this.NextNumberOutput = await this.http.post(this.TableSequenceApiPath + "GenNextNumber/", this.stringifyValue, this.bcp.getHttpOptions())
      .map((response: any) => JSON.parse(response.toString())).toPromise();
    //console.log("NextNumberOutput is " + this.NextNumberOutput);
    //console.log("nextKey is " + this.NextNumberOutput.nextKey);
  }


  mergeStatus(companyCode: Array<string>, status: Array<string>) {
    for (var i = 0; i < 15; i++) {
      if (companyCode[i] != "" && companyCode[i] != null) {
        companyCode[i] = companyCode[i] + " (" + status[i] + ")";
      }
    }
  }


  reduceMinAmount(origAmount: Array<number>, minAmount: number) {
    for (var i = 0; i < 15; i++) {
      if (origAmount[i]>0) {
        origAmount[i] = origAmount[i] - minAmount;
      }
    }
  }


  calculatePercent(origAmount: Array<number>, minAmount: number) {
    for (var i = 0; i < 15; i++) {
      if (origAmount[i] > 0) {
        origAmount[i] = origAmount[i] / minAmount * 100;
      }
    }
  }


  sortPriceTable(inputList: ITenderPrice[]) {
    var result: ITenderPrice[];
    result = inputList.sort((a, b) => (a.part.localeCompare(b.part) || a.section - b.section));
    return result;
  }


  //-----------------------------------------------------------------------------
  //                            Report
  //-----------------------------------------------------------------------------

  async printPriceSummary() {

    let fileReader = new FileReader();
    let strLine: string;
    const url = "https://sheetjs.com/data/executive.json";
    var tmpStr: string;

    //get the tender data
    this.processingReport = "PriceSummary";
    this.processingFlag = "Y";
    this.ReportFieldHolder = null;
    this.ReportFieldHolder = JSON.parse('{"id": 0}');
    this.ReportFieldHolder.domainId = this.SelectedRecord.domainId;
    this.ReportFieldHolder.tenderId = this.SelectedRecord.tenderId;
    this.ReportFieldHolder.dataType = "H";
    this.stringifyValue = JSON.stringify(this.ReportFieldHolder);
    let headerList = await this.http.post(this.ReportApiPath + "Rpt_PriceSummary", this.stringifyValue, this.bcp.getHttpOptions())
      .map((response: any[]) => response).toPromise();
    this.ReportFieldHolder = null;
    this.ReportFieldHolder = JSON.parse('{"id": 0}');
    this.ReportFieldHolder.domainId = this.SelectedRecord.domainId;
    this.ReportFieldHolder.tenderId = this.SelectedRecord.tenderId;
    this.ReportFieldHolder.dataType = "D";
    this.stringifyValue = JSON.stringify(this.ReportFieldHolder);
    let detailList = await this.http.post(this.ReportApiPath + "Rpt_PriceSummary", this.stringifyValue, this.bcp.getHttpOptions())
      .map((response: any[]) => response).toPromise();

    //initial the worksheet and workbook
    this.strLine = "";
    this.updateExcelRow();
    let worksheet = XLSX.utils.json_to_sheet(this.excelRow, { header: [""], skipHeader: true });
    let workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "TenderAnalysis");

    //Header Fields
    if (1 == 1) {
      //output the data
      this.strLine = "Tender Summary Report";
      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

      this.strLine = " ";
      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

      this.strLine = "For Tender " + this.ReportFieldHolder["tenderId"];
      this.strLine = this.strLine.replace(/,/gi, this.delimiter);
      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

      this.strLine = " ";
      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

      this.strLine = "Print Date: , " + this.bcp.getCurrentDate();
      this.strLine = this.strLine.replace(/,/gi, this.delimiter);
      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

      this.strLine = " ";
      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

      //this.strLine = "Part, Section, Description";
      //this.strLine = this.strLine.replace(/,/gi, this.delimiter);
      //this.updateExcelRow();
      //XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });
    }
    
    for (var i = 0; i < headerList.length; i++) {
      //write heading title line
      this.strLine = "";
      //tmpStr = this.bcp.convertDateTimetoDate(recordList[i].InactiveDate) == "1900-01-01" ? this.bcp.convertDateTimetoDate(recordList[i].InactiveDate) : "";
      this.strLine = "Part, Section, Description, Optional,";
      this.strLine = this.strLine.replace(/,/gi, this.delimiter);
      this.strLine = this.strLine + headerList[i].fullName01
        + this.delimiter + headerList[i].fullName02
        + this.delimiter + headerList[i].fullName03
        + this.delimiter + headerList[i].fullName04
        + this.delimiter + headerList[i].fullName05
        + this.delimiter + headerList[i].fullName06
        + this.delimiter + headerList[i].fullName07
        + this.delimiter + headerList[i].fullName08
        + this.delimiter + headerList[i].fullName09
        + this.delimiter + headerList[i].fullName10
        + this.delimiter + headerList[i].fullName11
        + this.delimiter + headerList[i].fullName12
        + this.delimiter + headerList[i].fullName13
        + this.delimiter + headerList[i].fullName14
        + this.delimiter + headerList[i].fullName15;
        //+ this.delimiter + tmpStr;
      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });
      //write heading company code line
      let tmpa: Array<string>;
      tmpa = [headerList[i].companyCode01, headerList[i].companyCode02, headerList[i].companyCode03,
        headerList[i].companyCode04, headerList[i].companyCode05, headerList[i].companyCode06,
        headerList[i].companyCode07, headerList[i].companyCode08, headerList[i].companyCode09,
        headerList[i].companyCode10, headerList[i].companyCode11, headerList[i].companyCode12,
        headerList[i].companyCode13, headerList[i].companyCode14, headerList[i].companyCode15];
      let tmpb: Array<string>;
      tmpb = [headerList[i].tenderResponseStatus01, headerList[i].tenderResponseStatus02, headerList[i].tenderResponseStatus03,
        headerList[i].tenderResponseStatus04, headerList[i].tenderResponseStatus05, headerList[i].tenderResponseStatus06,
        headerList[i].tenderResponseStatus07, headerList[i].tenderResponseStatus08, headerList[i].tenderResponseStatus09,
        headerList[i].tenderResponseStatus10, headerList[i].tenderResponseStatus11, headerList[i].tenderResponseStatus12,
        headerList[i].tenderResponseStatus13, headerList[i].tenderResponseStatus14, headerList[i].tenderResponseStatus15];
      this.mergeStatus(tmpa, tmpb);
      this.strLine = "";
      this.strLine = " , , , ,";
      this.strLine = this.strLine.replace(/,/gi, this.delimiter);
      this.strLine = this.strLine + tmpa[0]
        + this.delimiter + tmpa[1]
        + this.delimiter + tmpa[2]
        + this.delimiter + tmpa[3]
        + this.delimiter + tmpa[4]
        + this.delimiter + tmpa[5]
        + this.delimiter + tmpa[6]
        + this.delimiter + tmpa[7]
        + this.delimiter + tmpa[8]
        + this.delimiter + tmpa[9]
        + this.delimiter + tmpa[10]
        + this.delimiter + tmpa[11]
        + this.delimiter + tmpa[12]
        + this.delimiter + tmpa[13]
        + this.delimiter + tmpa[14];
      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });
    }
    //write detail lines
    let hLines: number;
    hLines = 10;
    this.cellList = [];
    for (var i = 0; i < detailList.length; i++) {
      //set background colour for lowest value
      if (detailList[i].section>0) {
        if (detailList[i].lineAmount01 > 0 && detailList[i].lineAmount01 == detailList[i].minLineAmount) {
          this.addRangeToCellList("E", hLines + i, "E", hLines + i, true);
        }
        if (detailList[i].lineAmount02 > 0 && detailList[i].lineAmount02 == detailList[i].minLineAmount) {
          this.addRangeToCellList("F", hLines + i, "F", hLines + i, true);
        }
        if (detailList[i].lineAmount03 > 0 && detailList[i].lineAmount03 == detailList[i].minLineAmount) {
          this.addRangeToCellList("G", hLines + i, "G", hLines + i, true);
        }
        if (detailList[i].lineAmount04 > 0 && detailList[i].lineAmount04 == detailList[i].minLineAmount) {
          this.addRangeToCellList("H", hLines + i, "H", hLines + i, true);
        }
        if (detailList[i].lineAmount05 > 0 && detailList[i].lineAmount05 == detailList[i].minLineAmount) {
          this.addRangeToCellList("I", hLines + i, "I", hLines + i, true);
        }
        if (detailList[i].lineAmount06 > 0 && detailList[i].lineAmount06 == detailList[i].minLineAmount) {
          this.addRangeToCellList("J", hLines + i, "J", hLines + i, true);
        }
        if (detailList[i].lineAmount07 > 0 && detailList[i].lineAmount07 == detailList[i].minLineAmount) {
          this.addRangeToCellList("K", hLines + i, "K", hLines + i, true);
        }
        if (detailList[i].lineAmount08 > 0 && detailList[i].lineAmount08 == detailList[i].minLineAmount) {
          this.addRangeToCellList("L", hLines + i, "L", hLines + i, true);
        }
        if (detailList[i].lineAmount09 > 0 && detailList[i].lineAmount09 == detailList[i].minLineAmount) {
          this.addRangeToCellList("M", hLines + i, "M", hLines + i, true);
        }
        if (detailList[i].lineAmount10 > 0 && detailList[i].lineAmount10 == detailList[i].minLineAmount) {
          this.addRangeToCellList("N", hLines + i, "N", hLines + i, true);
        }
        if (detailList[i].lineAmount11 > 0 && detailList[i].lineAmount11 == detailList[i].minLineAmount) {
          this.addRangeToCellList("O", hLines + i, "O", hLines + i, true);
        }
        if (detailList[i].lineAmount12 > 0 && detailList[i].lineAmount12 == detailList[i].minLineAmount) {
          this.addRangeToCellList("P", hLines + i, "P", hLines + i, true);
        }
        if (detailList[i].lineAmount13 > 0 && detailList[i].lineAmount13 == detailList[i].minLineAmount) {
          this.addRangeToCellList("Q", hLines + i, "Q", hLines + i, true);
        }
        if (detailList[i].lineAmount14 > 0 && detailList[i].lineAmount14 == detailList[i].minLineAmount) {
          this.addRangeToCellList("R", hLines + i, "R", hLines + i, true);
        }
        if (detailList[i].lineAmount15 > 0 && detailList[i].lineAmount15 == detailList[i].minLineAmount) {
          this.addRangeToCellList("S", hLines + i, "S", hLines + i, true);
        }
      }
      if (detailList[i].section == 0) {
        detailList[i].section = "";
      }
      this.strLine = "";
      //tmpStr = this.bcp.convertDateTimetoDate(recordList[i].InactiveDate) == "1900-01-01" ? this.bcp.convertDateTimetoDate(recordList[i].InactiveDate) : "";
      this.strLine = this.strLine + detailList[i].part
        + this.delimiter + detailList[i].section
        + this.delimiter + detailList[i].longDescription
        + this.delimiter + detailList[i].optionalFlag
        + this.delimiter + detailList[i].lineAmount01
        + this.delimiter + detailList[i].lineAmount02
        + this.delimiter + detailList[i].lineAmount03
        + this.delimiter + detailList[i].lineAmount04
        + this.delimiter + detailList[i].lineAmount05
        + this.delimiter + detailList[i].lineAmount06
        + this.delimiter + detailList[i].lineAmount07
        + this.delimiter + detailList[i].lineAmount08
        + this.delimiter + detailList[i].lineAmount09
        + this.delimiter + detailList[i].lineAmount10
        + this.delimiter + detailList[i].lineAmount11
        + this.delimiter + detailList[i].lineAmount12
        + this.delimiter + detailList[i].lineAmount13
        + this.delimiter + detailList[i].lineAmount14
        + this.delimiter + detailList[i].lineAmount15;
      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });
      //delete cells for formatting
      if (detailList[i].section > 0) {
        delete (worksheet["A" + (hLines + i)]);
      } else {
        if (detailList[i].part == 'TOTAL') {
          delete (worksheet["A" + (hLines + i)]);
          delete (worksheet["B" + (hLines + i)]);
          delete (worksheet["D" + (hLines + i)]);
        }
        if (detailList[i].part == 'TOTAL2') {
          delete (worksheet["A" + (hLines + 2 + i)]);
          delete (worksheet["B" + (hLines + 2 + i)]);
          delete (worksheet["D" + (hLines + 2 + i)]);
        }
      }
      //processing for difference amount and percent after TOTAL line
      if (detailList[i].part == 'TOTAL') {
        //write difference amount
        let tmp1: Array<number>;
        tmp1 = [detailList[i].lineAmount01, detailList[i].lineAmount02, detailList[i].lineAmount03,
          detailList[i].lineAmount04, detailList[i].lineAmount05, detailList[i].lineAmount06,
          detailList[i].lineAmount07, detailList[i].lineAmount08, detailList[i].lineAmount09,
          detailList[i].lineAmount10, detailList[i].lineAmount11, detailList[i].lineAmount12,
          detailList[i].lineAmount13, detailList[i].lineAmount14, detailList[i].lineAmount15];
        let tmp2: number = detailList[i].minLineAmount;
        this.reduceMinAmount(tmp1, tmp2);
        this.strLine = "";
        this.strLine = this.strLine + detailList[i].part
          + this.delimiter + detailList[i].section
          + this.delimiter + "Difference (Amount) to the lowest"
          + this.delimiter + detailList[i].optionalFlag
          + this.delimiter + tmp1[0]
          + this.delimiter + tmp1[1]
          + this.delimiter + tmp1[2]
          + this.delimiter + tmp1[3]
          + this.delimiter + tmp1[4]
          + this.delimiter + tmp1[5]
          + this.delimiter + tmp1[6]
          + this.delimiter + tmp1[7]
          + this.delimiter + tmp1[8]
          + this.delimiter + tmp1[9]
          + this.delimiter + tmp1[10]
          + this.delimiter + tmp1[11]
          + this.delimiter + tmp1[12]
          + this.delimiter + tmp1[13]
          + this.delimiter + tmp1[14];
        this.updateExcelRow();
        XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });
        delete (worksheet["A" + (hLines + 1 + i)]);
        delete (worksheet["B" + (hLines + 1 + i)]);
        delete (worksheet["D" + (hLines + 1 + i)]);
        //write difference percent
        this.calculatePercent(tmp1, tmp2);
        this.strLine = "";
        this.strLine = this.strLine + detailList[i].part
          + this.delimiter + detailList[i].section
          + this.delimiter + "Difference (Percent) to the lowest"
          + this.delimiter + detailList[i].optionalFlag
          + this.delimiter + tmp1[0]
          + this.delimiter + tmp1[1]
          + this.delimiter + tmp1[2]
          + this.delimiter + tmp1[3]
          + this.delimiter + tmp1[4]
          + this.delimiter + tmp1[5]
          + this.delimiter + tmp1[6]
          + this.delimiter + tmp1[7]
          + this.delimiter + tmp1[8]
          + this.delimiter + tmp1[9]
          + this.delimiter + tmp1[10]
          + this.delimiter + tmp1[11]
          + this.delimiter + tmp1[12]
          + this.delimiter + tmp1[13]
          + this.delimiter + tmp1[14];
        this.updateExcelRow();
        XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });
        delete (worksheet["A" + (hLines + 2 + i)]);
        delete (worksheet["B" + (hLines + 2 + i)]);
        delete (worksheet["D" + (hLines + 2 + i)]);
      }
    }
    //highlight lowest price
    this.formatCell(worksheet, this.cellList, "BGCOLOR_01");
    //console.log("cellList is " + this.cellList);

    //total section
    //this.strLine = " ";
    //this.updateExcelRow();
    //XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

    //this.strLine = "No. of Lines: ," + detailList.length;
    //this.strLine = this.strLine.replace(/,/gi, this.delimiter);
    //this.updateExcelRow();
    //XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

    //worksheet["C"+11].s = {
    //  alignment: { vertical: 'middle', wrapText: true }
    //};

    this.fixWidth(worksheet);
    this.applyCellFormat(worksheet);

    //delete (worksheet["H9"])

    XLSX.writeFile(workbook, "Report_PriceSummary.xlsx", { compression: true });
    this.processingFlag = "N";
    this.processingReport = "";
  }


  async printTenderMaster() {

    let fileReader = new FileReader();
    let strLine: string;
    const url = "https://sheetjs.com/data/executive.json";
    var tmpStr: string;
    let hLines = 16;

    this.listLength1 = 0;
    this.listLength2 = 0;
    this.listLength3 = 0;
    this.listLength4 = 0;

    this.processingReport = "TenderMaster";
    this.processingFlag = "Y";
    //get the tender data
    this.ReportFieldHolder = null;
    this.ReportFieldHolder = JSON.parse('{"id": 0}');
    this.ReportFieldHolder.domainId = this.SelectedRecord.domainId;
    this.ReportFieldHolder.tenderId = this.SelectedRecord.tenderId;
    this.ReportFieldHolder.dataType = "T";
    this.stringifyValue = JSON.stringify(this.ReportFieldHolder);
    let reportList = await this.http.post(this.ReportApiPath + "Rpt_TenderMaster", this.stringifyValue, this.bcp.getHttpOptions())
      .map((response: any[]) => response).toPromise();
    this.listLength1 = reportList.length;
    //get the tender item data
    this.ReportFieldHolder = null;
    this.ReportFieldHolder = JSON.parse('{"id": 0}');
    this.ReportFieldHolder.domainId = this.SelectedRecord.domainId;
    this.ReportFieldHolder.tenderId = this.SelectedRecord.tenderId;
    this.ReportFieldHolder.dataType = "P";
    this.stringifyValue = JSON.stringify(this.ReportFieldHolder);
    let itemList = await this.http.post(this.ReportApiPath + "Rpt_TenderMaster", this.stringifyValue, this.bcp.getHttpOptions())
      .map((response: any[]) => response).toPromise();
    this.listLength2 = itemList.length;
    //get the tender document data
    this.ReportFieldHolder = null;
    this.ReportFieldHolder = JSON.parse('{"id": 0}');
    this.ReportFieldHolder.domainId = this.SelectedRecord.domainId;
    this.ReportFieldHolder.tenderId = this.SelectedRecord.tenderId;
    this.ReportFieldHolder.dataType = "D";
    this.stringifyValue = JSON.stringify(this.ReportFieldHolder);
    let documentList = await this.http.post(this.ReportApiPath + "Rpt_TenderMaster", this.stringifyValue, this.bcp.getHttpOptions())
      .map((response: any[]) => response).toPromise();
    this.listLength3 = documentList.length;
    //initial the worksheet and workbook
    this.strLine = "";
    this.updateExcelRow();
    let worksheet = XLSX.utils.json_to_sheet(this.excelRow, { header: [""], skipHeader: true });
    let workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "TenderMaster");

    //Header Fields
    if (1 == 1) {
      //output the data
      this.strLine = "Tender Master Report";
      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

      this.strLine = " ";
      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

      this.strLine = "Tender Id: , " + this.ReportFieldHolder["tenderId"];
      this.strLine = this.strLine.replace(/,/gi, this.delimiter);
      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

      this.strLine = " ";
      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

      this.strLine = "Print Date: , " + this.bcp.getCurrentDate();
      this.strLine = this.strLine.replace(/,/gi, this.delimiter);
      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });
    }
    for (var i = 0; i < reportList.length; i++) {
      //write heading lines
      if (i == 0) {
        this.strLine = "Subject: , " + reportList[i].subject;
        this.strLine = this.strLine.replace(/,/gi, this.delimiter);
        this.updateExcelRow();
        XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

        this.strLine = "Tender Manager: , " + reportList[i].tenderManager
          + " (Email: " + reportList[i].email + " / Tel: " + reportList[i].phone + ")";
        this.strLine = this.strLine.replace(/,/gi, this.delimiter);
        this.updateExcelRow();
        XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

        this.strLine = "Tender Category: , " + reportList[i].tenderCategory;
        this.strLine = this.strLine.replace(/,/gi, this.delimiter);
        this.updateExcelRow();
        XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

        this.strLine = "Business Unit: , " + reportList[i].businessUnit;
        this.strLine = this.strLine.replace(/,/gi, this.delimiter);
        this.updateExcelRow();
        XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

        this.strLine = "Property: , " + reportList[i].tenderProperty;
        this.strLine = this.strLine.replace(/,/gi, this.delimiter);
        this.updateExcelRow();
        XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

        this.strLine = "Open Date: , " + this.bcp.formatDateToDisplayString(reportList[i].tenderDate02,false,false,'-',':');
        this.strLine = this.strLine.replace(/,/gi, this.delimiter);
        this.updateExcelRow();
        XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

        this.strLine = "Due Date: , " + this.bcp.formatDateToDisplayString(reportList[i].tenderDate03, true, false, '-', ':');
        this.strLine = this.strLine.replace(/,/gi, this.delimiter);
        this.updateExcelRow();
        XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

        this.strLine = "Status / Remark: , " + reportList[i].tenderStatus
          + this.delimiter + reportList[i].tenderSummary;
        this.strLine = this.strLine.replace(/,/gi, this.delimiter);
        this.updateExcelRow();
        XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

        this.strLine = " ";
        this.updateExcelRow();
        XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

        //write company header line
        this.strLine = "";
        this.strLine = "Invited Contractor";
        this.strLine = this.strLine.replace(/,/gi, this.delimiter);
        this.updateExcelRow();
        XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });
        this.strLine = "";
        this.strLine = "Company Code, Company Name";
        this.strLine = this.strLine.replace(/,/gi, this.delimiter);
        this.updateExcelRow();
        XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });
      }
      //write company code line
      this.strLine = "";
      this.strLine = this.strLine + reportList[i].invitedCompanyCode
        + this.delimiter + reportList[i].fullName;
      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });
    }
    //write tender item lines
    this.strLine = " ";
    this.updateExcelRow();
    XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });
    this.strLine = "";
    this.strLine = "Tender Item";
    this.strLine = this.strLine.replace(/,/gi, this.delimiter);
    this.updateExcelRow();
    XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });
    this.strLine = "";
    this.strLine = "Part, Section, Description, Unit of Measure, Quantity, Optional";
    this.strLine = this.strLine.replace(/,/gi, this.delimiter);
    this.updateExcelRow();
    XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });
    this.cellList = [];
    for (var i = 0; i < itemList.length; i++) {
      this.strLine = "";
      this.strLine = this.strLine + itemList[i].part
        + this.delimiter + itemList[i].section
        + this.delimiter + itemList[i].longDescription
        + this.delimiter + itemList[i].unitOfMeasure
        + this.delimiter + itemList[i].quantityTendered
        + this.delimiter + itemList[i].optionalFlag;
      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });
      //format part section description
      if (itemList[i].section == 0) {
        delete (worksheet["B" + (hLines + 1 + this.listLength1 + 4 + i)]);
        this.addRangeToCellList("C", (hLines + 1 + this.listLength1 + 4 + i), "C", (hLines + 1 + this.listLength1 + 4 + i), true);
      } else {
        delete (worksheet["A" + (hLines + 1 + this.listLength1 + 4 + i)]);
      }
    }
    this.formatCell(worksheet, this.cellList, "BOLDUNDERLINE");
    //write tender document lines
    this.strLine = " ";
    this.updateExcelRow();
    XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });
    this.strLine = "";
    this.strLine = "Tender Document";
    this.strLine = this.strLine.replace(/,/gi, this.delimiter);
    this.updateExcelRow();
    XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });
    this.strLine = "";
    this.strLine = "Purpose, Document Name, Remark, File Name";
    this.strLine = this.strLine.replace(/,/gi, this.delimiter);
    this.updateExcelRow();
    XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });
    for (var i = 0; i < documentList.length; i++) {
      this.strLine = "";
      if (documentList[i].tenderDocumentType == "SPEC") {
        strLine = "For Download";
      } else {
        strLine = "For Upload";
      }
      this.strLine = this.strLine + strLine
        + this.delimiter + documentList[i].tenderDocumentName
        + this.delimiter + documentList[i].remark
        + this.delimiter + documentList[i].displayName;
      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });
    }
    //total section
    //this.strLine = " ";
    //this.updateExcelRow();
    //XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

    //this.strLine = "No. of Lines: ," + detailList.length;
    //this.strLine = this.strLine.replace(/,/gi, this.delimiter);
    //this.updateExcelRow();
    //XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

    //worksheet["C"+11].s = {
    //  alignment: { vertical: 'middle', wrapText: true }
    //};

    this.fixWidthTenderMaster(worksheet);
    this.applyCellFormatTenderMaster(worksheet);

    XLSX.writeFile(workbook, "Report_TenderMaster.xlsx", { compression: true });
    this.processingFlag = "N";
    this.processingReport = "";
  }


  async printTenderLog() {

    let fileReader = new FileReader();
    let strLine: string;
    const url = "https://sheetjs.com/data/executive.json";
    var tmpStr: string;
    let preCompanyCode: string = "";
    let hLines = 12;

    this.listLength1 = 0;

    this.processingReport = "TenderLog";
    this.processingFlag = "Y";
    //get the tender log data
    this.ReportFieldHolder = null;
    this.ReportFieldHolder = JSON.parse('{"id": 0}');
    this.ReportFieldHolder.domainId = this.SelectedRecord.domainId;
    this.ReportFieldHolder.tenderId = this.SelectedRecord.tenderId;
    this.ReportFieldHolder.dataType = "L";
    this.stringifyValue = JSON.stringify(this.ReportFieldHolder);
    let reportList = await this.http.post(this.ReportApiPath + "Rpt_TenderLog", this.stringifyValue, this.bcp.getHttpOptions())
      .map((response: any[]) => response).toPromise();
    this.listLength1 = reportList.length;
    //initial the worksheet and workbook
    this.strLine = "";
    this.updateExcelRow();
    let worksheet = XLSX.utils.json_to_sheet(this.excelRow, { header: [""], skipHeader: true });
    let workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "TenderLog");

    //Header Fields
    if (1 == 1) {
      //output the data
      this.strLine = "Tender System Log";
      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

      this.strLine = " ";
      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

      this.strLine = "Tender Id: , " + this.ReportFieldHolder["tenderId"];
      this.strLine = this.strLine.replace(/,/gi, this.delimiter);
      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

      this.strLine = " ";
      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

      this.strLine = "Print Date: , " + this.bcp.getCurrentDate();
      this.strLine = this.strLine.replace(/,/gi, this.delimiter);
      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });
    }
    for (var i = 0; i < reportList.length; i++) {
      //write heading lines
      if (i == 0) {
        this.strLine = "Subject: , " + reportList[i].subject;
        this.strLine = this.strLine.replace(/,/gi, this.delimiter);
        this.updateExcelRow();
        XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

        this.strLine = "Tender Manager: , " + reportList[i].tenderManager
          + " (Email: " + reportList[i].email + " / Tel: " + reportList[i].phone + ")";
        this.strLine = this.strLine.replace(/,/gi, this.delimiter);
        this.updateExcelRow();
        XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

        this.strLine = "Business Unit: , " + reportList[i].businessUnit;
        this.strLine = this.strLine.replace(/,/gi, this.delimiter);
        this.updateExcelRow();
        XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

        this.strLine = "Status: , " + reportList[i].tenderStatus;
        this.strLine = this.strLine.replace(/,/gi, this.delimiter);
        this.updateExcelRow();
        XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

        this.strLine = " ";
        this.updateExcelRow();
        XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

        //write log header line
        this.strLine = "";
        this.strLine = "Company Code, Company Name, Action Datetime, Description";
        this.strLine = this.strLine.replace(/,/gi, this.delimiter);
        this.updateExcelRow();
        XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });
      }
      //write company code line
      this.strLine = "";
      this.strLine = this.strLine + reportList[i].companyCode
        + this.delimiter + reportList[i].fullName
        + this.delimiter + this.bcp.formatDateToDisplayString(reportList[i].createDate, true, true, '-', ':')
        + this.delimiter + reportList[i].description;
      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });
      if (reportList[i].companyCode == preCompanyCode) {
        delete (worksheet["A" + (hLines + 1 + i)]);
        delete (worksheet["B" + (hLines + 1 + i)]);
      }
      preCompanyCode = reportList[i].companyCode;
    }
    //total section
    //this.strLine = " ";
    //this.updateExcelRow();
    //XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

    //this.strLine = "No. of Lines: ," + detailList.length;
    //this.strLine = this.strLine.replace(/,/gi, this.delimiter);
    //this.updateExcelRow();
    //XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

    //worksheet["C"+11].s = {
    //  alignment: { vertical: 'middle', wrapText: true }
    //};

    this.fixWidthTenderLog(worksheet);
    this.applyCellFormatTenderLog(worksheet);

    XLSX.writeFile(workbook, "Report_TenderLog.xlsx", { compression: true });
    this.processingFlag = "N";
    this.processingReport = "";
  }


  async printTenderItemPrice() {

    let fileReader = new FileReader();
    let strLine: string;
    const url = "https://sheetjs.com/data/executive.json";
    var tmpStr: string;
    let prePart: string = "";
    let subTotalAmount: number = 0;
    let grandTotalAmount: number = 0;
    let hLines = 14;
    let currentLineNumber = hLines;

    this.listLength1 = 0;

    this.processingReport = "TenderItemPrice";
    this.processingFlag = "Y";
    //get the tender item price data
    this.ReportFieldHolder = null;
    this.ReportFieldHolder = JSON.parse('{"id": 0}');
    this.ReportFieldHolder.domainId = this.SelectedRecord.domainId;
    this.ReportFieldHolder.tenderId = this.SelectedRecord.tenderId;
    this.ReportFieldHolder.companyCode = this.SelectedRecord.companyCode;
    this.ReportFieldHolder.dataType = "P";
    this.stringifyValue = JSON.stringify(this.ReportFieldHolder);
    let reportList = await this.http.post(this.ReportApiPath + "Rpt_TenderItemPrice", this.stringifyValue, this.bcp.getHttpOptions())
      .map((response: any[]) => response).toPromise();
    this.listLength1 = reportList.length;
    //initial the worksheet and workbook
    this.strLine = "";
    this.updateExcelRow();
    let worksheet = XLSX.utils.json_to_sheet(this.excelRow, { header: [""], skipHeader: true });
    let workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "TenderItemPrice");

    //Header Fields
    if (1 == 1) {
      //output the data
      this.strLine = "Tender Item Price By Contractor";
      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

      this.strLine = " ";
      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

      this.strLine = "Tender Id: , , " + this.ReportFieldHolder["tenderId"];
      this.strLine = this.strLine.replace(/,/gi, this.delimiter);
      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

      this.strLine = " ";
      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

      this.strLine = "Print Date: , , " + this.bcp.getCurrentDate();
      this.strLine = this.strLine.replace(/,/gi, this.delimiter);
      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });
    }
    this.cellList = [];
    for (var i = 0; i < reportList.length; i++) {
      //write heading lines
      if (i == 0) {
        this.strLine = "Subject: , , " + reportList[i].subject;
        this.strLine = this.strLine.replace(/,/gi, this.delimiter);
        this.updateExcelRow();
        XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

        this.strLine = "Tender Manager: , , " + reportList[i].tenderManager
          + " (Email: " + reportList[i].email + " / Tel: " + reportList[i].phone + ")";
        this.strLine = this.strLine.replace(/,/gi, this.delimiter);
        this.updateExcelRow();
        XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

        this.strLine = "Property: , , " + reportList[i].tenderProperty;
        this.strLine = this.strLine.replace(/,/gi, this.delimiter);
        this.updateExcelRow();
        XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

        this.strLine = "Business Unit: , , " + reportList[i].businessUnit;
        this.strLine = this.strLine.replace(/,/gi, this.delimiter);
        this.updateExcelRow();
        XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

        this.strLine = "Status: , , " + reportList[i].tenderStatus;
        this.strLine = this.strLine.replace(/,/gi, this.delimiter);
        this.updateExcelRow();
        XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

        this.strLine = "Contractor: , , " + reportList[i].fullName + " [" + reportList[i].companyCode + "]";
        this.strLine = this.strLine.replace(/,/gi, this.delimiter);
        this.updateExcelRow();
        XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

        this.strLine = " ";
        this.updateExcelRow();
        XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

        //write log header line
        this.strLine = "";
        this.strLine = "Part, Section, Description, Quantity, Unit of Measure, Optional, Unit Price, Amount";
        this.strLine = this.strLine.replace(/,/gi, this.delimiter);
        this.updateExcelRow();
        XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

        //merge A2:C2, A4:B4, A5:B5, A6:B6, A7:B7, A8:B8, A9:B9, A10:B10, A11:11, A12:B12,
        const merge = [
          { s: { r: 1, c: 0 }, e: { r: 1, c: 2 } }, { s: { r: 3, c: 0 }, e: { r: 3, c: 1 } }, { s: { r: 4, c: 0 }, e: { r: 4, c: 1 } }, { s: { r: 5, c: 0 }, e: { r: 5, c: 1 } },
          { s: { r: 6, c: 0 }, e: { r: 6, c: 1 } }, { s: { r: 7, c: 0 }, e: { r: 7, c: 1 } }, { s: { r: 8, c: 0 }, e: { r: 8, c: 1 } }, { s: { r: 9, c: 0 }, e: { r: 9, c: 1 } },
          { s: { r: 10, c: 0 }, e: { r: 10, c: 1 } }, { s: { r: 11, c: 0 }, e: { r: 11, c: 1 } },
        ];
        worksheet["!merges"] = merge;
      }
      //print subtotal line
      if (reportList[i].part != prePart && prePart != "") {
        this.strLine = "";
        this.strLine = " , ,Part " + prePart + " Subtotal, , , ,," + subTotalAmount;;
        this.strLine = this.strLine.replace(/,/gi, this.delimiter);
        this.updateExcelRow();
        XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });
        currentLineNumber = currentLineNumber + 1;
        worksheet["C" + currentLineNumber].s = { font: { bold: true } };
        worksheet["H" + currentLineNumber].s = { font: { bold: true } };
        worksheet["H" + currentLineNumber].s = { border: { top: { style: 'thin', color: { rgb: "000000" } } } };
        subTotalAmount = 0;
      }
      //write tender item lines
      this.strLine = "";
      this.strLine = this.strLine + reportList[i].part
        + this.delimiter + reportList[i].section
        + this.delimiter + reportList[i].longDescription
        + this.delimiter + reportList[i].quantityTendered
        + this.delimiter + reportList[i].unitOfMeasure
        + this.delimiter + reportList[i].optionalFlag
        + this.delimiter + reportList[i].unitPrice
        + this.delimiter + reportList[i].lineAmount;
      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });
      currentLineNumber = currentLineNumber + 1;
      //format part section description
      if (reportList[i].section == 0) {
        delete (worksheet["B" + currentLineNumber]);
        //this.addRangeToCellList("C", (hLines + 1 + subTotalLines + i), "C", (hLines + 1 + subTotalLines + i), true);
        this.addRangeToCellList("C", currentLineNumber, "C", currentLineNumber, true);
      } else {
        delete (worksheet["A" + currentLineNumber]);
      }
      //save the last part number and amount
      prePart = reportList[i].part;
      subTotalAmount = subTotalAmount + reportList[i].lineAmount;
      if (reportList[i].optionalFlag != "Y") {
        grandTotalAmount = grandTotalAmount + reportList[i].lineAmount;
      }
    }
    this.formatCell(worksheet, this.cellList, "BOLDUNDERLINE");
    //print last subtotal line
    this.strLine = "";
    this.strLine = " , ,Part " + prePart + " Subtotal, , , ,," + subTotalAmount;
    this.strLine = this.strLine.replace(/,/gi, this.delimiter);
    this.updateExcelRow();
    XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });
    currentLineNumber = currentLineNumber + 1;
    worksheet["C" + currentLineNumber].s = { font: { bold: true } };
    worksheet["H" + currentLineNumber].s = { font: { bold: true } };
    worksheet["H" + currentLineNumber].s = { border: { top: { style: 'thin', color: { rgb: "000000" } } } };
    //print total line
    this.strLine = "";
    this.strLine = " , ,Contract Sum Total, , , ,," + grandTotalAmount;
    this.strLine = this.strLine.replace(/,/gi, this.delimiter);
    this.updateExcelRow();
    XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });
    currentLineNumber = currentLineNumber + 1;
    worksheet["C" + currentLineNumber].s = { font: { bold: true } };
    worksheet["H" + currentLineNumber].s = { font: { bold: true } };
    worksheet["H" + currentLineNumber].s = { border: { top: { style: 'thin', color: { rgb: "000000" } }, bottom: { style: 'double', color: { rgb: "000000" } }  } };
    //worksheet["H" + currentLineNumber].s = { border: { bottom: { style: 'double', color: { rgb: "000000" } } } };

    //total section
    //this.strLine = " ";
    //this.updateExcelRow();
    //XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

    //this.strLine = "No. of Lines: ," + detailList.length;
    //this.strLine = this.strLine.replace(/,/gi, this.delimiter);
    //this.updateExcelRow();
    //XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

    //worksheet["C"+11].s = {
    //  alignment: { vertical: 'middle', wrapText: true }
    //};

    this.fixWidthTenderItemPrice(worksheet);
    this.applyCellFormatTenderItemPrice(worksheet);

    XLSX.writeFile(workbook, "Report_TenderItemPrice.xlsx", { compression: true });
    this.processingFlag = "N";
    this.processingReport = "";
  }


  async printTenderDocumentActivity() {

    let fileReader = new FileReader();
    let strLine: string;
    const url = "https://sheetjs.com/data/executive.json";
    var tmpStr: string;
    let preCompanyCode: string = "";
    let hLines = 11;

    this.listLength1 = 0;

    this.processingReport = "DocumentActivity";
    this.processingFlag = "Y";
    //get the tender log data
    this.ReportFieldHolder = null;
    this.ReportFieldHolder = JSON.parse('{"id": 0}');
    this.ReportFieldHolder.domainId = this.SelectedRecord.domainId;
    this.ReportFieldHolder.tenderId = this.SelectedRecord.tenderId;
    this.ReportFieldHolder.dataType = "L";
    this.stringifyValue = JSON.stringify(this.ReportFieldHolder);
    let reportList = await this.http.post(this.ReportApiPath + "Rpt_DocumentActivity", this.stringifyValue, this.bcp.getHttpOptions())
      .map((response: any[]) => response).toPromise();
    this.listLength1 = reportList.length;
    //initial the worksheet and workbook
    this.strLine = "";
    this.updateExcelRow();
    let worksheet = XLSX.utils.json_to_sheet(this.excelRow, { header: [""], skipHeader: true });
    let workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "DocumentActivity");

    //Header Fields
    if (1 == 1) {
      //output the data
      this.strLine = "Tender Document Activity";
      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

      this.strLine = " ";
      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

      this.strLine = "Tender Id: , " + this.ReportFieldHolder["tenderId"];
      this.strLine = this.strLine.replace(/,/gi, this.delimiter);
      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

      this.strLine = " ";
      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

      this.strLine = "Print Date: , " + this.bcp.getCurrentDate();
      this.strLine = this.strLine.replace(/,/gi, this.delimiter);
      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });
    }
    for (var i = 0; i < reportList.length; i++) {
      //write heading lines
      if (i == 0) {
        this.strLine = "Subject: , " + reportList[i].subject;
        this.strLine = this.strLine.replace(/,/gi, this.delimiter);
        this.updateExcelRow();
        XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

        this.strLine = "Business Unit: , " + reportList[i].businessUnit;
        this.strLine = this.strLine.replace(/,/gi, this.delimiter);
        this.updateExcelRow();
        XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

        this.strLine = "Status: , " + reportList[i].tenderStatus;
        this.strLine = this.strLine.replace(/,/gi, this.delimiter);
        this.updateExcelRow();
        XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

        this.strLine = " ";
        this.updateExcelRow();
        XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

        //write log header line
        this.strLine = "";
        this.strLine = "Company Code, Company Name, Datetime, Document Name, User, File Name, Action";
        this.strLine = this.strLine.replace(/,/gi, this.delimiter);
        this.updateExcelRow();
        XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });
      }
      //write company code line
      tmpStr = "";
      if (reportList[i].tenderLogCode == "72") {
        tmpStr = "Uploaded";
      } else if (reportList[i].tenderLogCode == "74") {
        tmpStr = "Removed";
      } else if (reportList[i].tenderLogCode == "76" && reportList[i].referenceNumber == "") {
        tmpStr = "Downloaded";
      } else if (reportList[i].tenderLogCode == "76" && reportList[i].referenceNumber != "") {
        tmpStr = "Downloaded for " + reportList[i].awardComment;
      }
      this.strLine = "";
      this.strLine = this.strLine + reportList[i].companyCode
        + this.delimiter + reportList[i].fullName
        + this.delimiter + this.bcp.formatDateToDisplayString(reportList[i].createDate, true, true, '-', ':')
        + this.delimiter + reportList[i].title
        + this.delimiter + reportList[i].remark
        + this.delimiter + reportList[i].reason
        + this.delimiter + tmpStr;
      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });
      if (reportList[i].companyCode == preCompanyCode) {
        delete (worksheet["A" + (hLines + 1 + i)]);
        delete (worksheet["B" + (hLines + 1 + i)]);
      }
      preCompanyCode = reportList[i].companyCode;
    }
    //total section
    //this.strLine = " ";
    //this.updateExcelRow();
    //XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

    //this.strLine = "No. of Lines: ," + detailList.length;
    //this.strLine = this.strLine.replace(/,/gi, this.delimiter);
    //this.updateExcelRow();
    //XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });

    //worksheet["C"+11].s = {
    //  alignment: { vertical: 'middle', wrapText: true }
    //};

    this.fixWidthDocumentActivity(worksheet);
    this.applyCellFormatDocumentActivity(worksheet);

    XLSX.writeFile(workbook, "Report_DocumentActivity.xlsx", { compression: true });
    this.processingFlag = "N";
    this.processingReport = "";
  }


  updateExcelRow() {
    const colIndexArray = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"];
    let dataArray: string[];
    this.excelRow = [];
    this.strLine = this.strLine.replace(/undefined/gi, "");
    this.strLine = this.strLine.replace(/Null/gi, "");
    this.strLine = this.strLine.replace(/null/gi, "");
    dataArray = this.strLine.split(this.delimiter);
    for (let index = 0; index < dataArray.length; index += 1) {
      this.excelRow[index] = dataArray[index];
    }
  }


  fixWidth(worksheet: XLSX.WorkSheet) {
    const data = XLSX.utils.sheet_to_json<any>(worksheet)
    const wscols = [
      { width: 10 }, { width: 10 }, { width: 80 }, { width: 10 }, { width: 25 }, //ABCDE
      { width: 25 }, { width: 25 }, { width: 25 }, { width: 25 }, { width: 25 }, //FGHIJ
      { width: 25 }, { width: 25 }, { width: 25 }, { width: 25 }, { width: 25 }, //KLMNO
      { width: 25 }, { width: 25 }, { width: 25 }, { width: 25 },//PQRST
      //UVWXYZ
    ];
    worksheet["!cols"] = wscols;
    this.lastRowNumber = data.length + 1;
  }


  fixWidthTenderMaster(worksheet: XLSX.WorkSheet) {
    const data = XLSX.utils.sheet_to_json<any>(worksheet)
    const wscols = [
      { width: 20 }, { width: 30 }, { width: 80 }, { width: 20 }, { width: 15 }, //ABCDE
      { width: 15 }, { width: 25 }, { width: 25 }, { width: 25 }, { width: 25 }, //FGHIJ
      { width: 25 }, { width: 25 }, { width: 25 }, { width: 25 }, { width: 25 }, //KLMNO
      { width: 25 }, { width: 25 }, { width: 25 }, { width: 25 },//PQRST
      //UVWXYZ
    ];
    worksheet["!cols"] = wscols;
    this.lastRowNumber = data.length + 1;
  }


  fixWidthTenderLog(worksheet: XLSX.WorkSheet) {
    const data = XLSX.utils.sheet_to_json<any>(worksheet)
    const wscols = [
      { width: 20 }, { width: 50 }, { width: 20 }, { width: 80 }, { width: 15 }, //ABCDE
      { width: 15 }, { width: 25 }, { width: 25 }, { width: 25 }, { width: 25 }, //FGHIJ
      { width: 25 }, { width: 25 }, { width: 25 }, { width: 25 }, { width: 25 }, //KLMNO
      { width: 25 }, { width: 25 }, { width: 25 }, { width: 25 },//PQRST
      //UVWXYZ
    ];
    worksheet["!cols"] = wscols;
    this.lastRowNumber = data.length + 1;
  }


  fixWidthTenderItemPrice(worksheet: XLSX.WorkSheet) {
    const data = XLSX.utils.sheet_to_json<any>(worksheet)
    const wscols = [
      { width: 8 }, { width: 10 }, { width: 80 }, { width: 12 }, { width: 16 }, //ABCDE
      { width: 12 }, { width: 15 }, { width: 15 }, { width: 25 }, { width: 25 }, //FGHIJ
      { width: 25 }, { width: 25 }, { width: 25 }, { width: 25 }, { width: 25 }, //KLMNO
      { width: 25 }, { width: 25 }, { width: 25 }, { width: 25 },//PQRST
      //UVWXYZ
    ];
    worksheet["!cols"] = wscols;
    this.lastRowNumber = data.length + 1;
  }


  fixWidthDocumentActivity(worksheet: XLSX.WorkSheet) {
    const data = XLSX.utils.sheet_to_json<any>(worksheet)
    const wscols = [
      { width: 20 }, { width: 50 }, { width: 20 }, { width: 35 }, { width: 30 }, //ABCDE
      { width: 30 }, { width: 80 }, { width: 25 }, { width: 25 }, { width: 25 }, //FGHIJ
      { width: 25 }, { width: 25 }, { width: 25 }, { width: 25 }, { width: 25 }, //KLMNO
      { width: 25 }, { width: 25 }, { width: 25 }, { width: 25 },//PQRST
      //UVWXYZ
    ];
    worksheet["!cols"] = wscols;
    this.lastRowNumber = data.length + 1;
  }


  applyCellFormat(worksheet: XLSX.WorkSheet) {

    //Format Cell as Bold with Border
    let tmpList = [];
    this.cellList = [];

    //bold
    this.addRangeToCellList("A", 2, "S", 9, true);
    this.formatCell(worksheet, this.cellList, "BOLD");

    //bgcolor
    this.cellList = [];
    //this.addRangeToCellList("A", 1, "W", 1, true);
    //this.formatCell(worksheet, this.cellList, "BGCOLOR_01");

    //border
    this.cellList = [];
    this.addRangeToCellList("A", 8, "S", this.lastRowNumber, true);
    this.formatCell(worksheet, this.cellList, "BORDER");

    //wraptext
    this.cellList = [];
    this.addRangeToCellList("C", 10, "C", this.lastRowNumber, true);
    this.formatCell(worksheet, this.cellList, "WRAPTEXT");

    //worksheet["C13"].s = {
    //  alignment: { vertical: 'middle', wrapText: true }
    //};

    //amount with 2dp
    //aware if any space before the cell value
    //tmpList = ["D11"];
    this.cellList = [];
    this.addRangeToCellList("E", 11, "S", this.lastRowNumber, true);
    this.formatCell(worksheet, this.cellList, "AMOUNT");

    //Number in 2dp
    tmpList = [""];
    //this.addListToCellList(tmpList, false);
    //this.formatCell(worksheet, this.cellList, "NUMBER");

    //percent in 2dp
    tmpList = [""];
    //this.formatCell(worksheet, this.cellList, "PERCENT");

  };


  applyCellFormatTenderMaster(worksheet: XLSX.WorkSheet) {

    //Format Cell as Bold with Border
    let tmpList = [];
    this.cellList = [];
    let headingLines = 16;

    //bold
    //first column until contractor heading title
    this.addRangeToCellList("A", 2, "A", headingLines, true);
    //tender id line
    this.addRangeToCellList("A", 4, "B", 4, true);
    //contractor heading line
    this.addRangeToCellList("A", headingLines + 1, "B", headingLines + 1, true);
    //tender item heading line
    this.addRangeToCellList("A", headingLines + 1 + this.listLength1 + 2, "F", headingLines + 1 + this.listLength1 + 3, true);
    //tender document heading line
    this.addRangeToCellList("A", headingLines + 1 + this.listLength1 + 3 + this.listLength2 + 2, "F", headingLines + 1 + this.listLength1 + 3 + this.listLength2 + 3, true);
    this.formatCell(worksheet, this.cellList, "BOLD");

    //bgcolor
    this.cellList = [];
    this.addRangeToCellList("A", 4, "B", 4, true);
    this.formatCell(worksheet, this.cellList, "BGCOLOR_01");

    //border
    this.cellList = [];
    //tender Id
    this.addRangeToCellList("A", 4, "B", 4, true);
    //invited contractor title
    this.addRangeToCellList("A", headingLines + 1, "B", headingLines + 1, true);
    //tender item title
    this.addRangeToCellList("A", headingLines + 1 + this.listLength1 + 3, "F", headingLines + 1 + this.listLength1 + 3, true);
    //tender document title
    this.addRangeToCellList("A", headingLines + 1 + this.listLength1 + 3 + this.listLength2 + 3, "D", headingLines + 1 + this.listLength1 + 3 + this.listLength2 + 3, true);
    this.formatCell(worksheet, this.cellList, "BORDER");

    //wraptext
    this.cellList = [];
    this.addRangeToCellList("C", 14, "C", 14, true);
    this.addRangeToCellList("C", headingLines + 1 + this.listLength1 + 4, "C", headingLines + 1 + this.listLength1 + 4 + this.listLength2, true);
    this.formatCell(worksheet, this.cellList, "WRAPTEXT");

    //worksheet["C13"].s = {
    //  alignment: { vertical: 'middle', wrapText: true }
    //};

    //amount with 2dp
    //aware if any space before the cell value
    //tmpList = ["D11"];
    this.cellList = [];
    //this.addRangeToCellList("E", 11, "S", this.lastRowNumber, true);
    //this.formatCell(worksheet, this.cellList, "AMOUNT");

    //Number in 2dp
    tmpList = [""];
    //this.addListToCellList(tmpList, false);
    //this.formatCell(worksheet, this.cellList, "NUMBER");

    //percent in 2dp
    tmpList = [""];
    //this.formatCell(worksheet, this.cellList, "PERCENT");

  };


  applyCellFormatTenderLog(worksheet: XLSX.WorkSheet) {

    //Format Cell as Bold with Border
    let tmpList = [];
    this.cellList = [];
    let hLines = 12;

    //bold
    //first column until heading title
    this.addRangeToCellList("A", 2, "A", hLines, true);
    //tender id line
    this.addRangeToCellList("A", 4, "B", 4, true);
    //log heading line
    this.addRangeToCellList("A", hLines, "D", hLines, true);
    this.formatCell(worksheet, this.cellList, "BOLD");

    //bgcolor
    this.cellList = [];
    this.addRangeToCellList("A", 4, "B", 4, true);
    this.formatCell(worksheet, this.cellList, "BGCOLOR_01");

    //border
    this.cellList = [];
    //tender Id
    this.addRangeToCellList("A", 4, "B", 4, true);
    //log title
    this.addRangeToCellList("A", hLines, "D", hLines, true);
    this.formatCell(worksheet, this.cellList, "BORDER");

    //wraptext
    this.cellList = [];
    //this.addRangeToCellList("C", 14, "C", 14, true);
    //this.formatCell(worksheet, this.cellList, "WRAPTEXT");

    //worksheet["C13"].s = {
    //  alignment: { vertical: 'middle', wrapText: true }
    //};

    //amount with 2dp
    //aware if any space before the cell value
    //tmpList = ["D11"];
    this.cellList = [];
    //this.addRangeToCellList("E", 11, "S", this.lastRowNumber, true);
    //this.formatCell(worksheet, this.cellList, "AMOUNT");

    //Number in 2dp
    tmpList = [""];
    //this.addListToCellList(tmpList, false);
    //this.formatCell(worksheet, this.cellList, "NUMBER");

    //percent in 2dp
    tmpList = [""];
    //this.formatCell(worksheet, this.cellList, "PERCENT");

  };


  applyCellFormatTenderItemPrice(worksheet: XLSX.WorkSheet) {

    //Format Cell as Bold with Border
    let tmpList = [];
    this.cellList = [];
    let hLines = 14;

    //bold
    //first column until heading title
    this.addRangeToCellList("A", 2, "A", hLines, true);
    //tender id line
    this.addRangeToCellList("A", 4, "B", 4, true);
    //heading line
    this.addRangeToCellList("A", hLines, "H", hLines, true);
    this.formatCell(worksheet, this.cellList, "BOLD");

    //bgcolor
    this.cellList = [];
    this.addRangeToCellList("A", 4, "D", 4, true);
    this.formatCell(worksheet, this.cellList, "BGCOLOR_01");

    //border
    this.cellList = [];
    //tender Id
    this.addRangeToCellList("A", 4, "D", 4, true);
    //log title
    this.addRangeToCellList("A", hLines, "H", hLines, true);
    this.formatCell(worksheet, this.cellList, "BORDER");

    //wraptext
    this.cellList = [];
    this.addRangeToCellList("C", hLines + 1, "C", this.lastRowNumber, true);
    this.formatCell(worksheet, this.cellList, "WRAPTEXT");

    //worksheet["C13"].s = {
    //  alignment: { vertical: 'middle', wrapText: true }
    //};

    //amount with 2dp
    //aware if any space before the cell value
    //tmpList = ["D11"];
    this.cellList = [];
    this.addRangeToCellList("G", hLines + 1, "H", this.lastRowNumber, true);
    this.formatCell(worksheet, this.cellList, "AMOUNT");

    //Number in 2dp
    tmpList = [""];
    //this.addListToCellList(tmpList, false);
    //this.formatCell(worksheet, this.cellList, "NUMBER");

    //percent in 2dp
    tmpList = [""];
    //this.formatCell(worksheet, this.cellList, "PERCENT");

  };


  applyCellFormatDocumentActivity(worksheet: XLSX.WorkSheet) {

    //Format Cell as Bold with Border
    let tmpList = [];
    this.cellList = [];
    let hLines = 11;

    //bold
    //first column until heading title
    this.addRangeToCellList("A", 2, "A", hLines, true);
    //tender id line
    this.addRangeToCellList("A", 4, "B", 4, true);
    //log heading line
    this.addRangeToCellList("A", hLines, "G", hLines, true);
    this.formatCell(worksheet, this.cellList, "BOLD");

    //bgcolor
    this.cellList = [];
    this.addRangeToCellList("A", 4, "B", 4, true);
    this.formatCell(worksheet, this.cellList, "BGCOLOR_01");

    //border
    this.cellList = [];
    //tender Id
    this.addRangeToCellList("A", 4, "B", 4, true);
    //log title
    this.addRangeToCellList("A", hLines, "G", hLines, true);
    this.formatCell(worksheet, this.cellList, "BORDER");

    //wraptext
    this.cellList = [];
    //this.addRangeToCellList("C", 14, "C", 14, true);
    //this.formatCell(worksheet, this.cellList, "WRAPTEXT");

    //worksheet["C13"].s = {
    //  alignment: { vertical: 'middle', wrapText: true }
    //};

    //amount with 2dp
    //aware if any space before the cell value
    //tmpList = ["D11"];
    this.cellList = [];
    //this.addRangeToCellList("E", 11, "S", this.lastRowNumber, true);
    //this.formatCell(worksheet, this.cellList, "AMOUNT");

    //Number in 2dp
    tmpList = [""];
    //this.addListToCellList(tmpList, false);
    //this.formatCell(worksheet, this.cellList, "NUMBER");

    //percent in 2dp
    tmpList = [""];
    //this.formatCell(worksheet, this.cellList, "PERCENT");

  };


  colIndexToChar(colIndex) {
    let result: string = "";
    let adjustFlag = (colIndex - (Math.floor(colIndex / 26) * 26)) === 0 ? 1 : 0; // for AZ/BZ ... handling

    if (colIndex <= 26) {
      result = String.fromCharCode(colIndex + 64);
    } else {
      result = String.fromCharCode(Math.floor((colIndex - adjustFlag) / 26) + 64); //assume max column is ZZ
      result = result + String.fromCharCode(colIndex - (Math.floor((colIndex - adjustFlag) / 26) * 26) + 64);
    }
    return result;
  }


  charToColIndex(colName) {
    let result = 0;
    if (colName.length == 1) {
      result = colName.charCodeAt(0) - 64
    } else {
      result = (colName[0].charCodeAt(0) - 64) * 26;
      result = result + colName[1].charCodeAt(0) - 64;
    }
    return result;
  }


  addListToCellList(extraList: string[], appendFlag) {
    if (!appendFlag || this.cellList == null || this.cellList == undefined) {
      this.cellList = [];
    }
    this.cellList = this.cellList.concat(extraList);
  }


  addRangeToCellList(startCol, startRow, endCol, endRow, appendFlag) {
    let startColIndex = this.charToColIndex(startCol);
    let endColIndex = this.charToColIndex(endCol);
    let currCell: string;
    if (!appendFlag || this.cellList == null || this.cellList == undefined) {
      this.cellList = [];
    }

    for (let c = startColIndex; c <= endColIndex; c++) {
      for (let r = startRow; r <= endRow; r++) {
        this.cellList.push(this.colIndexToChar(c) + r);
      }

    }
  }


  formatCell(worksheet: XLSX.WorkSheet, localCellList: string[]
    , formatRule: string) {

    let defaultStyle = {
      font: {
        bold: false,
        italic: false,
        underline: false
      },
      border: {
        top: { style: "none", color: { auto: 1 } },
        right: { style: "none", color: { auto: 1 } },
        bottom: { style: "none", color: { auto: 1 } },
        left: { style: "none", color: { auto: 1 } }
      },
      alignment: {
        wrapText: false
      }
    };

    let newStyle = JSON.parse(JSON.stringify(defaultStyle));
    let originalStyle = JSON.parse(JSON.stringify(defaultStyle));

    const fontSetting01 = {
      bold: true,
      italic: false,
      underline: false
    };

    const fontSetting02 = {
      bold: true,
      italic: false,
      underline: true
    };

    const borderSetting01 = {
      top: { style: "thin", color: { auto: 1 } },
      right: { style: "thin", color: { auto: 1 } },
      bottom: { style: "thin", color: { auto: 1 } },
      left: { style: "thin", color: { auto: 1 } }
    };

    const bgcolorSetting01 = {
      patternType: "solid",
      //fgColor: { rgb: "e6f7eb" }
      fgColor: { rgb: "f7f372" }
    }

    for (let i = 0; i < localCellList.length; i++) {
      //cache the original style of the cell

      if (worksheet[localCellList[i]] !== undefined) {
        if (formatRule === "BOLD" || formatRule === "BORDER"
          || formatRule === "BGCOLOR_01" || formatRule === "WRAPTEXT"
          || formatRule === "BOLDUNDERLINE") {
          newStyle = JSON.parse(JSON.stringify(defaultStyle));
          originalStyle = JSON.parse(JSON.stringify(defaultStyle));
          if (worksheet[localCellList[i]].s !== undefined) {
            originalStyle = JSON.parse(JSON.stringify(worksheet[localCellList[i]].s));
          }

          if (originalStyle.font !== undefined) {
            newStyle.font = originalStyle.font;
          }
          if (originalStyle.border !== undefined) {
            newStyle.border = originalStyle.border;
          }
          if (originalStyle.fill !== undefined) {
            newStyle.fill = originalStyle.fill;
          }

          if (formatRule === "BOLD") {
            newStyle.font = fontSetting01;
          }

          if (formatRule === "BOLDUNDERLINE") {
            newStyle.font = fontSetting02;
          }

          if (formatRule === "BORDER") {
            newStyle.border = borderSetting01;
          }

          if (formatRule === "BGCOLOR_01") {
            newStyle.fill = bgcolorSetting01;
          }

          if (formatRule === "WRAPTEXT") {
            newStyle.alignment = { wrapText: true };
          }

          worksheet[localCellList[i]].s = newStyle;
        }

        if (formatRule === "AMOUNT") {
          worksheet[localCellList[i]].t = "n"; //  change format
          worksheet[localCellList[i]].z = "_($* #,##0.00_);_($* (#,##0.00);_($* -??_);_(@_)";
        }

        if (formatRule === "NUMBER") {
          worksheet[localCellList[i]].t = "n"; //  change format
          worksheet[localCellList[i]].z = "0.00";
        }

        if (formatRule === "NUMBER_4DP") {
          worksheet[localCellList[i]].t = "n"; //  change format
          worksheet[localCellList[i]].z = "0.0000";
        }

        if (formatRule === "PERCENT") {
          worksheet[localCellList[i]].t = "n"; //  change format
          worksheet[localCellList[i]].z = "0.00%";
        }
      } else {
        //console.log("Error when Formatting Cell " + localCellList[i]);
      }
    }



  }//formatCell end

  //------Import Excel File-----
  //when select file button clicked then display selected file name
  selectImportFile(event) {
     
    this.importFile = event.target.files[0];
    this.processImportFile();

    console.log(this.PriceRecordList);
  }

  //reset import file name to let user re-upload file with same file name
  resetInputFile(event) {
    event.target.value = "";
  }

  //when 'upload and validate' button clicked
  processImportFile() {
    console.log("processing");
    let fileReader = new FileReader();
    //set file reader definition
    fileReader.onload = (e) => {
      this.arrayBuffer = fileReader.result;
      var data = new Uint8Array(this.arrayBuffer);
      var arr = new Array();
      for (var i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
      var bstr = arr.join("");
      var workbook = XLSX.read(bstr, { type: "binary" });
      var first_sheet_name = workbook.SheetNames[0];
      var worksheet = workbook.Sheets[first_sheet_name];

      this.importData = XLSX.utils.sheet_to_json(worksheet, { raw: true });

      if (this.importData.length > 1) {
        this.PriceRecordList = [];

      }

      //process every row - Convert Data
      for (var i = 0; i < this.importData.length; i++) {

        //Convert Excel date format to useable date format
        //if (this.importData[i].Issue_Date != null) {
        //  var importIssueDate = this.ExcelDateToJSDate(this.importData[i].Issue_Date);
        //  var formattedIssueDate = importIssueDate
        //  this.importData[i]. = formattedIssueDate;
        //}
        var blankRow: ITenderPrice;
        blankRow = null;
        blankRow = JSON.parse('{"id":0}');
        blankRow.part = this.importData[i].Part;
        blankRow.section = this.importData[i].Section === undefined ? '' : this.importData[i].Section;
        blankRow.longDescription = this.importData[i].Description;
        blankRow.quantityTendered = this.importData[i].Qty === undefined ? '' : this.importData[i].Qty;
        blankRow.unitOfMeasure = this.importData[i].UOM === undefined ? '' : this.importData[i].UOM;
        blankRow.optionalFlag = this.importData[i].Optional === undefined ? '' : this.importData[i].Optional;
        blankRow.unitPrice = "";
        blankRow.lineAmount = "";
        //clone the whole array to a tmpArray and add new blank row
        const tmpArray = [...this.PriceRecordList];
        tmpArray.push(blankRow);
        this.PriceRecordList = tmpArray;
      }
      this.sortPriceTable(this.PriceRecordList);
      console.log(this.PriceRecordList);
    }
    fileReader.readAsArrayBuffer(this.importFile);
  }

  ExcelDateToJSDate(serial) {
    var utc_days = Math.floor(serial - 25569);
    var utc_value = utc_days * 86400;
    var date_info = new Date(utc_value * 1000);

    var fractional_day = serial - Math.floor(serial) + 0.0000001;
    var total_seconds = Math.floor(86400 * fractional_day);
    var seconds = total_seconds % 60;
    total_seconds -= seconds;
    var hours = Math.floor(total_seconds / (60 * 60));
    var minutes = Math.floor(total_seconds / 60) % 60;

    var formatDate = new Date(date_info.getFullYear(), date_info.getMonth(), date_info.getDate(), hours, minutes, seconds);

    var jsonDate = new Date(formatDate.getTime() + 28800 * 1000).toJSON().slice(0, 10);
    return jsonDate;
  }
  //------Import Excel File Ended-----


  //ending of export class
  //class ended
}


interface ITender {
  id?;
  domainId?;
  companyCode?;
  tenderId?;
  subject?;
  tenderCategory?;
  tenderProperty?;
  businessUnit?;
  estimatedBudget?;
  fullName?;
  fullNameOther?;
  phoneArea?;
  phone?;
  email?;
  tenderStatus?;
  tenderSummary?;
  tenderDate01?;
  tenderDate02?;
  tenderDate03?;
  tenderDate04?;
  tenderDate05?;
  tenderDate06?;
  tenderDate07?;
  tenderDate08?;
  tenderDate09?;
  tenderDate10?;
  tenderDate11?;
  tenderDate12?;
  purchaseNumber?;
  priceValidityMonths?;
  priceValidityDate?;
  retentionPercent?;
  liquidatedDamages?;
  defectsLiabilityPeriod?;
  approveUser?;
  approveDate?;
  tenderResponseStatus?;
  expressInterest?;
  expressUser?;
  expressDate?;
  tenderResponseType?;
  tenderRevisionType?;
  remark?;
  title?;
  contractSum?;
  includeOptionalFlag?;
  adjustedContractSum?;
  adjustmentRemark?;
  withdrawFlag?;
  withdrawUser?;
  withdrawDate?;
  controlFlag01?;
  controlFlag02?;
  controlFlag03?;
  responseUser?;
  responseDate?;
  acceptAward?;
  reason?;
  acceptUser?;
  acceptDate?;
  successAward?;
  awardCompanyCode?;
  awardComment?;
  createUser?;
  createDate?;
  updateUser?;
  updateDate?;
  // not database field
  createUserName?;
}


interface ITenderLock {
  id?;
  domainId?;
  sourceTableName?;
  sourceRecordId?;
  fullName?;
  updateUser?;
  updateDate?;
}


interface ITenderPrice {
  id?;
  domainId?;
  companyCode?;
  tenderId?;
  part?;
  section?;
  subSection?;
  inventoryItem?;
  accountNumber?;
  longDescription?;
  lineDescription01?;
  lineDescription02?;
  quantityTendered?;
  quantityOffered?;
  unitOfMeasure?;
  unitPrice?;
  lineAmount?;
  currencyCode?;
  unitPriceCurrency?;
  lineAmountCurrency?;
  tenderRecordId?;
  mandatoryFlag?;
  optionalFlag?;
  displaySequence?;
  accountCostCenter?;
  accountObject?;
  accountSubsidiary?;
  createUser?;
  createDate?;
  updateUser?;
  updateDate?;
}

interface ITenderInvitation {
  id?;
  domainId?;
  companyCode?;
  tenderId?;
  invitedCompanyCode?;
  companyNumber?;
  generationFlag?;
  withdrawFlag?;
  withdrawUser?;
  withdrawDate?;
  remark?;
  reason?;
  activeFlag?;
  controlFlag01?;
  controlFlag02?;
  controlFlag03?;
  tenderRecordId?;
  createUser?;
  createDate?;
  generationUser?;
  generationDate?;
  updateUser?;
  updateDate?;
  // not database field
  tenderResponseStatus?;
  contractSum?;
  companyTenderRecordId?;
  fullName?;
  actualFileName?;
  displayName?;
  attachmentRecordId?;
}

interface ITenderDocument {
  id?;
  domainId?;
  companyCode?;
  tenderId?;
  tenderDocumentType?;
  lineId?;
  tenderDocumentName?;
  tenderDocumentCategory?;
  documentNumber?;
  documentIssuedDate?;
  documentExpiryDate?;
  remark?;
  instructionText?;
  mandatoryFlag?;
  optionalFlag?;
  displaySequence?;
  requestUploadFlag?;
  tenderRecordId?;
  createUser?;
  createDate?;
  uploadUser?;
  uploadDate?;
  downloadUser?;
  downloadDate?;
  updateUser?;
  updateDate?;
  // not database field
  actualFileName?;
  displayName?;
  attachmentRecordId?;
}

interface ITenderMessage {
  id?;
  domainId?;
  companyCode?;
  tenderId?;
  invitedCompanyCode?;
  createDate?;
  createUser?;
  messageId?;
  messageStatus?;
  approveUser?;
  approveDate?;
  subject?;
  contentBody?;
  allowReply?;
  replyBody?;
  deadline?;
  loginId?;
  email?;
  emailSent?;
  readFlag?;
  tenderRecordId?;
  replyUser?;
  replyDate?;
  updateUser?;
  updateDate?;
  // not database field
  replyUserName?;
}

interface ITenderLog {
  id?;
  domainId?;
  companyCode?;
  tenderId?;
  createDate?;
  createUser?;
  tenderLogCode?;
  description?;
  expressInterest?;
  tenderResponseType?;
  tenderRevisionType?;
  remark?;
  title?;
  contractSum?;
  successAward?;
  awardCompanyCode?;
  awardComment?;
  acceptAward?;
  reason?;
  referenceNumber?;
  tenderRecordId?;
}

interface ICopyTender {
  domainId?;
  tenderId?;
  recordId?;
  invitedCompanyCode?;
  createUser?;
  createDate?;
}

interface IGenPriceSummary {
  domainId?;
  tenderId?;
  createUser?;
  createDate?;
}

interface IConvertProject {
  domainId?;
  companyCode?;
  projectId?;
  recordId?;
  createUser?;
  createDate?;
}

interface ICopyAttachment {
  domainId?;
  fromSourceTableName?;
  fromSourceRecordId?;
  toSourceTableName?;
  toSourceRecordId?;
  createUser?;
  createDate?;
}

interface IUpdateTender {
  domainId?;
  tenderId?;
}

interface IAwardTender {
  domainId?;
  companyCode?;
  tenderId?;
  successAward?;
  awardCompanyCode?;
}


interface IWriteLog {
  recordId?;
  domainId?;
  tenderLogCode?;
  companyCode?;
  createUser?;
  createDate?;
}


interface IWriteDocLog {
  recordId?;
  domainId?;
  tenderLogCode?;
  companyCode?;
  tenderDocumentName?;
  displayName?;
  invitedCompanyCode?;
  createUser?;
  createDate?;
}


interface IWithdrawTender {
  id?;
  withdrawUser?;
  withdrawDate?;
  reverseFlag?;
}



interface ICompanyData {
  companyCode?;
  fullName?;
  companyNumber?;
}

interface IUserName {
  userName?;
  userNameOther?;
  userNameLong?;
  email1?;
  phone1?;
  email1Iv?;
  email1Salt?;
  email1Hash?;
  phone1Iv?;
  phone1Salt?;
}

interface IDeclineLetter {
  declineLetterId?;
  declineLetterName?;
}

interface IDataRole {
}

interface IProcessRole {
}

interface IListValue {
  label?;
  value?;
}

interface IAttachmentValue {
  filePath?;
  id?;
  domainId?;
  sourceTable?;
  sourceRecordId?;
  actualFileName?;
  displayName?;
  createDate?;
  updateUser?;
  updateDate?;
}

interface SelectItem {
}

interface Message {
}


interface IGenNextNumber {
  domainId?;
  tableKey?;
  year?;
  inputDate?;
  updateUser?;
  updateDate?;
}


interface INextNumber {
  nextNumber?;
  nextKey?;
}

interface ICompanyStatus {
  vertificationKey?;
  registerFlag?;
  inviteFlag?;
  tempCompany?;
  companyStatus?;
}

interface ITenderProcessEmail {
  inputDomain?;
  inputUser?;
  companyCode?;
  tenderId?;
  tenderSubject?;
  tenderCloseDate?;
  messageSubject?;
  messageBody?;
  messageId?;
  tenderResponseStatus?;
  tenderResponseUser?;
  tenderResponseDate?;
}

interface IPriceSummary {
  domainId?;
  tenderId?;
  companyCode?;
  dataType?;
}
